import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  es: {
    app_name: "We Speak Spanish",
    tagline: "Plataforma de gestión escolar",
    login_title: "Bienvenido",
    login_subtitle: "Inicia sesión para acceder a tu panel",
    login_google: "Iniciar sesión con Google",
    logout: "Cerrar sesión",
    dashboard: "Panel",
    sedes: "Sedes",
    programs: "Programas",
    mail_center: "Centro de correos",
    users: "Usuarios",
    teachers: "Profesores",
    students: "Estudiantes",
    groups: "Grupos",
    payments: "Pagos",
    journal: "Bitácora",
    attendance: "Asistencia",
    my_attendance: "Mi asistencia",
    my_payments: "Mis pagos",
    overview: "Resumen",
    create: "Crear",
    save: "Guardar",
    cancel: "Cancelar",
    change: "Cambiar",
    edit: "Editar",
    delete: "Eliminar",
    confirm: "Confirmar",
    name: "Nombre",
    email: "Correo",
    role: "Rol",
    address: "Dirección",
    description: "Descripción",
    price: "Precio",
    duration_months: "Duración (meses)",
    classes_included: "Clases incluidas",
    classes_consumed: "Clases tomadas",
    classes_progress: "Progreso de clases",
    invoice_sent: "Factura enviada",
    invoices_sent: "Facturas enviadas",
    run_billing: "Ejecutar facturación",
    run_billing_desc: "Procesa facturas de ciclos completados y envía recordatorios pendientes.",
    billing_done: "Facturación procesada",
    weekly_summary: "Enviar resumen semanal",
    weekly_summary_done: "Resumen enviado a",
    weekly_summary_desc: "Envío automático cada lunes; puedes dispararlo manualmente cuando quieras.",
    cycle: "Ciclo",
    sede: "Sede",
    program: "Programa",
    teacher: "Profesor",
    student: "Estudiante",
    academic_director: "Dirección Académica",
    is_private: "Privado",
    schedule: "Horario",
    schedule_days: "Días",
    schedule_time: "Hora",
    start_time: "Inicio",
    end_time: "Fin",
    start_date: "Fecha de inicio",
    start_date_hint: "Marca el inicio del ciclo. Déjalo en blanco si aún no sabes cuándo empezará — el correo dirá que el horario está pendiente. Si el programa tiene precio, se crea automáticamente un pago pendiente con vencimiento en esta fecha.",
    edit_start_date: "Editar fecha de inicio",
    no_start_date: "Sin fecha de inicio",
    invite_user: "Invitar usuario",
    invite_teacher: "Invitar profesor",
    invite_student: "Invitar estudiante",
    or: "o",
    magic_link_send: "Enviarme un enlace de acceso",
    magic_link_hint: "Usa el correo con el que fuiste registrado en la plataforma.",
    login_receive_code_btn: "Recibir código de acceso por correo",
    login_or_other_method: "o elige otro método",
    login_magic_link_btn: "Enlace mágico por correo",
    login_code_sent_intro: "Enviamos un código de 6 dígitos a",
    login_code_sent_hint: "Ingrésalo aquí para acceder:",
    login_submit_code_btn: "Acceder con el código",
    login_code_not_received: "¿No lo recibiste?",
    login_retry: "Reintentar",
    login_check_your_email: "Revisa tu correo",
    login_link_sent_intro: "Enviamos un enlace de acceso a",
    login_link_sent_hint: "Ábrelo desde el mismo dispositivo para entrar. Si no llega en 2 minutos, revisa tu carpeta de spam.",
    login_back: "← Volver",
    login_invalid_code: "Código inválido o vencido",
    login_code_must_be_6: "El código debe tener 6 dígitos",
    login_code_check_email: "Revisa tu correo para el código",
    magic_link_resend: "Reenviar enlace",
    magic_link_sent: "Si tu email está registrado, recibirás un enlace en breve.",
    magic_link_check_email: "Revisa tu correo y haz clic en el enlace de acceso.",
    invite_user_hint: "El usuario recibirá un email con un enlace mágico de un solo uso para activar su cuenta.",
    invite_sent_to: "Invitación enviada a",
    invite_enroll_section: "Inscribir en un grupo (opcional)",
    invite_enroll_hint: "Si seleccionas un grupo, el estudiante quedará inscrito al activar su cuenta. Se creará un pago pendiente si el programa tiene precio y fecha de inicio.",
    invite_select_group: "Selecciona un grupo (opcional)",
    invite_add_program: "Agregar programa",
    default_price: "Precio por defecto",
    program_type: "Tipo de programa",
    any_program: "Cualquier programa",
    bank_account: "Cuenta bancaria",
    bank_account_select_placeholder: "Selecciona una cuenta…",
    bank_account_none: "Sin depósito bancario",
    bank_account_select_hint: "Aparecerá en el correo de bienvenida del estudiante junto al monto a depositar.",
    edit_user: "Editar usuario",
    edit_add_program_section: "Inscribir en más programas",
    edit_add_program_hint: "Los programas de clases nuevos se crean al guardar. Cada uno genera un pago pendiente si tiene fecha de inicio y monto > 0.",
    resend_magic_link: "Reenviar invitación",
    whatsapp: "WhatsApp",
    payment_link: "Enlace de pago",
    priv_payment_link_hint: "Opcional — se muestra en el correo de bienvenida como botón \"Pagar ahora\".",
    payment_link_hint: "URL para que el estudiante haga su pago (Stripe, PayPal, transferencia, etc.). Se incluye en los emails de recordatorio y en el banner del dashboard.",
    pay_now: "Pagar ahora",
    renew_banner_75: "Te quedan {n} sesiones para renovar tu nuevo programa. Al finalizar te estaremos enviando tu nueva factura.",
    renew_banner_done: "Completaste tu ciclo. En breve te enviamos la factura de tu nuevo programa.",
    renew_banner_75_pending: "Te quedan {n} sesiones para finalizar tu programa y tienes una factura pendiente de pago.",
    renew_banner_done_pending: "Completaste tu ciclo y tienes una factura pendiente de pago para continuar.",
    my_progress: "Mi progreso del ciclo",
    remaining: "Restantes",
    date_in_schedule: "Día programado para este grupo",
    date_off_schedule: "Día fuera del horario regular del grupo",
    daily_reminders: "Recordatorio del día",
    daily_reminders_done: "Recordatorios enviados",
    daily_reminders_desc: "Notifica a los profesores con clases programadas hoy. Idempotente — un solo email por profesor/día.",
    schedule_coverage: "Cobertura de asistencia",
    schedule_coverage_desc: "Clases programadas vs. asistencias reportadas este mes (hasta hoy).",
    classes_scheduled: "Programadas",
    classes_reported: "Reportadas",
    classes_missing: "Sin reportar",
    missing_dates: "Fechas sin reportar",
    no_schedule_coverage: "Ningún grupo tiene horario estructurado todavía.",
    add_schedule: "Agregar horario",
    no_schedule_set: "Sin horario definido",
    day_mon: "Lun",
    day_tue: "Mar",
    day_wed: "Mié",
    day_thu: "Jue",
    day_fri: "Vie",
    day_sat: "Sáb",
    day_sun: "Dom",
    max_students: "Cupos máximos",
    max_students_hint: "Vacío = ilimitado · Privado individual: 1 · Privado pareja: 2",
    capacity: "Capacidad",
    new_private_group: "Nuevo estudiante privado",
    program_price: "Precio del programa",
    program_price_none: "Sin precio definido",
    custom_price: "Precio especial (opcional)",
    custom_price_hint: "Déjalo vacío para usar el precio del programa. Si pones un valor aquí, será el que se use para la factura y el cobro.",
    custom_price_edit_hint: "Si cambias este valor, se actualizará la factura pendiente del estudiante. Déjalo vacío para usar el precio del programa.",
    program_cycle: "Sesiones por ciclo",
    custom_cycle: "Sesiones del ciclo (opcional)",
    custom_cycle_hint: "Déjalo vacío para usar el ciclo del programa. Si pones un valor (ej. 9 con cortesía), ese será el ciclo de este estudiante.",
    custom_cycle_edit_warn: "Ojo: si el estudiante ya lleva clases, cambiar este valor desfasa el contador. Usá «Cambiar plan».",
    change_plan: "Cambiar plan",
    current_plan: "Plan actual",
    cycle_in_progress: "Ciclo #{n} en curso: {x}/{y} sesiones tomadas",
    new_sessions: "Sesiones por ciclo",
    new_price: "Precio por ciclo",
    change_plan_hint: "El ciclo en curso termina con sus sesiones y precio actuales. El nuevo plan aplica desde el ciclo #{n}. El historial del estudiante no se toca.",
    notify_student_plan: "Notificar al estudiante por correo",
    plan_history: "Historial de cambios",
    from_cycle: "desde ciclo #{n}",
    notified: "notificado",
    apply_change: "Aplicar cambio",
    plan_changed_ok: "Plan actualizado: aplica desde el próximo ciclo",
    add_to_calendar: "Agregar a mi calendario",
    my_achievements: "Mis logros",
    celebration_title: "¡Nueva insignia!",
    celebration_total: "{n} pts en total",
    celebration_next: "Siguiente",
    celebration_close: "¡Genial!",
    my_points: "Mis puntos",
    points_short: "pts",
    badges_earned: "Insignias ganadas",
    your_rank: "Tu puesto",
    earned_on: "Ganada el",
    badge_manual_hint: "La otorga el equipo docente en ocasiones especiales.",
    badge_cat_attendance: "Asistencia",
    badge_cat_homework: "Tareas",
    badge_cat_payments: "Pagos",
    badge_cat_community: "Comunidad y recursos",
    badge_cat_special: "Especiales",
    leaderboard_title: "Ranking de insignias",
    leaderboard_empty_month: "Nadie ganó insignias este mes todavía. ¡Sé el primero!",
    leaderboard_show_more: "Ver los {n} restantes",
    leaderboard_show_less: "Ver menos",
    badges_how_title: "¿Cómo se ganan las insignias?",
    badges_how_btn: "Cómo ganar insignias",
    badges_how_intro: "Cada insignia da puntos. Se otorgan solas cuando cumplís la meta; no hay que pedir nada.",
    badges_how_1: "Asistencia: venir a clase seguido (Racha), terminar un ciclo sin faltas injustificadas (Ciclo perfecto) y dos meses seguidos sin faltas (Constancia).",
    badges_how_2: "Tareas y pagos: entregar todas las tareas del mes a tiempo (Al día), acumular tareas (Maratón) y pagar 3 cobros seguidos antes del vencimiento (Puntual).",
    badges_how_3: "Comunidad: asistir a WSS Live (Voz activa), practicar con Amigos con IA (Amigo fiel), completar lecciones y guardar recursos (Explorador), reaccionar y comentar en el muro y las fotos (Animador/a, Conversador/a).",
    badges_how_4: "Especiales: el equipo docente puede darte «Pionero WSS Live» o un «Reconocimiento».",
    badges_how_note: "El ranking del mes suma los puntos de las insignias ganadas ese mes. En «Mis logros» ves tu progreso hacia la siguiente.",
    leaderboard_empty: "Todavía nadie ganó insignias. ¡Sé el primero!",
    live_award_badge: "Otorgar insignia «Pionero WSS Live» a los asistentes",
    live_award_confirm: "¿Otorgar la insignia «Pionero WSS Live» (+30 pts) a los {attended} asistentes de «{title}»?",
    live_award_done: "Insignia otorgada a {n} estudiante(s) ({skipped} ya la tenían)",
    starts_on_date: "Inicia el {date}",
    not_started_hint: "Este estudiante todavía no había iniciado clases en esta fecha. Si asistió, ajustá la fecha de inicio en su matrícula.",
    cycle_stats_title: "Este ciclo",
    show_all_history: "Ver todo el historial",
    all_time_present: "Total histórico presente",
    cal_ics_file: "otros (.ics)",
    copied: "Copiado",
    cal_sync_title: "Sincronizá tus clases con tu calendario",
    cal_sync_sub: "Una sola vez: tus reservas WSS Live, clases regulares y privadas aparecen y se actualizan solas.",
    cal_sync_sub_teacher: "Una sola vez: tus grupos, sesiones WSS Live y clases privadas reservadas aparecen y se actualizan solas.",
    cal_sync_note: "Recordatorio 15 minutos antes de cada clase. Google tarda hasta 12-24 h en refrescar; Apple y Outlook suelen ser más rápidos. El enlace es privado: no lo compartas.",
    cal_copy_link: "Copiar enlace",
    cal_how_it_works: "¿Cómo funciona?",
    cal_regenerate: "Generar nuevo enlace",
    cal_regenerate_confirm: "El enlace anterior dejará de funcionar y tendrás que volver a suscribirte. ¿Continuar?",
    cal_regenerated: "Nuevo enlace generado",
    cal_help_1: "Tocá el botón de tu calendario (Google, Apple u Outlook) y confirmá «Agregar» o «Suscribirse».",
    cal_help_2: "Aparece un calendario nuevo llamado «WSS · Mis clases» con todas tus clases y reservas futuras.",
    cal_help_3: "Si un botón no abre (por ejemplo Google en el celular), copiá el enlace y pegalo en Google Calendar → Otros calendarios → + → Desde URL.",
    starts_on_day: "Inicia ciclo en día (opcional)",
    starts_on_day_hint: "Déjalo vacío para empezar en la sesión 1. Si pones un número (ej. 4 en un ciclo de 8), la próxima sesión será la #5 y le quedan 4 para renovar el ciclo.",
    paid_on_start: "Inicia programa pagado",
    paid_on_start_hint: "Actívalo si el estudiante ya pagó este ciclo (no se generará cobro). Déjalo apagado si aún debe pagar — recibirá los datos para hacerlo en su email de bienvenida.",
    historical_payment: "Pago histórico (no incluir en ingresos del mes)",
    historical_payment_hint: "Actívalo si el estudiante pagó hace meses (antes de usar la app). Este pago no afectará los ingresos del mes y NO se generará factura para él.",
    edit_enrollment: "Editar programa de clases",
    per_day_times: "Usar horario distinto por día",
    per_day_times_hint: "Actívalo cuando el estudiante toma clases a horas diferentes según el día. Los valores se pre-llenan con el horario de arriba.",
    // ===== Welcome email preview / resend =====
    preview_welcome_email: "Vista previa del correo",
    resend_welcome_email: "Reenviar correo de bienvenida",
    welcome_email_resent: "Correo de bienvenida reenviado",
    welcome_email_resend_error: "No se pudo reenviar el correo",
    // ===== My profile =====
    my_profile: "Mi perfil",
    meeting_room_superadmin: "Reunión con Admin",
    booking: "Reservas y citas",
    self_booking: "Reserva sus clases desde el calendario",
    self_booking_badge: "Agenda sus clases",
    amigos: "Practicá hablando",
    program_self_booking: "Las clases privadas de este programa se agendan por el estudiante",
    program_self_booking_hint: "Cada programa de clases privadas nuevo de este programa nace con \"Reserva sus clases desde el calendario\" encendido. Se puede apagar por estudiante en Editar programa de clases. No aplica a grupos.",
    self_booking_hint: "El estudiante agenda sus clases en la página pública; cada clase queda programada y consume una sesión al marcar asistencia.",
    meeting_room_academic_director: "Cita académica",
    meeting_room_section: "Mi sala de reuniones 1 a 1",
    meeting_room_hint: "Este enlace es el que abre el botón de la barra superior para todos los usuarios. Se usa Meet si está lleno; si no, Zoom.",
    profile_saved: "Perfil actualizado",
    profile_readonly_note: "Tu email y rol solo pueden ser cambiados por un administrador.",
    upload_avatar: "Subir foto",
    change_avatar: "Cambiar foto",
    remove_avatar: "Quitar foto",
    avatar_updated: "Foto actualizada",
    avatar_removed: "Foto eliminada",
    avatar_upload_error: "No se pudo subir la foto",
    avatar_too_large: "El archivo es muy grande (máx. 5 MB)",
    avatar_invalid_type: "Formato no permitido. Solo JPG, PNG o WEBP",
    // ===== Homework wall (attachments + submissions) =====
    attachments_and_responses: "Adjuntos y respuestas",
    material_from_teacher: "Material del profesor",
    material_hint: "Archivos compartidos con todo el grupo (PDF, imágenes, audio, Office).",
    upload_material: "Subir material",
    no_material: "Aún no hay material subido.",
    my_response: "Mi respuesta",
    my_response_placeholder: "Escribe aquí tu respuesta a la tarea…",
    submit_response: "Enviar respuesta",
    update_response: "Actualizar respuesta",
    add_attachment: "Adjuntar archivo",
    submission_saved: "Respuesta guardada",
    uploaded: "Archivo subido",
    wall_responses: "Muro de respuestas",
    no_responses_yet: "Aún no hay respuestas. ¡Sé el primero!",
    you: "tú",
    reaction: "reacción",
    reactions: "reacciones",
    add_feedback: "Dar feedback",
    write_feedback_placeholder: "Escribe tu comentario para el alumno…",
    send_feedback: "Enviar feedback",
    comment_posted: "Comentario publicado",
    // ===== Notifications =====
    notifications: "Notificaciones",
    no_notifications: "No tienes notificaciones nuevas.",
    mark_all_read: "Marcar todo como leído",
    view_all_notifications: "Ver todas las notificaciones",
    just_now: "ahora",
    admin_broadcast_btn: "Enviar mensaje",
    target_audience: "Destinatarios",
    all_students: "Todos los estudiantes",
    all_teachers: "Todos los profesores",
    all_academic_directors: "Directores académicos",
    title_required: "El título es obligatorio",
    delivered_to: "Enviado a",
    message: "Mensaje",
    link_optional: "Enlace (opcional)",
    send: "Enviar",
    title: "Título",
    send_also_email: "Enviar también por correo electrónico",
    also_send_by_email: "Enviar también por correo electrónico",
    also_send_by_email_hint: "Además de la notificación en la app, enviaremos un email a cada destinatario.",
    emails_sent: "correos enviados",
    broadcast_email_sent: "Correos enviados a",
    profile_tab_personal: "Datos personales",
    profile_tab_enrollments: "Mis programas",
    profile_section_basic: "Información básica",
    profile_section_learner: "Información de estudiante",
    profile_section_teacher: "Información profesional",
    save_changes: "Guardar cambios",
    next_pending_payment: "Próximo pago pendiente",
    no_enrollments_yet: "Aún no tienes programas asignados.",
    cycle_progress: "Progreso del ciclo",
    profession: "Profesión",
    emergency_contact_name: "Contacto de emergencia",
    emergency_contact_phone: "Tel. de emergencia",
    learning_goal: "Mi meta de aprendizaje",
    occupation: "Ocupación",
    native_language: "Idioma nativo",
    city: "Ciudad",
    country_of_residence: "País de residencia",
    date_of_birth: "Fecha de nacimiento",
    sessions_unit: "sesiones",
    suspend: "Suspender cobro",
    resume: "Reactivar cobro",
    suspended: "Suspendido",
    suspended_hint: "Programa pausado: no se genera el siguiente ciclo ni su factura.",
    program_status: "Estado del programa",
    edit_private_students_hint: "Para añadir o quitar estudiantes usa los botones de la tarjeta del grupo.",
    next_payment: "Próximo pago",
    payment_pending: "Pago pendiente",
    pay_now: "Pagar ahora",
    bank_deposit: "Depósito bancario",
    view_payment_details: "Ver detalles del pago",
    no_due_date: "Sin fecha límite",
    due_today: "Vence hoy",
    due_tomorrow: "Vence mañana",
    due_in_days: "Vence en {n} días",
    overdue_by: "Vencido hace {n} días",
    all_caught_up: "¡Estás al día!",
    no_pending_payments: "No tienes pagos pendientes en este momento.",
    my_current_cycle: "Mi ciclo actual",
    my_previous_cycle: "Ciclo anterior",
    my_next_cycle: "Próximo ciclo",
    cycle: "Ciclo",
    cycle_current: "Actual",
    no_dates_in_cycle: "No hay clases en este ciclo.",
    cycle_past: "Ciclo anterior",
    cycle_current_lbl: "Ciclo actual",
    cycle_future: "Próximo ciclo",
    archived: "Archivada",
    alert_archive: "Archivar",
    alert_restore: "Restaurar",
    alert_archived: "Alerta archivada",
    alert_restored: "Alerta restaurada",
    alerts_show_all: "Ver archivadas",
    alerts_show_active: "Ver activas",
    alerts_purge_note: "Las alertas se eliminan automáticamente después de 90 días.",
    student_search_placeholder: "Buscar estudiante por nombre o correo…",
    student_picker_no_match: "Sin coincidencias.",
    student_picker_full: "Ya seleccionaste el máximo de estudiantes (2). Elimina uno para añadir otro.",
    remove: "Quitar",
    resend_enrollment_email: "Reenviar correo de inscripción",
    enrollment_email_sent: "Correo de inscripción enviado",
    private_pair: "Pareja",
    private_individual: "Individual",
    filter_all: "Todos",
    filter_groups: "Grupales",
    filter_private: "Privados",
    capacity_reached: "Cupo lleno",
    add_students: "Agregar estudiantes",
    select_up_to_2: "Selecciona 1 o 2 estudiantes",
    date: "Fecha",
    status: "Estado",
    amount: "Monto",
    due_date: "Fecha de vencimiento",
    issued_date: "Fecha de emisión",
    paid_date: "Fecha de pago",
    notes: "Notas",
    topic: "Tema",
    content: "Contenido",
    actions: "Acciones",
    new_sede: "Nueva sede",
    new_program: "Nuevo programa",
    duplicate: "Duplicar",
    duplicate_program: "Duplicar programa",
    copy_suffix: "(Copia)",
    clone_groups_too: "Duplicar también los grupos asociados",
    groups_cloned: "grupos duplicados",
    new_group: "Nuevo grupo",
    new_payment: "Nuevo pago",
    new_journal_entry: "Nueva entrada",
    homework: "Tareas",
    my_homework: "Mis tareas",
    my_journal: "Bitácora",
    my_notebook: "Mi Notebook",
    wall_board: "Muro",
    gallery: "Galería",
    notebooks: "Notebooks",
    calendar: "Calendario",
    my_calendar: "Mi calendario",
    today: "Hoy",
    close: "Cerrar",
    all_groups: "Todos los grupos",
    scheduled_class: "Clase programada",
    attendance_reported: "Asistencia reportada",
    homework_due: "Tarea por entregar",
    homework_assigned: "Tarea asignada",
    no_events_for_day: "Sin eventos para este día.",
    my_status: "Mi estado",
    scheduled_classes_month: "Clases programadas del mes",
    reported: "Reportada",
    pending_past: "Pendiente",
    upcoming: "Próxima",
    att_day_taken: "Asistencia tomada",
    att_day_partial: "Incompleta",
    att_day_missing: "Sin registrar",
    att_day_paused: "En pausa",
    att_day_marked_count: "marcados",
    att_paused_badge: "En pausa",
    att_blocked_badge: "No es día de clase",
    att_blocked_title: "Este día no es de clase de este grupo.",
    att_blocked_body: "La lista queda bloqueada para que no se reporte asistencia en una fecha que no está en el programa. Si hubo clase (reposición, reprogramación o bonus), creá primero la sesión extra y después pasá la lista.",
    att_paused_hint: "El estudiante está en pausa en esta fecha: la clase queda congelada y no consume el ciclo.",
    att_paused_admin_warning: "Este estudiante está en pausa en esta fecha. Si lo marcás, la clase sí consume el ciclo.",
    missing_report: "Sin reporte",
    cancel_class: "Cancelar clase",
    my_attendance_month: "Mi asistencia del mes",
    cancel_class_body: "Esto marcará a los {count} estudiantes inscritos como «Cancelada (prof.)» para el {date}. ¿Confirmas?",
    cancel_class_confirm: "Sí, cancelar la clase",
    class_cancelled_saved: "Clase marcada como cancelada",
    unsaved_changes_title: "Tienes cambios sin guardar",
    unsaved_changes_body: "Si sales ahora se perderá la asistencia que aún no fue guardada. ¿Qué deseas hacer?",
    stay_here: "Quedarme aquí",
    save_and_continue: "Guardar y continuar",
    discard_changes: "Descartar cambios",
    my_journal_subtitle: "Lo que el profesor anotó en cada clase.",
    new_homework: "Nueva tarea",
    edit_homework: "Editar tarea",
    title: "Título",
    link: "Enlace",
    homework_link_hint: "Opcional. Pega un enlace a Drive, YouTube, PDF, etc.",
    homework_progress: "Progreso de tareas",
    show_completed: "Mostrar completadas",
    completed: "Completada",
    open_link: "Abrir enlace",
    all: "Todas",
    unassigned: "Sin asignar",
    clear: "Limpiar",
    clear_filters: "Limpiar filtros",
    orphan_payment_one: "pago sin programa de clases activo",
    orphan_payments_many: "pagos sin programa de clases activo",
    orphan_payments_hint: "Su programa de clases fue eliminado. Podés borrarlos con el ícono rojo de la papelera.",
    orphan_badge: "Sin programa",
    kept_badge: "Ingreso conservado",
    kept_badge_tooltip: "El programa se borró, pero este ingreso fue real y la factura se conserva",
    keep_invoice: "Conservar factura",
    unkeep_invoice: "Volver a marcarla como pendiente",
    keep_invoice_title: "¿Conservar esta factura?",
    keep_invoice_body: "El programa ya no existe, pero el ingreso fue real: la factura mantiene su número, sigue contando como ingreso y el estudiante la sigue viendo en su perfil. Solo deja de aparecer en la alerta de pagos sin programa.",
    keep_invoice_reason: "Motivo (opcional)",
    keep_invoice_reason_ph: "Ej.: el estudiante no continuó, pero pagó el ciclo completo",
    keep_invoice_cta: "Sí, conservarla",
    kept_ok: "Factura conservada",
    unkept_ok: "Volvió a la lista de pagos sin programa",
    progress_no_program: "Sin programa no hay asistencias de las que calcular el progreso",
    orphan_badge_tooltip: "El programa de clases asociado a este pago ya no existe.",
    show_orphans_only: "Ver solo huérfanos",
    show_all_payments: "Ver todos",
    groups_search_placeholder: "Buscar grupo, programa, profesor o estudiante…",
    students_search_placeholder: "Buscar por nombre o correo…",
    no_results_for_filter: "No hay resultados para los filtros aplicados.",
    filter_by_teacher: "Filtrar por profesor",
    select_group: "Seleccionar grupo",
    select_sede: "Seleccionar sede",
    select_program: "Seleccionar programa",
    select_teacher: "Seleccionar profesor",
    select_student: "Seleccionar estudiante",
    enroll_student: "Inscribir estudiante",
    members: "Miembros",
    present: "Presente",
    absent: "Ausente",
    justified: "Ausencia just.",
    unjustified: "Ausencia injust.",
    teacher_cancelled: "Cancelada",
    not_counted: "No contabiliza",
    removed: "Eliminada del plan",
    removed_hint: "Solo el super admin: quita esta fecha del plan del estudiante. No consume el ciclo ni cuenta como ausencia — queda neutra.",
    removed_dialog_title: "Eliminar sesión del plan",
    removed_dialog_body: "Esta fecha dejará de formar parte del plan del estudiante. No consume el ciclo ni cuenta como ausencia. Podés revertirlo cuando quieras.",
    removed_reason_label: "Motivo (opcional)",
    removed_reason_placeholder: "Ej: el profe se enfermó, cortesía de la escuela...",
    removed_confirm: "Eliminar del plan",
    removed_revert: "Restaurar en el plan",
    removed_done: "Sesión eliminada del plan",
    removed_reverted: "Sesión restaurada en el plan",
    att_edit_chip_hint: "Tocá para cambiarle el estado a esta fecha",
    att_edit_now_in: "ahora está en",
    att_edit_unmarked: "todavía sin marcar",
    att_edit_no_consume: "no consume el ciclo",
    att_edit_clear: "Quitarle la marca (queda sin reportar)",
    att_edit_note_label: "Nota (opcional)",
    att_edit_note_placeholder: "Por qué se cambió, para que quede el rastro",
    att_edit_done: "Asistencia actualizada",

    flexible_schedule: "Horario especial (asistencia parcial)",
    flexible_schedule_badge: "Horario especial",
    flexible_schedule_hint: "Actívalo cuando este estudiante asiste menos veces que el resto del grupo. En la hoja de asistencia aparecerá el botón \"No contabiliza\" para marcar las fechas del grupo que no forman parte de su horario pagado (no consumen su ciclo). Recordá ajustar también el \"ciclo personalizado\" (ej. 4 en lugar de 8) para que su factura salga por las clases que paga.",
    justified_full: "Ausencia justificada",
    unjustified_full: "Ausencia injustificada",
    clear_attendance: "Sin reportar",
    clear_attendance_tooltip: "Borrar el reporte y devolver la sesión a estado 'Próxima'. Si consumía una clase del ciclo, se libera.",
    clear_attendance_confirm_title: "¿Borrar el reporte de esta sesión?",
    clear_attendance_confirm_body: "La sesión del {date} volverá a estado 'Próxima' y se liberará el conteo del ciclo si aplica.",
    quota_review_toast: "Guardado. Ojo: {names} ya usó su cupo de justificadas de este ciclo ({used}/{quota}), así que esa ausencia quedó esperando autorización de dirección y por ahora cuenta como clase tomada.",
    unlimited_justified_student_hint: "Podés cancelar sin límite y a cualquier hora: la escuela te dio ese permiso.",
    awaiting_approval: "Esperando autorización de dirección",
    unlimited_justified: "Justificadas sin límite",
    unlimited_justified_hint: "Puede justificar todas las veces que necesite, sin autorización y sin gastar cupo. Solo el super admin puede darlo.",
    unlimited_justified_badge: "Sin límite",
    unlimited_justified_note_label: "Por qué se le da (queda registrado)",
    unlimited_justified_on: "Permiso activado",
    unlimited_justified_off: "Permiso quitado",

    clear_attendance_cta: "Sí, borrar reporte",
    attendance_cleared: "Reporte de asistencia eliminado",
    paid: "Pagado",
    pending: "Pendiente",
    superadmin: "Superadministrador",
    no_data: "Sin datos",
    no_assignments: "Aún no estás inscrito en ningún grupo. Contacta al administrador.",
    welcome_back: "Bienvenido de vuelta",
    total: "Total",
    take_attendance: "Tomar asistencia",
    save_attendance: "Guardar asistencia",
    mark_paid: "Marcar como pagado",
    private: "Privado",
    group: "Grupo",
    private_student: "Estudiante privado",
    pay_now: "Pagar ahora",
    payment_info: "El pago se registra manualmente. Por favor contacta a la administración o consulta los métodos de pago aceptados.",
    confirm_delete: "¿Confirmar eliminación?",
    deleted: "Eliminado",
    saved: "Guardado",
    save_all: "Guardar todo",
    save_and_resend_email: "Guardar y reenviar correo",
    saved_and_email_resent: "Guardado · correo reenviado al estudiante",
    download_invoice: "Descargar factura",
    invoice: "Factura",
    invoice_settings: "Configuración de facturas",
    invoice_settings_short: "Config: Facturas",
    invoice_settings_subtitle: "Emisores múltiples, datos compartidos, asignación de estudiantes y reporte mensual",
    issuer_block: "Datos del emisor",
    issuer_block_hint: "Aparecen en la esquina superior derecha y en el pie de cada factura.",
    issuer_name: "Nombre del emisor",
    issuer_tax_id: "Cédula / Tax ID",
    issuer_location: "Ubicación",
    policy_url: "URL de políticas y condiciones",
    policy_url_hint: "Enlace que aparece debajo de 'CONDICIONES Y FORMA DE PAGO' en la factura.",
    numbering: "Numeración",
    numbering_hint: "El sistema asigna automáticamente el siguiente número al emitir cada factura.",
    next_invoice_number: "Próximo número a emitir",
    next_number_warning: "Cambiar el próximo número puede generar duplicados si emites con un valor ya usado. Verifica antes de guardar.",
    preview_sample: "Ver factura de ejemplo",
    // Multi-issuer
    tab_issuers: "Emisores",
    tab_shared: "Datos compartidos",
    tab_assignments: "Asignación",
    tab_report: "Reporte mensual",
    issuers_subtitle: "Configura las entidades legales (WF, SRL95, SRL96…) que pueden emitir facturas. Una será la predeterminada para nuevos estudiantes.",
    shared_subtitle: "Ubicación y enlace de políticas compartidos por todos los emisores.",
    assignments_subtitle: "Asigna cada estudiante a un emisor. Si no se asigna, se usará el emisor predeterminado.",
    report_subtitle: "Facturas emitidas en el mes seleccionado, desglosadas por emisor.",
    add_issuer: "Añadir emisor",
    new_issuer: "Nuevo emisor",
    edit_issuer: "Editar emisor",
    prefix: "Prefijo",
    prefix_hint: "Aparecerá antes del número (ej.: WF-1575, SRL95-200).",
    default_issuer: "Predeterminado",
    set_default: "Hacer predeterminado",
    cannot_delete_default: "No puedes eliminar el emisor predeterminado.",
    issuer_in_use: "No se puede eliminar: tiene facturas emitidas o estudiantes asignados.",
    confirm_delete_issuer: "¿Eliminar este emisor? Los estudiantes asignados volverán al predeterminado.",
    monthly_invoice_report: "Reporte mensual de facturas emitidas",
    total_invoices: "Total facturas",
    total_amount: "Monto total",
    no_invoices_month: "No se emitieron facturas este mes.",
    by_issuer: "Por emisor",
    issued_at: "Emitida el",
    invoice_number: "N° factura",
    student: "Estudiante",
    amount: "Monto",
    assigned_issuer: "Emisor asignado",
    use_default: "Usar predeterminado",
    bulk_assign: "Asignar seleccionados a:",
    apply_bulk_assign: "Aplicar",
    students_selected: "estudiantes seleccionados",
    filter_students: "Filtrar por nombre o correo…",
    month: "Mes",
    // Financial dashboard
    financial_overview: "Resumen financiero",
    financial_overview_hint: "Proyección vs. ingresos reales, flujo de estudiantes y desglose por programa.",
    financial_report: "Reporte financiero",
    export_pdf: "Exportar PDF",
    projection: "Proyección",
    realized_paid: "Ingresos cobrados",
    variance: "Variación",
    arps: "Ingreso prom./estudiante",
    arps_hint: "Promedio del mes (pago/activo)",
    override_active: "Manual",
    auto: "Auto",
    active_enrollments: "Programas activos",
    student_flow: "Flujo de estudiantes del mes",
    start_of_month: "Inicio del mes",
    new_students: "Nuevos",
    reactivated: "Reactivados",
    paused: "Pausados",
    cancelled: "Cancelados",
    end_of_month: "Final del mes",
    net_change: "Cambio neto",
    revenue_by_program: "Ingresos por programa",
    trend_important: "Lo importante",
    trend_rest: "El resto",
    trend_active_students: "Estudiantes activos",
    trend_group_students: "En clases grupales",
    trend_private_students: "En clases privadas",
    trend_hours_month: "Horas dictadas",
    trend_hours_all_time: "Horas acumuladas",
    trend_vs_prev: "vs. mes pasado",
    trend_with_enrollment: "con matrícula activa",
    trend_same_as_prev: "igual que el mes pasado",
    trend_no_data: "sin datos aún",
    income_title: "Ingresos y proyección mes a mes",
    income_subtitle: "En dólares · los meses recientes los calcula la app con los pagos cobrados; cualquier mes se puede corregir a mano",
    income_compare_all: "Comparar todos",
    income_projection: "Proyección",
    income_year: "Año",
    income_total: "Total",
    income_help: "Hacé clic en cualquier celda para corregir el monto (también en la fila de proyección, para anotar la meta de cada mes). Si la borrás y guardás vacío, ese mes vuelve a calcularse con los pagos del sistema.",
    income_saved: "Valor actualizado",
    income_cleared: "Mes vuelto al cálculo automático",
    income_save_error: "No se pudo guardar",
    programs_count: "programas",
    test_accounts_excluded: "cuentas de prueba excluidas de los números",
    program: "Programa",
    revenue: "Ingresos",
    override_projection: "Sobrescribir proyección",
    override_projection_hint: "Ajusta manualmente la proyección de ingresos de este mes (por ejemplo, si tienes ingresos esperados que no están en programas de clases activos).",
    leave_empty_to_use_auto: "Deja vacío para usar el cálculo automático",
    amount: "Monto",
    loading: "Cargando…",
    advance_balance: "a favor",
    advance_balance_hint: "lo aplicamos solo a la factura de tu próximo ciclo, no tenés que hacer nada",
    unreported_title: "Clases de hoy sin pasar lista",
    unreported_none: "Todas las clases de hoy ya tienen la lista pasada.",
    unreported_hint: "Mientras no se reporte, esas clases no consumen el ciclo y el cobro se atrasa. A las 8:30 p.m. te llega el recordatorio por correo.",
    exchange_rate: "Tipo de cambio",
    manual: "Manual",
    fallback: "Por defecto",
    refresh_from_bccr: "Actualizar desde BCCR",
    edit_rate: "Editar tipo de cambio",
    edit_exchange_rate: "Tipo de cambio USD → CRC",
    edit_exchange_rate_hint: "Sobrescribe manualmente el tipo de cambio. Deja vacío para usar el valor automático del BCCR (se actualiza diariamente).",
    rate: "Tipo de cambio",
    leave_empty_for_bccr_auto: "Deja vacío para usar el valor automático del BCCR",
    exchange_rate_refreshed: "Tipo de cambio actualizado desde BCCR",
    bccr_unavailable: "BCCR no disponible. Verifica credenciales BCCR_EMAIL y BCCR_TOKEN en el backend.",
    error_generic: "Ocurrió un error. Inténtalo de nuevo.",
    // Extra / rescheduled sessions
    add_extra_session: "Añadir sesión extra",
    new_extra_session: "Nueva sesión extra",
    new_extra_session_subtitle: "Crea una clase de reposición, una reprogramación o una sesión bonus fuera del horario habitual.",
    session_type: "Tipo de sesión",
    session_type_extra: "Extra (bonus)",
    session_type_reschedule: "Reprogramación",
    session_type_makeup: "Reposición",
    original_class_date: "Fecha original a reemplazar",
    original_class_date_hint: "La fecha original se ocultará del calendario y será reemplazada por la nueva.",
    applies_to: "Aplica a",
    entire_group: "Todo el grupo",
    start_time: "Hora de inicio",
    time_select_use_quick: "Usar horas rápidas",
    time_select_quick: "Rápido",
    time_select_use_custom: "Hora personalizada",
    session_time_hint: "Si lo dejas vacío, se usa la hora regular del grupo.",
    duration_minutes: "Duración (min)",
    counts_toward_cycle: "Cuenta para el ciclo del estudiante",
    generates_charge: "Genera un cobro adicional",
    charge_amount: "Monto a cobrar",
    currency: "Moneda",
    expenses: "Control de Gastos",
    nav_academic: "Académico",
    resources: "Recursos",
    conjugation: "Conjugación",
    cj_title: "Conjugación de verbos",
    cj_subtitle: "Practicá con puntaje y consultá cualquier verbo, agrupado por su tipo de irregularidad.",
    cj_tab_practice: "Practicar",
    cj_tab_dictionary: "Diccionario",
    cj_build: "Armá tu práctica",
    cj_tenses: "Tiempos verbales",
    cj_difficulty: "Dificultad",
    cj_difficulty_all: "Toda",
    cj_difficulty_any: "Toda dificultad",
    cj_count: "Cantidad",
    cj_include_vos: "Incluir vos",
    cj_include_vosotros: "Incluir vosotros",
    cj_start: "Empezar",
    cj_pick_tense: "Elegí al menos un tiempo verbal",
    cj_cannot_build: "No se pudo armar la práctica",
    cj_practices: "prácticas",
    cj_best_score: "Mejor puntaje",
    cj_hits_of: "aciertos de",
    cj_question_of: "Pregunta {n} de {total}",
    cj_pts: "pts",
    cj_type_answer: "Escribí la forma correcta…",
    cj_check: "Revisar",
    cj_next: "Siguiente",
    cj_see_score: "Ver mi puntaje",
    cj_exit: "Salir",
    cj_correct: "¡Correcto!",
    cj_almost_accent: "Casi: te faltó la tilde. Es",
    cj_right_form: "La forma correcta es",
    cj_points_of: "{score} de {max} puntos",
    cj_correct_of: "{correct} correctas de {total} · {acc}% de acierto",
    cj_accent_wrong: "con la tilde equivocada",
    cj_to_review: "Para repasar",
    cj_accent_only: "solo la tilde",
    cj_practice_again: "Practicar de nuevo",
    cj_change_filters: "Cambiar los filtros",
    cj_search_verb: "Buscar un verbo en español o en inglés…",
    cj_verbs_count: "verbos",
    cj_gerund: "Gerundio",
    cj_participle: "Participio",
    cj_tense_col: "Tiempo",
    cj_imperative_col: "Imperativo",
    cj_t_presente: "Presente",
    cj_t_preterito: "Pretérito",
    cj_t_imperfecto: "Imperfecto",
    cj_t_futuro: "Futuro",
    cj_t_condicional: "Condicional",
    cj_t_subjuntivo_presente: "Presente de subjuntivo",
    cj_t_subjuntivo_imperfecto: "Imperfecto de subjuntivo",
    cj_t_imperativo_afirmativo: "Imperativo afirmativo",
    cj_t_imperativo_negativo: "Imperativo negativo",
    cj_affirmative: "afirmativo",
    cj_negative: "negativo",
    cj_diff_basico: "Básico",
    cj_diff_intermedio: "Intermedio",
    cj_diff_avanzado: "Avanzado",
    cj_rank_title: "Ranking de la semana",
    cj_rank_hint: "Se reinicia cada lunes · hora de Costa Rica",
    cj_rank_empty: "Nadie ha practicado esta semana. ¡Sé el primero!",
    cj_rank_you: "vos",
    cj_rank_my_place: "Vas en el puesto {n} de {total}",
    cj_rank_accuracy: "acierto",
    cj_rank_all_time: "Histórico",
    cj_rank_week: "Esta semana",
    cj_rank_gap: "Te faltan {n} puntos para pasar a {name}",
    cj_streak_days: "días",
    cj_streak_day_one: "día",
    cj_streak_row: "seguidos practicando",
    cj_streak_row_one: "practicando",
    cj_streak_best: "tu mejor racha",
    cj_vod_title: "Verbo del día",
    cj_vod_note: "{n} preguntas · como 30 segundos",
    cj_vod_go: "Ronda rápida",
    cj_weak_title: "Verbos que más se te escapan",
    cj_weak_misses: "{n} fallos",
    cj_weak_misses_one: "{n} fallo",
    cj_opts_all_levels: "Todos los niveles",
    cj_weak_practice: "Practicar solo estos",
    cj_challenge_title: "Reto de la semana",
    cj_challenge_text: "Esta semana todos practicamos el",
    cj_challenge_progress: "{done} de {total} rondas hechas",
    cj_challenge_go: "Practicar el reto",
    cj_opts_show: "Cambiar",
    cj_opts_hide: "Listo",
    cj_opts_questions: "{n} preguntas",
    cj_which_verbs: "¿Qué verbos?",
    cj_fam_all: "Todos",
    cj_fam_regular: "Regulares",
    cj_fam_ortho: "Regulares con cambio ortográfico",
    cj_fam_core: "18 irregulares",
    cj_fam_stem: "Irregulares con cambio ortográfico",
    cj_fam_reflexive: "Reflexivos",
    cj_fam_few: "Pocos verbos con ese filtro: se van a repetir",
    cjg_button: "Cómo se usa",
    cjg_title: "Cómo usar las actividades de conjugación",
    cjg_intro: "Hay tres actividades. Elegí una, marcá los tiempos que querés practicar, decidí qué verbos (todos, regulares, irregulares, reflexivos…), cuántas preguntas querés y presioná «Empezar». Escribí tu respuesta y presioná Enter: el sistema te dice al instante si está bien y te muestra la forma correcta. Al final ves tu puntaje y tus puntos suman en la tabla semanal.",
    cjg_m1_title: "1 · Conjugar el verbo",
    cjg_m1_steps: "Te aparece un verbo y una persona (por ejemplo: «vivir» + «nosotros») en el tiempo que elegiste. | Escribí solo la forma conjugada: «vivimos». | Las tildes cuentan: si te falta una tilde te lo decimos y la respuesta vale la mitad. | Es la actividad para memorizar terminaciones y verbos irregulares.",
    cjg_m1_tip: "Consejo: empezá con Presente y verbos regulares, y después agregá los 18 irregulares.",
    cjg_m2_title: "2 · Completar oraciones",
    cjg_m2_steps: "Te aparece una oración completa con un espacio en blanco, armada con las cuatro piezas: tiempo + persona + verbo + información (ej.: «Todos los días yo ____ café con leche en la mañana»). | Abajo ves el verbo en infinitivo como pista. | Escribí la forma que va en el espacio. | Con el imperativo y el subjuntivo a veces hay que escribir también el pronombre (te lo indicamos).",
    cjg_m2_tip: "Pasá el mouse (o tocá con el dedo en el celular) cualquier parte de la oración para ver la traducción al inglés, y palabra por palabra. Ojo: si usás esa ayuda, esa pregunta vale la mitad de los puntos.",
    cjg_m3_title: "3 · Unir oraciones",
    cjg_m3_steps: "Son dos oraciones unidas por un conector («y», «pero», «porque», «por eso»…): dos espacios en blanco, uno en cada oración. | Nivel 1: conectores simples y el mismo tiempo en las dos. | Nivel 2: los dos tiempos pueden ser distintos (ej.: pasado y futuro). | Nivel 3: además tenés que elegir vos el conector que le da sentido a la oración. | Escribí los dos verbos y presioná Enter.",
    cjg_m3_tip: "Esta es la actividad más parecida a hablar de verdad: pensá primero qué relación hay entre las dos ideas.",
    cjg_extras_title: "Otras cosas que podés hacer",
    cjg_extras: "«Modo difícil»: en vez del verbo en español, la pista es la traducción en inglés. | «Vos» y «vosotros»: prendelos o apagalos según lo que estés estudiando; queda guardado. | «Imprimir hoja»: genera una hoja de ejercicios para trabajar en papel, con o sin respuestas. | Diccionario: la tabla completa de los verbos, agrupada por regulares, irregulares y reflexivos. | Tabla semanal: cada práctica te da puntos y aparecés en el ranking de la semana.",

    cj_help_hint: "Pasá el mouse (o tocá) una palabra de la oración para ver el inglés · usar la ayuda vale la mitad de los puntos",
    cj_help_used: "Usaste la traducción: esta pregunta vale la mitad de los puntos",
    cj_help_cost: "vale la mitad de los puntos",


    cj_mode_sentences: "Completar oraciones",
    cj_mode_sentences_desc: "Tiempo + pronombre + verbo + información",
    cj_mode_forms: "Conjugar el verbo",
    cj_mode_forms_desc: "Te digo el tiempo y la persona",
    cj_mode_linked: "Unir dos oraciones",
    cj_mode_linked_desc: "Dos four-finger con un conector",
    cj_level: "Nivel",
    cj_level_1: "Nivel 1",
    cj_level_1_desc: "Mismo tiempo en los dos lados",
    cj_level_2: "Nivel 2",
    cj_level_2_desc: "Tiempos distintos (Antes… pero ayer…)",
    cj_level_3: "Nivel 3",
    cj_level_3_desc: "Vos escogés el conector",
    cj_pick_connector: "conector…",
    cj_two_tenses: "dos tiempos",
    cj_right_forms: "Las formas correctas son:",
    cj_worksheet: "Hoja de práctica",
    cj_worksheet_open: "Imprimir hoja",
    cj_worksheet_print: "Imprimir",
    cj_worksheet_answers: "Incluir respuestas",
    cj_worksheet_key: "Hoja de respuestas",
    cj_worksheet_name: "Nombre",
    cj_worksheet_date: "Fecha",
    cj_worksheet_items: "ejercicios",
    cj_tense_mixed: "Todos mezclados",
    cj_hard_mode: "Modo difícil",
    cj_hard_mode_desc: "te doy el verbo en inglés",
    cj_pronoun_blank: "pron.",
    cj_verb_blank: "verbo",
    cj_pronoun_wrong: "Ojo con el pronombre reflexivo.",
    cjt_tab: "Mis oraciones",
    cjt_title: "Mis oraciones",
    cjt_subtitle: "Escribí tus propios marcadores de tiempo y complementos. Se suman a los del sistema y salen en las prácticas de los estudiantes.",
    cjt_kind_marker: "Marcadores de tiempo",
    cjt_kind_marker_hint: "El primer dedo: Ayer, Todos los días, Ojalá que…",
    cjt_kind_complement: "Información del verbo",
    cjt_kind_complement_hint: "El cuarto dedo: lo que va después del verbo",
    cjt_verb: "Verbo",
    cjt_new_marker: "Nuevo marcador",
    cjt_new_complement: "Nueva información",
    cjt_ph_marker: "Ej: El jueves pasado",
    cjt_ph_complement: "Ej: un casado en Soda Tapia",
    cjt_add: "Agregar",
    cjt_added: "Listo, ya sale en las prácticas",
    cjt_error: "No se pudo guardar",
    cjt_only_school: "Usar solo mis oraciones",
    cjt_only_school_hint: "si lo prendés, se dejan de usar las del sistema donde tengás propias",
    cjt_preview: "Ver un ejemplo",
    cjt_mine: "Mías",
    cjt_mine_empty: "Todavía no has agregado ninguna. Las del sistema siguen funcionando.",
    cjt_system: "Del sistema",
    cjt_marker_warning: "El marcador tiene que obligar el tiempo que elegiste. Si en Presente pones \"El jueves pasado\", el estudiante va a contestar en pretérito y el sistema lo va a marcar mal. Revisá el ejemplo antes de guardar.",
    cjt_kind_connector: "Conectores",
    cjt_kind_connector_hint: "Para unir dos oraciones: y, pero, después…",
    cjt_new_connector: "Nuevo conector",
    cjt_ph_connector: "Ej: de una vez",
    cjt_causal: "Usar conectores de causa",
    cjt_causal_hint: "porque, por eso, por lo tanto, así que, entonces, por esa razón — apagados por defecto porque piden una relación lógica real entre las dos oraciones",
    announcements: "Anuncios",
    resources_sub: "Material de estudio para practicar en cualquier momento",
    resource_new: "Nuevo recurso",
    resource_edit: "Editar recurso",
    resource_category: "Categoría",
    resource_search: "Buscar recurso...",
    resource_favorites: "Favoritos",
    resource_empty: "Todavía no hay recursos publicados",
    resource_new_badge: "Nuevo",
    resource_draft: "Borrador",
    resource_open: "Abrir",
    resource_watch: "Ver",
    resource_clicks: "Aperturas",
    resource_kind: "Tipo de recurso",
    resource_kind_link: "Enlace externo",
    resource_kind_video: "Video (YouTube, Vimeo...)",
    resource_kind_pdf: "PDF para descargar",
    resource_kind_file: "Archivo para descargar (PDF, Word, Excel, imagen, audio)",
    resource_file_hint: "PDF, Word, Excel, PowerPoint, texto, CSV, ZIP, imágenes o audio · máx 25 MB",
    resource_kind_embed: "Insertar contenido (embed)",
    resource_embed_code: "Código para insertar",
    resource_embed_preview: "Vista previa",
    resource_aspect: "Proporción del contenido",
    resource_aspect_fine: "Ajuste fino",
    resource_aspect_hint: "Elegí la proporción del diseño original. Si no coincide, Canva o YouTube rellenan con negro a los lados.",
    resource_aspect_wide: "panorámico (video, presentaciones)",
    resource_aspect_classic: "clásico (presentaciones Canva)",
    resource_aspect_square: "cuadrado",
    resource_aspect_portrait: "vertical (hoja)",
    resource_aspect_story: "vertical alto (celular)",
    resource_embed_no_iframe: "No encuentro un <iframe> con src en el código pegado",
    resource_embed_bad_host: "Dominio no permitido para insertar:",
    resource_reorder_hint: "Arrastrá las tarjetas para cambiar el orden en que las ven los estudiantes",
    resource_duplicate: "Duplicar",
    resource_duplicated: "Recurso duplicado: cambiá el título y el enlace",
    resource_ranking: "Ranking de uso",
    resource_ranking_total: "Aperturas totales",
    resource_category_new: "Nueva categoría",
    resource_category_edit: "Editar categoría",
    resource_category_name: "Nombre de la categoría",
    resource_category_hidden: "Oculta (sin recursos)",
    resource_category_delete_confirm: "¿Borrar esta categoría? Sus recursos pasan a 'Otros'.",
    resource_all_categories: "Todas las categorías",
    resource_visibility: "Visibilidad",
    resource_vis_all: "Todos (estudiantes y profesores)",
    resource_vis_staff: "Solo profesores",
    resource_vis_public_badge: "Público",
    resource_vis_hint: "\"Solo profesores\" no aparece en la galería del estudiante, pero sí lo puede abrir si un profesor se lo adjunta a una tarea (mientras siga adjunto).",
    resource_pending_review: "Pendiente de aprobación",
    resource_teacher_note: "Tu recurso queda en borrador hasta que administración o dirección académica lo apruebe.",
    resource_share: "Copiar enlace para compartir",
    resource_attach: "Adjuntar a una tarea",
    resource_attach_new_hw: "Crear una tarea nueva",
    resource_attach_need_title: "Escribí el título de la tarea",
    resource_attached: "Material adjuntado a la tarea",
    select: "Seleccioná...",
    resource_link_copied: "Enlace copiado: pegalo en la tarea, correo o WhatsApp",
    resource_count_one: "recurso",
    resource_count_many: "recursos",
    resource_reorder_cats_hint: "Arrastrá las categorías para cambiar el orden en que las ven los estudiantes",
    resource_reorder_blocked: "Quitá los filtros y el buscador para poder reordenar las tarjetas",
    resource_embed_hint: "Pegá el código que te da Canva, YouTube, Quizlet, Genially, Canva, Wordwall, Padlet o Google. Tomamos solo el iframe y lo mostramos dentro de la plataforma.",
    resource_url: "Enlace",
    resource_pdf: "Archivo PDF (máx 20 MB)",
    resource_cover: "Portada",
    resource_image_url_hint: "Pegá la URL de una imagen (o subí una abajo)",
    resource_published: "Publicado",
    resource_published_hint: "Si está apagado, solo lo ves vos (borrador)",
    all_levels: "Todos los niveles",
    level: "Nivel",
    download: "Descargar",
    nav_people: "Personas",
    nav_finance: "Finanzas",
    nav_marketing: "Mercadeo y Ventas",
    nav_comms: "Comunicación",
    nav_settings: "Configuración",
    expenses_sub: "Registra y controla los gastos de cada oficina",
    expense_categories: "Categorías",
    expense_category: "Categoría",
    expense_new: "Nuevo gasto",
    expense_records: "gastos",
    expense_total: "Total del período (USD)",
    expense_by_office: "Gasto por oficina (USD)",
    expense_vendor: "Proveedor (opcional)",
    expense_new_category: "Nueva categoría",
    expense_category_archived: "Categoría archivada (tiene gastos asociados)",
    notes_placeholder_extra: "Motivo o detalles adicionales",
    extra_session_created: "Sesión creada y notificada",
    extra_sessions_label: "Sesiones extra",
    extra_session_extra: "EXTRA",
    extra_session_reschedule: "REPO",
    extra_session_makeup: "REPO",
    reschedule_needs_original: "Selecciona la fecha original que se está reprogramando",
    reschedule_session: "Reprogramar sesión",
    reschedule_edit: "Editar reprogramación",
    reschedule_session_title: "Reprogramar sesión",
    reschedule_session_subtitle: "Mové la sesión del {date} a otra fecha. La original se oculta del ciclo y queda reemplazada por la nueva.",
    rescheduled_from: "Reprogramada desde el {date}",
    new_date: "Nueva fecha",
    date_is_reschedule: "Esta fecha es una reprogramación del {orig}",
    date_is_makeup: "Esta fecha es una reposición del grupo",
    date_is_extra: "Esta fecha es una sesión extra del grupo",
    extra_session_updated: "Sesión actualizada y notificada",
    undo_session_tooltip: "Deshacer esta sesión",
    edit_session_tooltip: "Cambiar la fecha u hora de esta sesión",
    change_date_short: "Fecha",
    move_booked_class_title: "Mover la clase reservada",
    booked_class_moved: "Clase movida · también se movió la reserva y el calendario, sin avisar a nadie",
    edit_session_title: "Cambiar esta sesión",
    edit_session_subtitle: "Sesión del {date}. Cambiá la fecha o la hora y guardá.",
    extra_sessions_hint: "Tocá la sesión para marcar asistencia, «Fecha» para cambiarle el día u hora, o la X para deshacerla.",
    move_booked_class_tooltip: "Cambiar la fecha de esta clase reservada",
    move_booked_class_note: "Esta clase la reservó el estudiante desde el calendario. Al cambiar la fecha o la hora se mueve también la reserva y el evento del Google Calendar del profesor, sin mandar correos.",
    move_booked_class_conflict_cta: "Moverla igual",
    move_booked_class_conflict_other: "Elegir otro horario",
    undo_session_title: "¿Deshacer esta sesión?",
    undo_reschedule_body: "La sesión del {date} se elimina y la fecha original ({orig}) vuelve al ciclo del estudiante. Podés volver a reprogramarla cuando quieras.",
    undo_extra_body: "La sesión del {date} se elimina del calendario del grupo y de sus estudiantes.",
    undo_session_cta: "Sí, deshacer",
    undo_session_done: "Sesión deshecha",
    // Absence requests
    absence_requests: "Solicitudes de ausencia",
    absence_requests_title: "Solicitudes de ausencia",
    absence_requests_subtitle: "Revisa y gestiona las solicitudes de ausencia enviadas por los estudiantes.",
    my_absences: "Mis ausencias",
    my_absences_title: "Mis solicitudes de ausencia",
    my_absences_subtitle: "Solicita la cancelación de una clase con al menos 12 horas de anticipación (o el plazo personalizado que tengas asignado).",
    new_absence_request: "Nueva solicitud",
    new_absence_dialog_subtitle: "Escoge una o varias fechas que no podrás asistir.",
    enrollment: "Programa de clases",
    dates_to_cancel: "Fechas a cancelar",
    add_date: "Añadir fecha",
    at_least_one_date: "Debes incluir al menos una fecha",
    choose_class_date: "Elige una fecha de clase…",
    no_available_dates_to_cancel: "No hay clases próximas disponibles para cancelar en este ciclo.",
    submit_request: "Enviar solicitud",
    absence_reason_placeholder: "Motivo de la ausencia (opcional pero recomendado)",
    cycle_quota_label: "Cuota de cancelaciones (ciclo actual)",
    quota_left_short: "{left} de {total} disponibles",
    absence_history_current_cycle: "Ciclo en curso",
    absence_history_past_cycles: "Ciclos anteriores",
    no_cycle_active: "Sin ciclo activo",
    no_active_enrollments: "No tienes programas de clases activos",
    remaining_cancellations_cycle: "Te quedan {left} de {total} en este ciclo",
    policy_hours_label: "Política: {hours} horas de anticipación mínima",
    quota_exhausted_warning: "Ya usaste todas las cancelaciones permitidas. Las próximas solicitudes irán a revisión administrativa.",
    absence_request_received: "Solicitud recibida",
    absence_request_received_subtitle: "Esto fue procesado:",
    auto_justified_msg: "✓ Recibida dentro del plazo y dentro de cuota — la ausencia queda justificada automáticamente.",
    over_quota_msg: "⚠️ Excede tu cuota del ciclo. Por ahora esta clase se descuenta de tu plan; si admin aprueba la justificación, se libera.",
    late_notice_msg: "⚠️ Fuera del plazo de {hours} h. Por ahora esta clase se descuenta de tu plan; si admin aprueba la justificación, se libera.",
    my_absence_history: "Historial de mis solicitudes",
    no_absence_requests: "Aún no has enviado solicitudes.",
    no_pending_requests: "No hay solicitudes pendientes de revisión.",
    review_request_title: "Revisar solicitud",
    dates_in_request: "Fechas en la solicitud",
    hours_notice_label: "Anticipación",
    out_of_policy: "Fuera del plazo",
    exceeds_quota_short: "Excede cuota",
    admin_note: "Nota del administrador",
    admin_note_optional: "Nota (opcional)",
    admin_note_placeholder: "Comentario sobre la decisión",
    request_approved: "Solicitud aprobada",
    request_rejected: "Solicitud rechazada",
    submitted: "Enviada",
    review: "Revisar",
    approve: "Aprobar",
    reject: "Rechazar",
    pending: "Pendientes",
    all: "Todas",
    dates: "Fechas",
    group: "Grupo",
    cancellation_policy_hours_label: "Horas de cancelación personalizadas",
    cancellation_policy_hours_hint: "Si lo dejas vacío, se aplica la política default (12 h).",
    no_usable_enrollment: "Para poder solicitar una ausencia, primero debes estar al día con el pago de tu ciclo actual. Una vez confirmado tu pago, esta opción se habilitará automáticamente. Si crees que ya pagaste, contacta a la dirección académica.",
    payment_required_title: "Pago del ciclo pendiente",
    group_deleted: "(grupo eliminado)",
    unjustified_consumed: "Ausencia descontada",
    unjustified_consumed_hint: "Esta clase se descontó del ciclo porque la solicitud fue tardía o excedió tu cuota. El admin puede revertirlo aprobando la solicitud.",
    view_month: "Mes",
    view_week: "Semana",
    today: "Hoy",
    from: "De",
    to: "A",
    reschedule_class_title: "Reagendar clase",
    reschedule_class_subtitle: "Confirma el cambio de fecha y hora para esta clase.",
    reschedule_class_hint: "La fecha original se ocultará del calendario y será reemplazada por la nueva.",
    reschedule_class_done: "Clase reagendada y notificada",
    confirm_reschedule: "Confirmar reagenda",
    mon_short: "Lun",
    tue_short: "Mar",
    wed_short: "Mié",
    thu_short: "Jue",
    fri_short: "Vie",
    sat_short: "Sáb",
    sun_short: "Dom",
    // Help center
    help: "Ayuda",
    help_title: "Manual de uso",
    help_subtitle: "Guía paso a paso de todo lo que puedes hacer en la plataforma según tu rol.",
    download_manual_pdf: "Descargar PDF",
    // CSV bulk import
    bulk_import_students: "Importar CSV",
    bulk_import_title: "Importación masiva de estudiantes",
    bulk_import_subtitle: "Sube un archivo CSV con columnas name, email, whatsapp, country.",
    download_template: "Descargar plantilla CSV",
    drop_csv_here: "Arrastra tu CSV aquí o haz clic para seleccionarlo",
    select_csv: "Seleccionar archivo",
    file_selected: "Archivo seleccionado",
    analyze_csv: "Analizar archivo",
    preview_results: "Resultado del análisis",
    rows_valid: "Filas válidas",
    rows_duplicate: "Duplicados (se omitirán)",
    rows_invalid: "Con errores (se omitirán)",
    rows_total: "Total filas",
    send_welcome_emails: "Enviar correo de bienvenida (magic link) a los creados",
    confirm_import: "Confirmar e importar",
    import_summary: "Resumen de importación",
    created_count: "estudiantes creados",
    skipped_count: "omitidos (duplicados)",
    emails_sent_count: "correos enviados",
    errors_count: "errores",
    import_again: "Importar otro archivo",
    csv_no_valid_rows: "No hay filas válidas para importar.",
    reason: "Motivo",
    language: "Idioma",
    role_pending: "Tu cuenta está pendiente de asignación de rol. Contacta al administrador.",
    settings: "Ajustes",
    enrollments: "Programas de clases",
    my_groups: "Mis programas",
    my_students: "Mis estudiantes",
    messages: "Mensajes",
    messages_subtitle: "Chat privado con tus profesores/estudiantes.",
    messages_subtitle_pass: "Escribile directo a la administración de la escuela.",
    dm_sec_staff: "Administración",
    gc_section: "Mis grupos",
    gc_subtitle: "Chat del grupo: lo ven tus compañeros y el profesor.",
    gc_empty: "Este es el inicio del chat del grupo. Escribile a tus compañeros y a tu profesor.",
    gc_placeholder: "Escribir en {g}",
    gc_teacher: "Profesor",
    gc_send_error: "No se pudo enviar",
    dm_sec_teachers: "Profesores",
    dm_sec_students: "Estudiantes",
    dm_sec_affiliates: "Afiliados",
    ann_button: "Mensaje a varios",
    ann_title: "Un mensaje para varias personas",
    ann_help: "El mensaje le llega a cada persona como un chat privado, así que si responden te responden solo a vos.",
    ann_audience: "¿A quién le llega?",
    ann_aud_all: "A todos",
    ann_aud_teachers: "A los profesores",
    ann_aud_students: "A los estudiantes",
    ann_aud_affiliates: "A los afiliados",
    ann_aud_group: "A un grupo",
    ann_aud_sede: "A una sede",
    ann_aud_my_students: "A mis estudiantes",
    ann_pick_group: "Elegí el grupo",
    ann_pick_sede: "Elegí la sede",
    ann_message: "Mensaje",
    ann_placeholder: "Escribí el mensaje…",
    ann_email_toggle: "Enviarlo también por correo",
    ann_email_hint: "Si lo apagás, solo aparece en la plataforma con su notificación.",
    ann_attach: "Adjuntar un archivo (opcional)",
    ann_send: "Enviar el mensaje",
    ann_sent: "Mensaje enviado a {n} personas",
    ann_error: "No se pudo enviar el mensaje",
    ann_need_text: "Escribí el mensaje",
    ann_need_group: "Elegí el grupo",
    ann_need_sede: "Elegí la sede",
    ann_history: "Enviados antes",
    ann_people: "personas",
    ann_with_email: "con correo",

    no_messages_available: "Aún no tienes conversaciones disponibles.",
    no_messages_yet: "Sin mensajes",
    pick_conversation: "Selecciona una conversación",
    no_results: "Sin resultados",
    open_dm: "Abrir chat",
    summary: "Resumen general",
    alerts: "Alertas",
    alerts_desc: "Eventos detectados automáticamente que requieren tu atención.",
    no_alerts: "Sin alertas registradas. ¡Todo en orden!",
    run_alerts: "Ejecutar análisis",
    alerts_done: "Análisis ejecutado",
    alert_absence: "Ausencias",
    alert_overdue: "Pago vencido",
    alert_absence_msg: "Acumuló {missed} ausencias en {program}, superando el límite del 25% ({allowed} permitidas).",
    alert_overdue_msg: "Pago de {amount} por {program} lleva {days} días vencido.",
    notified: "Notificados",
    just_now: "ahora",
    reports: "Reportes",
    reports_desc: "Ingresos, pagos y estudiantes consolidados por sede.",
    by_sede: "Por sede",
    paid_total: "Total pagado",
    pending_total: "Total pendiente",
    paid_last_30d: "Pagado últimos 30d",
    payments_paid_count: "# pagos",
    revenue_chart: "Ingresos por sede",
    unattributed_title: "Pagos sin sede asignada",
    unattributed_desc: "Hay pagos cuyo estudiante no está inscrito en ningún grupo de ese programa. Inscribe al estudiante para atribuir el ingreso correctamente:",
    you: "tú",
    users_invite_hint: "Comparte el link de la app con tu equipo; cuando inicien sesión aparecerán aquí.",
    teachers_invite_hint: "Profesores activos en la plataforma. Promueve a nuevos profesores cambiándoles el rol.",
    students_invite_hint: "Estudiantes registrados. Inscríbelos a grupos desde la pestaña Grupos.",
    delete_user_title: "¿Eliminar usuario?",
    delete_user_desc: "Se eliminará a {name} junto con sus programas de clases, asistencia y pagos. Esta acción no se puede deshacer.",
    applications: "Solicitudes",
    applications_desc: "Revisa y aprueba a los usuarios que solicitaron acceso.",
    no_applications: "No hay solicitudes pendientes.",
    view_details: "Ver detalles",
    view_user: "Ver usuario",
    view_no_enrollments: "Este estudiante aún no tiene programas de clases.",
    no_whatsapp: "Sin WhatsApp",
    no_payment_link: "Sin enlace de pago",
    no_bank_account: "Sin cuenta bancaria",
    no_amount: "Sin monto",
    country: "País",
    no_country: "Sin país",
    select_country: "Selecciona un país…",
    whatsapp_dial_label: "Código",
    whatsapp_number_placeholder: "Número (sin el +)",
    copied_to_clipboard: "Copiado al portapapeles",
    copy_email: "Copiar correo",
    magic_link_expired_title: "Enlace caducado o no válido",
    magic_link_expired_hint: "No te preocupes — escribe tu correo abajo y te enviaremos un enlace nuevo de 24 horas.",
    magic_link_sent_title: "¡Enlace enviado!",
    approve: "Aprobar",
    reject: "Rechazar",
    approve_as: "Aprobar como",
    approved: "Aprobado",
    rejected: "Rechazado",
    confirm_reject: "¿Rechazar esta solicitud? El usuario perderá acceso a la app.",
    // ----- Onboarding -----
    onboarding_title_student: "Cuéntanos un poco más de ti",
    onboarding_title_teacher: "Completa tu perfil de profesor",
    onboarding_subtitle: "Necesitamos esta información para activar tu cuenta. Solo te tomará un minuto.",
    onboarding_required_hint: "Los campos marcados con * son obligatorios.",
    onboarding_submit: "Activar mi cuenta",
    onboarding_saving: "Activando…",
    onboarding_success: "¡Listo! Tu cuenta está activada.",
    // ----- Policies & Conditions acceptance -----
    policies_accept_prefix: "He leído y acepto las",
    policies_link_text: "Políticas y Condiciones",
    policies_accept_suffix: "de We Speak Spanish CR",
    policies_page_title: "Políticas y Condiciones",
    policies_page_subtitle: "Hola {name}, antes de continuar necesitamos que confirmes que aceptas nuestras políticas y condiciones actuales.",
    policies_page_subtitle_reaccept: "Hola {name}, hemos actualizado nuestras políticas y condiciones. Necesitamos que las revises y las aceptes nuevamente para poder continuar.",
    policies_page_body: "Para poder seguir utilizando la plataforma, por favor lee nuestras Políticas y Condiciones actualizadas y marca la casilla de aceptación al final.",
    policies_page_body_reaccept: "Hemos hecho cambios en nuestras Políticas y Condiciones. Por favor léelas y confirma tu aceptación de la nueva versión.",
    policies_updated_title: "📄 Actualizamos nuestras Políticas y Condiciones",
    policies_updated_body: "Realizamos cambios importantes que queremos que conozcas. Por favor revisa el documento actualizado y marca tu aceptación para continuar usando la plataforma.",
    policies_whats_new: "Qué cambió",
    policies_menu_item: "Políticas y Condiciones",
    // ----- Auto-response global kill switch -----
    autoresponse_toggle_on_title: "Auto-respuestas personalizadas activadas",
    autoresponse_toggle_on_body: "Los prospectos reciben el email personalizado según su programa/sede. Si no existe una plantilla específica, se usa la plantilla por defecto del sistema.",
    autoresponse_toggle_off_title: "Usando plantilla por defecto del sistema",
    autoresponse_toggle_off_body: "Todos los prospectos siguen recibiendo email de bienvenida, pero se ignoran tus plantillas personalizadas y se envía la plantilla segura preprogramada del sistema. Útil mientras editas plantillas específicas sin dejar al prospecto sin respuesta.",
    autoresponse_status_active: "Personalizadas",
    autoresponse_status_paused: "Solo default",
    autoresponse_paused: "Ahora se envía la plantilla por defecto del sistema a todos los leads (se ignoran las personalizadas).",
    autoresponse_resumed: "Auto-respuestas personalizadas reactivadas.",
    autoresponse_reason_label: "Motivo",
    autoresponse_reason_input_label: "Motivo (opcional, solo para tu registro interno)",
    autoresponse_reason_placeholder: "Ej. Actualizando plantillas de emails…",
    policies_read_here: "Leer las Políticas y Condiciones",
    policies_accept_button: "Aceptar y continuar",
    policies_must_accept: "Debes aceptar las Políticas y Condiciones para continuar.",
    policies_accepted_success: "¡Gracias! Tu aceptación ha sido registrada.",
    saving: "Guardando…",
    view_profile_section: "Perfil",
    view_no_profile_data: "Sin datos. El usuario completará su perfil en su primer acceso.",
    edit_profile_section_title: "Perfil del usuario",
    field_date_of_birth: "Fecha de nacimiento",
    field_country_of_residence: "País donde vives",
    field_city: "Ciudad donde vives",
    field_occupation: "Ocupación",
    field_native_language: "Idioma nativo",
    field_how_did_you_hear: "¿Cómo nos conociste?",
    field_learning_goal: "¿Cuál es tu objetivo aprendiendo español?",
    field_has_learning_difficulty: "¿Tienes alguna condición que te dificulte aprender idiomas?",
    field_learning_difficulty_detail: "Cuéntanos brevemente",
    field_address: "Dirección",
    field_profession: "Profesión",
    field_languages_spoken: "Idiomas que hablas",
    field_languages_spoken_hint: "Selecciona uno o varios. Para agregar otro, escríbelo y presiona Enter.",
    field_emergency_contact_name: "Nombre del contacto de emergencia",
    field_emergency_contact_phone: "Teléfono del contacto de emergencia",
    field_meet_link: "Enlace de Google Meet",
    field_zoom_link: "Enlace de Zoom",
    field_meet_link_hint: "Pega tu enlace recurrente de Meet. Puedes elegir si lo usas o el de Zoom en cada grupo.",
    field_zoom_link_hint: "Pega tu enlace recurrente de Zoom. Puedes elegir si lo usas o el de Meet en cada grupo.",
    field_meet_platform: "Plataforma virtual",
    platform_default: "Por defecto",
    platform_meet: "Google Meet",
    platform_zoom: "Zoom",
    join_class: "Unirse a clase",
    join_class_meet: "Unirse por Meet",
    join_class_zoom: "Unirse por Zoom",
    start_class: "Iniciar clase",
    start_class_meet: "Iniciar clase de Meet",
    start_class_zoom: "Iniciar clase de Zoom",
    student_status: "Estado del estudiante",
    status_active: "Activo",
    status_inactive: "Inactivo",
    status_cancelled: "Cancelado",
    filter_all: "Todos",
    yes: "Sí",
    no: "No",
    pick_option: "Selecciona una opción",
    how_online_search: "Buscando escuelas de español en internet",
    how_facebook_group: "Grupo de Facebook",
    how_newspaper_ads: "Anuncio en el periódico",
    how_google_ads: "Google Ads",
    how_facebook_ads: "Facebook Ads",
    how_recommendation: "Por recomendación",
    how_street_signal: "Señal en la calle",
    how_banner: "Banner",
    how_flyers: "Volantes",
    how_walk_in: "Pasando frente a la escuela",
    how_another_school: "Otra escuela",
    how_webpage_ads: "Anuncio en otra página web",
    lang_spanish: "Español",
    lang_english: "Inglés",
    lang_french: "Francés",
    lang_portuguese: "Portugués",
    lang_german: "Alemán",
    lang_italian: "Italiano",
    lang_other: "Otro",
    // ===== Churn feedback (estudiantes cancelados) =====
    churn_feedbacks: "Feedback de bajas",
    churn_feedback_title: "Tu opinión nos importa",
    churn_feedback_intro: "Gracias por habernos elegido. Antes de despedirte, ¿podrías contarnos por qué te vas? Tu respuesta nos ayudará a mejorar la escuela.",
    churn_feedback_reasons_label: "¿Por qué decidiste irte? (puedes elegir más de una opción)",
    churn_feedback_comment_label: "¿Algo más que quieras compartir? (opcional)",
    churn_feedback_comment_placeholder: "Cuéntanos lo que sentiste durante tu tiempo con nosotros…",
    churn_feedback_submit: "Enviar opinión",
    churn_feedback_submitted_title: "¡Gracias por tu opinión!",
    churn_feedback_submitted_msg: "Tu respuesta quedó registrada. Si algún día decides volver, te estaremos esperando.",
    churn_feedback_invalid_link: "Este enlace no es válido o ya expiró.",
    churn_feedback_select_at_least_one: "Selecciona al menos un motivo",
    churn_feedback_already_submitted: "Esta encuesta ya fue respondida.",
    // Reasons (multi-select)
    churn_reason_price: "Precio muy alto / Razones económicas",
    churn_reason_no_time: "Falta de tiempo",
    churn_reason_expectations_not_met: "No cumplió mis expectativas",
    churn_reason_changed_school: "Cambié de escuela",
    churn_reason_achieved_goal: "Logré mi objetivo",
    churn_reason_teacher_or_group_issue: "Problema con el profesor / grupo",
    churn_reason_other: "Otro (escribe abajo)",
    // Admin dashboard
    churn_send_farewell_btn: "Enviar email de despedida",
    churn_farewell_sent_toast: "Email de despedida enviado",
    churn_farewell_error_toast: "No se pudo enviar el email",
    churn_total_sent: "Emails enviados",
    churn_total_submitted: "Respuestas recibidas",
    churn_response_rate: "Tasa de respuesta",
    churn_top_reasons: "Motivos más frecuentes",
    churn_all_responses: "Todas las respuestas",
    churn_filter_submitted: "Solo respondidas",
    churn_filter_pending: "Solo pendientes",
    churn_col_student: "Estudiante",
    churn_col_reasons: "Motivos",
    churn_col_comment: "Comentario",
    churn_col_sent: "Enviado",
    churn_col_status: "Estado",
    churn_status_pending: "Pendiente",
    churn_status_responded: "Respondido",
    churn_status_email_skipped: "Email no enviado",
    churn_empty: "Aún no hay feedback registrado.",
    churn_no_responses_yet: "Aún no hay respuestas.",
    // ===== CRM Lead Management =====
    admissions_lead_coordinator: "Coordinador de Admisiones",
    leads: "Leads",
    leads_analytics: "Estadísticas",
    leads_analytics_title: "Estadísticas de Leads",
    leads_analytics_subtitle: "Tasa de conversión y distribución por canal para tomar mejores decisiones.",
    leads_view_analytics: "Ver estadísticas",
    leads_title: "Gestión de Leads",
    leads_subtitle: "Prospectos capturados desde el sitio web y otros canales.",
    lead_templates: "Plantillas de Email",
    lead_automation: "Automatización",
    distribution: "Distribución",
    affiliates: "Afiliados",
    affiliate: "Afiliado",
    store_orders: "Pedidos de la tienda",
    courses_od: "Cursos On-Demand",
    my_courses_od: "Cursos On-Demand",
    my_portal: "Mi portal",
    // ----- WSS Live Sessions (Programa WSS Plus) -----
    live_sessions: "Sesiones WSS Live",
    live_pass: "Pases WSS GO",
    attendance_report: "Asistencia del mes",
    lp_pay: "Pagar {price}",
    lp_trial_days: "Prueba gratis · te quedan {n} días. Después son {price} al mes.",
    lp_trial_one_day: "Prueba gratis · te queda 1 día. Después son {price} al mes.",
    lp_trial_last_day: "Prueba gratis · hoy es el último día. Después son {price} al mes.",
    lp_pending_title: "Tu prueba terminó.",
    lp_pending_text: "Tu factura de {price} ya está en «Mis pagos». Seguís entrando unos días más mientras la pagás.",
    lp_blocked_title: "Tu acceso está en pausa.",
    lp_blocked_text: "No hemos recibido el pago del mes. Apenas lo registremos, vuelve todo: clases en vivo, conjugación y recursos.",
    lp_home_title: "Tu acceso a WSS Live está listo",
    lp_home_text: "Entrá a WSS Live en el menú y reservá las clases en vivo que quieras. También tenés el entrenador de conjugación y la biblioteca de recursos.",
    lp_home_cta: "Ver las clases disponibles",
    game_zone_import: "Traer los de Recursos",
    game_zone_import_none: "No encontré juegos de Kahoot ni Wordwall en Recursos (o ya están todos aquí)",
    game_zone_import_confirm: "Encontré {n} juego(s) en Recursos. ¿Los traigo a la Game Zone?",
    game_zone_import_done: "{n} juego(s) traídos a la Game Zone",

    sa_game_sub: "Jugá en línea con Kahoot y Wordwall",
    sa_game_count: "{n} juegos",
    sa_game_plays: "{n} partidas jugadas",

    game_zone: "WSS Game Zone",
    game_zone_sub: "Jugá y practicá sin salir de la plataforma. Elegí una categoría y arrancá.",
    game_zone_new_category: "Nueva categoría",
    game_zone_edit_category: "Editar categoría",
    game_zone_new_game: "Agregar juego",
    game_zone_edit_game: "Editar juego",
    game_zone_games: "juegos",
    game_zone_featured: "Destacados de la semana",
    game_zone_play_now: "Jugar ahora",
    game_zone_awards: "Tus galardones",
    game_zone_plays: "partidas",
    game_zone_empty: "Todavía no hay juegos. La escuela los va a ir agregando.",
    game_zone_category_empty: "Todavía no hay juegos en esta categoría.",
    game_zone_link: "Enlace del juego",
    game_zone_link_hint: "Pegá el enlace o el código para insertar: la plataforma reconoce sola si es de Kahoot o de Wordwall. Los de Kahoot tienen que estar públicos o «unlisted».",
    game_zone_feature_it: "Destacarlo esta semana",
    game_zone_any_level: "Cualquier nivel",
    game_zone_open_tab: "Abrir en una pestaña",
    game_zone_open_outside: "Este juego no se deja cargar aquí adentro. Abrilo en una pestaña con el botón de abajo.",
    category: "Categoría",
    your_level: "Tu nivel",

    email_change_cta: "Cambiar el correo de acceso",
    email_change_new: "Correo nuevo",
    email_change_apply: "Cambiar el correo",
    email_change_hint: "El cambio es inmediato. Al correo anterior le llega un aviso de que ya no sirve para entrar, y al nuevo que de ahora en adelante es su acceso.",
    email_change_confirm_q: "Revisá que esté bien escrito: la persona va a entrar con",
    email_change_confirm_yes: "Sí, cambiarlo",
    email_change_done: "Ahora entra con {email}",

    like: "Me gusta",
    resource_view_cards: "Ver en tarjetas",
    resource_view_list: "Ver en renglones",

    photo_week_label: "Semana del {from} al {to}",
    see_full_gallery: "Ver galería completa ({n})",

    gallery_sub: "Todas las fotos de la comunidad, incluidas las de semanas anteriores",
    gallery_caption_ph: "Pie de foto (opcional)",
    gallery_upload: "Subir fotos",
    gallery_pending_note: "Tus fotos quedan pendientes de autorización",
    gallery_all_photos: "Todas las fotos",
    gallery_sent_for_review: "Enviadas para autorización",
    gallery_published: "Fotos publicadas",
    gallery_upload_failed: "No se pudo subir",
    photo_caption_prompt: "Pie de foto",
    photo_caption_saved: "Pie de foto actualizado",
    photo_delete_confirm: "¿Borrar esta foto?",
    write_comment_ph: "Escribí un comentario",

    wall_news_title: "Noticias y comunicados",
    wall_see_all: "Ver todas",
    wall_empty_text: "Todavía no hay comunicados publicados",
    wall_comments_n: "{n} comentarios",

    sa_live_sub: "Clases en vivo todos los días",
    sa_conj_sub: "Entrená los verbos a tu ritmo",
    sa_conj_title: "Conjugación de verbos",
    sa_res_sub: "Guías, audios y material de clase",
    sa_live_none: "Ver la agenda",
    sa_live_today: "Hoy {time}",
    sa_live_tomorrow: "Mañana {time}",
    sa_conj_none: "Empezá hoy",
    sa_conj_verbs: "{n} verbos practicados",
    sa_res_count: "{n} materiales",
    sa_photos_title: "Fotos de la semana",
    sa_photos_sub: "Lo que pasó en la escuela",
    sa_photos_all: "Ver la galería",

    lp_admin_sub: "Quién entró por la página pública, quién está en cortesía y a quién hay que cobrarle.",
    ls_title: "Visitas de la landing WSS GO",
    ls_sub: "Contador propio, en hora de Costa Rica. No usa cookies.",
    ls_days: "{n} días",
    ls_visitors: "Personas",
    ls_views: "Aperturas",
    ls_signups: "Inscritos",
    ls_conversion: "Conversión",
    ls_empty: "Todavía nadie ha abierto la landing en este periodo. El contador arranca cuando se publique.",
    ls_chart_note: "Cada barra es un día. La rayita verde arriba marca los días con inscripciones.",
    ls_sources: "De dónde llegaron",
    ls_direct: "Directo (escribieron el enlace o lo abrieron de un mensaje)",

    lp_st_trial: "En cortesía",
    lp_st_invoiced: "Facturado",
    lp_st_active: "Al día",
    lp_st_blocked: "Bloqueado",
    lp_terms: "Condiciones de la oferta",
    lp_price: "Precio mensual",
    lp_trial_days_label: "Días de cortesía",
    lp_pay_link: "Enlace de pago",
    lp_terms_hint: "La factura se emite al terminar la cortesía; el recordatorio y el bloqueo salen 48 y 96 horas después.",
    lp_people: "Personas",
    lp_search: "Buscar por nombre o correo",
    lp_empty: "Todavía nadie se ha registrado por la página pública de WSS Live.",
    lp_col_person: "Persona",
    lp_col_status: "Estado",
    lp_col_trial_until: "Cortesía hasta",
    lp_col_paid_until: "Pagado hasta",
    lp_col_action: "Acción",
    lp_register_payment: "Registrar pago",
    lp_payment_hint: "Vas a marcar la factura del pase de {name} como pagada y a devolverle el acceso por un mes.",
    lp_confirm_convert: "¿Pasar a {name} a estudiante regular? El pase se corta hoy y WSS Live le queda incluido con su programa.",
    lp_converted: "Listo: ya es estudiante regular",
    lp_delete_title: "Borrar a {name}",
    lp_delete_hint: "Se elimina de la plataforma: pierde el acceso y se borran su matrícula y su asistencia.",
    lp_keep_history: "Conservar su historial de compras y sus facturas en el sistema",
    lp_deleted: "Persona eliminada",
    payment_method: "Forma de pago",
    cash: "Efectivo",
    deposit: "Depósito",
    card: "Tarjeta",
    unspecified: "Sin especificar",
    lp_sales_line: "Pases WSS Live",
    lp_embed: "Poné el formulario en tu sitio web",
    lp_embed_hint: "Copiá este código y pegalo en la página de tu sitio donde querés que la gente se registre. El formulario queda adentro de tu web y el código de 6 dígitos se valida ahí mismo.",
    lp_copy_embed: "Copiar el código",
    lp_open_public: "Ver la página pública",
    lp_confirm_payment: "¿Registrar el pago de {name} y reactivar su acceso por un mes?",
    lp_saved: "Condiciones guardadas",
    lp_active_until: "Acceso activo hasta {date}",
    live_sessions_sub: "Clases virtuales en vivo adicionales para todos los estudiantes activos",
    live_classes: "WSS Live",
    live_classes_sub: "Reserva sesiones virtuales en vivo incluidas en tu programa",
    live_new_session: "Nueva sesión",
    live_topic: "Tema de la sesión",
    live_activity_type: "Tipo de actividad",
    live_capacity: "Cupo",
    live_levels: "Niveles",
    live_levels_hint: "Si no eliges ninguno, la sesión será visible para todos los niveles.",
    live_all_levels: "Todos los niveles",
    live_meet_link: "Enlace de la reunión",
    live_meet_link_hint: "Si lo dejas vacío se usará tu enlace por defecto del perfil (primero Meet, luego Zoom).",
    live_meet_link_hint_admin: "Si lo dejas vacío se usará el enlace por defecto del profesor asignado (primero Meet, luego Zoom).",
    live_default_link: "Se usará este enlace",
    live_no_default_link: "⚠ El profesor no tiene enlace de Meet ni de Zoom en su perfil: escribí uno acá.",
    live_missing_link: "⚠ Sin enlace: este profesor no tiene Meet ni Zoom guardado en su perfil. Editá la sesión y pegá un enlace, o agregalo en el perfil del profesor (Usuarios → editar).",
    live_link_from_profile: "Usa el enlace del perfil del profesor",
    live_title_required: "El tema es obligatorio",
    live_sent_for_approval: "Sesión enviada para aprobación",
    live_status_all: "Todas",
    live_status_past: "Pasadas",
    live_status_completed: "Completada",
    live_past_summary: "{booked} reservados · {attended} asistieron",
    live_clone: "Clonar",
    live_clone_hint: "Se copia todo (tema, tipo, niveles, cupo, profe y materiales). Solo elegí la fecha y la hora nuevas.",
    live_cloned: "Sesión clonada. Buscala en la fecha nueva.",
    live_past_no_access: "Esta sesión ya terminó. El enlace de acceso se cerró, pero podés ver sus materiales.",
    live_status_proposed: "Por aprobar",
    live_status_published: "Publicada",
    live_status_rejected: "Rechazada",
    live_status_cancelled: "Cancelada",
    live_approve: "Aprobar",
    live_approved: "Sesión aprobada y publicada",
    live_reject: "Rechazar",
    live_reject_reason_ph: "Motivo (opcional)",
    live_rejected_reason: "Motivo",
    live_cancel_session: "Cancelar sesión",
    live_cancel_confirm: "¿Cancelar esta sesión? Se avisará a los inscritos.",
    live_cancelled_ok: "Sesión cancelada",
    live_roster: "Inscritos",
    live_no_bookings: "Aún no hay inscritos",
    live_confirmed: "Confirmado",
    live_waitlist: "Lista de espera",
    live_seats: "Inscritos",
    live_seats_left: "Cupos disponibles",
    live_email_prefs_title: "Correos de WSS Live",
    live_month_left_hint: "Clases WSS Live publicadas que están por venir",
    live_only_mine: "Solo mías",
    billing_profile: "Datos de facturación",
    billing_profile_hint: "Llená esto solo si la factura debe salir a nombre de una empresa. Si lo dejás vacío, la factura sale a nombre del estudiante.",
    billing_name: "Facturar a / Razón social",
    billing_tax_id: "Cédula jurídica",
    billing_activity_code: "Código de actividad económica",
    billing_location: "Lugar / dirección de facturación",
    billing_email: "Correo para la factura",
    billing_email_hint: "Recibe una copia de la factura además del estudiante.",
    guardian_title: "Padre / madre / tutor",
    guardian_hint: "Para menores de edad. Este correo puede entrar a ESTA cuenta con su propio código y recibe copia de las facturas y de los recordatorios de pago. Dejalo vacío si no aplica.",
    guardian_email: "Correo del padre/tutor",
    live_view_all: "Todas",
    live_all_weeks: "Todas las semanas",
    live_from_resources: "Desde Recursos",
    live_pick_resources: "Traer material de Recursos",
    live_from_resources_hint: "Elegí PDFs, videos, audios o enlaces que ya tenés en el banco de Recursos.",
    live_material_type_resource: "Recurso",
    live_month_summary: "{upcoming} clases próximas · {remaining} este mes",
    live_email_prefs_hint: "Elegí qué avisos querés recibir sobre las clases en vivo. Los recordatorios de las clases que ya reservaste y los avisos de cancelación se envían siempre.",
    live_email_weekly: "Agenda semanal (domingos)",
    live_email_weekly_hint: "Todas las clases de la semana que viene, con el botón para reservar.",
    live_email_daily: "Agenda del día (8 a.m.)",
    live_email_daily_hint: "Solo los días en que hay clases en vivo programadas.",
    live_save_attendance: "Guardar asistencia",
    live_explore: "Explorar",
    live_my_reservations: "Mis reservas",
    live_all_activities: "Todas las actividades",
    live_showing_for_level: "Mostrando sesiones para tu nivel",
    live_open_to_all: "Todas las sesiones están abiertas: podés participar en la que quieras, aunque no sea de tu nivel",
    live_assigned_teacher: "Profesor asignado",
    live_materials: "Materiales",
    live_upload_material: "Subir imagen o video",
    live_material_hint: "Documentos (PDF, Word, PowerPoint, Excel, TXT) hasta 25 MB · imágenes hasta 10 MB · videos hasta 50 MB. Podés seleccionar varios a la vez.",
    live_materials_added: "{n} materiales agregados",
    live_materials_locked: "Los materiales de esta sesión quedan disponibles solo para quienes estuvieron presentes.",
    live_add_link: "O pegá un enlace (YouTube, Drive, etc.)",
    live_no_materials: "Esta sesión todavía no tiene materiales",
    live_material_added: "Material agregado",
    live_material_type_image: "Imagen",
    live_material_type_video: "Video",
    live_material_type_link: "Enlace",
    live_open: "Abrir",
    live_session_materials: "Material de la sesión",
    live_download: "Descargar",
    menu: "Menú",
    payment_cancelled: "Anulado (la factura conserva su consecutivo)",
    invoice_number_short: "Nº Factura",
    cycle_mismatch_warning: "El sistema contabiliza",
    cycle_mismatch_dates: "Registros fuera del calendario del ciclo",
    cycle_mismatch_extra: "sesión extra/reprogramada",
    cycle_mismatch_offschedule: "día fuera del horario del grupo",
    cycle_mismatch_delete_confirm: "¿Eliminar el registro de asistencia del",
    live_tagline: "Tu español viaja contigo",
    live_view_week: "Semana",
    live_view_month: "Mes",
    live_timezone: "Hora de Costa Rica",
    live_see_next_week: "Ver la próxima semana",
    live_see_next_month: "Ver el próximo mes",
    live_pick_teacher: "Selecciona un profesor",
    live_no_level_set: "Aún no tienes un nivel asignado: te mostramos todas las sesiones disponibles.",
    live_no_sessions: "No hay sesiones disponibles por ahora",
    live_no_reservations: "Todavía no tienes reservas",
    live_reserve: "Reservar",
    live_join_waitlist: "Unirme a lista de espera",
    live_cancel_reservation: "Cancelar reserva",
    live_booked_ok: "¡Reserva confirmada!",
    live_waitlisted_ok: "Estás en lista de espera",
    live_unbooked_ok: "Reserva cancelada",
    live_you_are_waitlisted: "Estás en lista de espera. Te avisaremos si se libera un lugar.",
    live_join: "Entrar a la clase",
    live_stats: "Estadísticas",
    live_stat_sessions: "Sesiones",
    live_stat_bookings: "Reservas",
    live_stat_attended: "Asistencias",
    live_stat_rate: "% asistencia",
    live_top_sessions: "Sesiones más reservadas",
    live_demand_by_level: "Demanda por nivel",
    live_demand_by_hour: "Demanda por hora",
    live_top_students: "Estudiantes más activos",
    live_attended_short: "asistidas",
    live_type_conversation: "Conversación",
    live_type_grammar: "Gramática",
    live_type_pronunciation: "Pronunciación",
    live_type_five_finger: "Five-Finger System",
    live_type_costa_rican_spanish: "Español costarricense",
    live_type_everyday_spanish: "Español cotidiano",
    live_type_listening: "Comprensión auditiva",
    live_type_qa: "Preguntas y respuestas",
    live_type_other: "Otra",
    spanish_level: "Nivel de español",
    // ----- Automation (Scheduled Newsletters + Follow-up Rules) -----
    automation_page_title: "Automatización de leads",
    automation_page_subtitle: "Programa envíos y crea reglas de seguimiento que trabajan por ti.",
    automation_tab_scheduled: "Envíos programados",
    automation_tab_rules: "Reglas de seguimiento",
    automation_tab_settings: "Ajustes",
    // Tracking settings
    tracking_settings_title: "Tracking de correos (Resend webhooks)",
    tracking_settings_desc: "Registra automáticamente cuándo se abre, se hace click o rebota cada correo.",
    tracking_settings_active: "Activo",
    tracking_settings_not_configured: "No configurado",
    tracking_settings_steps_title: "Cómo activarlo:",
    tracking_settings_step1: "Entra a",
    tracking_settings_step2: "Crea un webhook con esta URL:",
    tracking_settings_step3: "Marca los 6 eventos: sent, delivered, opened, clicked, bounced, complained.",
    tracking_settings_step4: "Copia el Signing Secret (whsec_...) y pégalo abajo.",
    tracking_settings_secret_label: "Signing Secret de Resend",
    tracking_settings_save: "Guardar",
    tracking_settings_saved: "Secret guardado. El tracking ya está activo.",
    tracking_settings_save_error: "Error al guardar",
    tracking_settings_invalid_secret: "El secret debe empezar con \"whsec_\"",
    tracking_settings_url_copied: "URL copiada",
    tracking_settings_currently: "Actualmente configurado desde {source}. Termina en:",
    tracking_settings_source_env: "variable de entorno",
    tracking_settings_source_db: "base de datos",
    maintenance_title: "Mantenimiento",
    orphans_title: "Limpiar facturas huérfanas",
    orphans_desc: "Elimina facturas pendientes cuyo programa ya fue eliminado (útil para limpiar datos de prueba).",
    orphans_run: "Limpiar ahora",
    orphans_removed: "{n} factura(s) huérfana(s) eliminada(s)",
    orphans_none: "No hay facturas huérfanas — todo limpio",
    orphans_error: "Error al limpiar",
    orphans_last: "Última limpieza",
    automation_scheduled_title: "Newsletters programados",
    automation_scheduled_desc: "Programa un correo hacia un segmento específico de leads. Se enviará automáticamente en la fecha y hora indicadas.",
    automation_scheduled_empty: "No hay envíos programados. Crea uno para empezar.",
    automation_new_scheduled: "Programar envío",
    automation_new_scheduled_desc: "Redacta el correo y elige a quién enviárselo. El sistema lo dispara automáticamente en el momento indicado.",
    automation_label: "Nombre interno (opcional)",
    automation_label_placeholder: "Ej. Recordatorio Clase Introductoria — julio",
    automation_subject: "Asunto",
    automation_body: "Cuerpo del correo (HTML)",
    automation_vars_hint: "Variables disponibles: {name} · {first_name} · {last_name} · {full_name} · {email} · {group} · {campus}",
    automation_when: "Fecha y hora de envío",
    automation_campus: "Sede",
    automation_status_filter: "Filtrar por clasificación (opcional)",
    automation_status_filter_hint: "Deja vacío para enviar a TODOS los leads con email. Selecciona una o más para segmentar.",
    automation_exclude_converted: "Excluir leads ya convertidos a estudiantes",
    automation_preview_recipients: "Ver destinatarios",
    automation_preview_total: "Destinatarios: {n}",
    automation_preview_error: "No se pudo calcular la vista previa",
    automation_preview_ok: "{n} lead(s) coinciden con esta regla ahora mismo",
    automation_required_fields: "Completa el asunto, cuerpo y fecha",
    automation_must_be_future: "La fecha debe estar en el futuro",
    automation_scheduled_ok: "Envío programado correctamente",
    automation_scheduled_error: "Error al programar el envío",
    automation_schedule_button: "Programar",
    automation_cancel_title: "¿Cancelar envío programado?",
    automation_cancel_desc: "Este envío no se disparará. Puedes crear otro más adelante.",
    automation_cancel_confirm: "Cancelar envío",
    automation_cancelled_ok: "Envío cancelado",
    automation_cancel_error: "No se pudo cancelar",
    automation_delete_record: "Eliminar de la lista",
    automation_delete_record_title: "¿Eliminar este envío del historial?",
    automation_delete_record_desc: "El correo ya se envió (o fue cancelado). Esto solo quita el registro de la lista para mantenerla limpia. Los correos ya enviados no se ven afectados.",
    automation_sn_status_pending: "Programado",
    automation_sn_status_sending: "Enviando…",
    automation_sn_status_sent: "Enviado",
    automation_sn_status_cancelled: "Cancelado",
    automation_sn_status_failed: "Fallido",
    // Rules
    automation_rules_title: "Reglas de seguimiento automático",
    automation_rules_desc: "Cuando un lead pase X días en una clasificación sin moverse, envía un correo de seguimiento.",
    automation_rules_empty: "Aún no tienes reglas activas.",
    automation_rules_example: "Ej. \"Clase Introductoria +3 días sin respuesta → recordatorio suave\"",
    automation_new_rule: "Nueva regla",
    automation_edit_rule: "Editar regla",
    automation_rule_dialog_desc: "Define cuándo se dispara el seguimiento y qué correo se envía.",
    automation_rule_name: "Nombre",
    automation_rule_name_placeholder: "Ej. Seguimiento 2 días — Contactados",
    automation_rule_source_status: "Clasificación origen",
    automation_rule_days_after: "Días sin cambios",
    automation_rule_summary: "Después de {days} día(s) en \"{status}\" sin actividad → envía correo",
    automation_rule_stats: "Enviados: {sent} · Última ejecución: {last}",
    automation_active: "Activa",
    automation_paused: "Pausada",
    automation_edit: "Editar",
    automation_save_rule: "Guardar regla",
    automation_rule_saved: "Regla guardada",
    automation_rule_save_error: "Error al guardar la regla",
    automation_rule_deleted: "Regla eliminada",
    automation_rule_delete_error: "Error al eliminar",
    automation_delete_rule: "¿Eliminar esta regla?",
    automation_delete_rule_desc: "No se enviarán nuevos correos con esta regla. Los ya enviados permanecen.",
    automation_delete: "Eliminar",
    automation_load_error: "Error al cargar",
    // ----- Distribution Kit -----
    distribution_title: "Distribución de contenido",
    distribution_subtitle: "Convierte tu último blog en copy listo para todos los canales — con ayuda de IA.",
    distribution_new_kit: "Nuevo kit con IA",
    distribution_empty_title: "Aún no has creado ningún kit",
    distribution_empty_body: "Ingresa el título y un resumen de tu blog post, y la IA genera todo el copy para Facebook, Instagram, LinkedIn, Twitter, email y Reels — listo para copiar y pegar.",
    distribution_new_kit_title: "Nuevo kit de distribución",
    distribution_new_kit_desc: "Cuéntale a la IA de qué trata tu blog post. Ella se encarga del resto.",
    distribution_form_title: "Título del blog post",
    distribution_form_url: "URL del blog post (opcional)",
    distribution_form_summary: "Resumen del contenido",
    distribution_form_summary_placeholder: "En 2-3 oraciones, explica de qué trata el post y qué aprenderá el lector. Sé específico: es lo que la IA usa para generar todo el copy.",
    distribution_form_campus: "Sede",
    distribution_form_tone: "Tono",
    distribution_form_language: "Idioma",
    distribution_tone_warm: "Cálido",
    distribution_tone_pro: "Profesional",
    distribution_tone_fun: "Divertido",
    distribution_generation_notice: "La generación tarda ~1 min. Puedes cerrar esta ventana y volver luego — el kit se actualiza solo.",
    distribution_generate: "Generar con IA",
    distribution_form_required: "Título y resumen son obligatorios",
    distribution_kit_queued: "Kit en cola. La IA está trabajando en segundo plano…",
    distribution_load_error: "Error cargando kits",
    distribution_delete_confirm: "¿Eliminar este kit?",
    distribution_pending_title: "Generando con IA…",
    distribution_pending_body: "Esto tarda cerca de un minuto. La ventana se actualiza sola cuando esté listo.",
    distribution_failed_title: "Falló la generación",
    distribution_failed_body: "Intenta de nuevo o revisa el resumen.",
    distribution_status_pending: "Generando",
    distribution_status_ready: "Listo",
    distribution_status_failed: "Falló",
    distribution_channels_published: "publicados",
    distribution_fb_variants: "Facebook — 5 variantes",
    distribution_instagram: "Instagram",
    distribution_linkedin: "LinkedIn",
    distribution_twitter: "Twitter / X — Thread",
    distribution_email: "Newsletter (Email)",
    distribution_reels: "Reels / Shorts — 3 ideas",
    distribution_reels_hook: "Idea",
    distribution_email_subject: "Asunto",
    distribution_email_body: "Cuerpo (HTML)",
    distribution_copy_full_thread: "Copiar todo el thread",
    distribution_copy_subject: "Copiar asunto",
    distribution_copy_body: "Copiar cuerpo",
    distribution_mark_published: "Marcar como publicado",
    distribution_marked_published: "Publicado",
    distribution_copied: "Copiado al portapapeles",
    // ----- Newsletter dispatch -----
    newsletter_send_button: "Enviar newsletter",
    newsletter_sending: "Enviando…",
    newsletter_dialog_title: "Enviar newsletter",
    newsletter_dialog_desc: "Envía este email a un segmento de leads y/o estudiantes. Personaliza el {name} para cada destinatario automáticamente.",
    newsletter_audience: "¿A quién enviar?",
    newsletter_audience_leads: "Solo leads (prospectos)",
    newsletter_audience_students: "Solo estudiantes activos",
    newsletter_audience_both: "Leads + estudiantes",
    newsletter_lead_statuses: "Filtrar leads por estado",
    newsletter_campus_filter: "Filtro de sede",
    newsletter_preview_btn: "Previsualizar destinatarios",
    newsletter_preview_total: "{count} destinatarios elegibles",
    newsletter_test_email_label: "Enviar prueba a un email primero (recomendado)",
    newsletter_send_test: "Enviar prueba",
    newsletter_test_hint: "Envía solo a esta dirección para revisar cómo se ve antes del envío masivo.",
    newsletter_test_email_required: "Ingresa un email para la prueba",
    newsletter_test_queued: "Email de prueba enviado.",
    newsletter_queued: "Newsletter en cola. Se están enviando los emails en segundo plano.",
    newsletter_confirm_send: "¿Enviar el newsletter a {count} destinatarios? Esta acción NO se puede deshacer.",
    newsletter_send_to_count: "Enviar a {count}",
    newsletter_last_sent: "Último envío: {sent} emails · {when}",
    newsletter_failed: "fallaron",
    more: "más",
    lead_templates_title: "Plantillas de Email por Sede",
    lead_templates_subtitle: "Personaliza el correo automático que se envía cuando un lead completa el formulario.",
    lead_status_new: "Nuevos",
    lead_status_introductory_class: "Clase Introductoria",
    lead_status_introductory_attended: "Asistió",
    lead_status_introductory_no_show: "No asistió",
    lead_status_contacted: "Contactados",
    lead_column_new: "Nuevos",
    lead_column_introductory_class: "Nuevos",
    lead_column_introductory_attended: "Asistió",
    lead_column_introductory_no_show: "No asistió",
    lead_column_contacted: "Contactados",
    lead_column_interview_meeting: "Entrevista",
    lead_column_send_info: "Enviar Info",
    lead_column_info_ready: "Info Lista",
    lead_column_enrolled: "Registrados",
    lead_column_later: "En el futuro",
    lead_column_not_interested: "No interesados",
    lead_column_archived: "Archivados",
    lead_tab_pipeline: "Pipeline",
    lead_tab_introductory: "Introductoria",
    lead_tab_archived: "Archivados",
    lead_archived_active: "Activos",
    lead_archived_inactive: "Inactivos",
    lead_archived_later: "En el futuro",
    lead_archived_not_interested: "No interesados",
    lead_status_interview_meeting: "Entrevista",
    lead_status_send_info: "Enviar Info",
    lead_status_info_ready: "Info Lista",
    lead_status_enrolled: "Registrados",
    lead_status_later: "En el futuro",
    lead_status_not_interested: "No interesados",
    lead_campus_general: "General",
    lead_campus_santa_ana: "Santa Ana",
    lead_campus_atenas: "Atenas",
    lead_campus_grecia: "Grecia",
    lead_campus_online: "Online",
    lead_filter_all_campuses: "Todas las sedes",
    lead_no_leads_column: "Sin leads",
    lead_add_note: "Agregar nota",
    lead_note_placeholder: "Escribe una nota, por ejemplo: le llamé por WhatsApp…",
    lead_save_note: "Guardar nota",
    lead_timeline: "Historial",
    lead_status: "Estado",
    lead_source_url: "Origen (URL)",
    lead_program: "Programa de interés",
    lead_referred: "¿Cómo nos conoció?",
    lead_message: "Mensaje",
    lead_form_answers: "Respuestas del formulario",
    lead_email_history: "Historial de correos",
    lead_email_bounced_title: "Este email rebotó",
    lead_email_complained_title: "Este destinatario marcó nuestros correos como spam",
    lead_email_invalid_desc: "Ya no se le enviarán correos automáticos, newsletters ni seguimientos hasta que actualices el email.",
    // Email status pills
    email_status_sent: "Enviado",
    email_status_delivered: "Entregado",
    email_status_opened: "Abierto",
    email_status_clicked: "Click",
    email_status_bounced: "Rebotado",
    email_status_complained: "Spam",
    email_status_failed: "Falló",
    email_bounce_generic: "Email no válido",
    email_campaign_auto_response: "Auto-respuesta",
    email_campaign_scheduled_newsletter: "Newsletter programado",
    email_campaign_followup_rule: "Seguimiento automático",
    email_campaign_distribution_newsletter: "Newsletter (Distribution Kit)",
    email_campaign_manual_lead_email: "Correo manual",
    email_campaign_unknown: "—",
    // Stats modal
    email_stats_title: "Detalles de envío",
    email_stats_desc: "Estado de cada correo con datos en tiempo real de Resend.",
    email_stats_view_button: "Ver detalles",
    email_stats_total: "Total",
    email_stats_delivered: "Entregados",
    email_stats_opened: "Abiertos",
    email_stats_bounced: "Rebotados",
    email_stats_recipient: "Destinatario",
    email_stats_status: "Estado",
    email_stats_sent_at: "Enviado",
    email_stats_details: "Detalle",
    email_stats_empty: "Aún no hay datos. Los eventos aparecen apenas Resend nos notifica.",
    lead_created: "Creado",
    lead_updated: "Actualizado",
    lead_delete: "Eliminar lead",
    lead_delete_confirm: "¿Seguro que quieres eliminar este lead? Esta acción es permanente.",
    lead_open_email: "Enviar email",
    lead_open_whatsapp: "Abrir WhatsApp",
    lead_no_program: "Sin programa seleccionado",
    lead_days_ago: "hace {n}d",
    lead_hours_ago: "hace {n}h",
    lead_just_now: "recién",
    lead_open_detail: "Ver detalle",
    lead_search_placeholder: "Buscar por nombre, email o programa…",
    template_edit: "Editar plantilla",
    template_reset: "Restaurar plantilla original",
    template_reset_confirm: "¿Restaurar la plantilla de {campus} a la versión original? Perderás las modificaciones.",
    template_subject: "Asunto",
    template_body: "Cuerpo del email (HTML)",
    template_preview: "Vista previa",
    template_save: "Guardar plantilla",
    template_cancel: "Cancelar",
    template_saved: "Plantilla guardada",
    template_reset_done: "Plantilla restaurada",
    template_variables_help: "Variables disponibles",
    template_variables_note: "Puedes usar estas variables en el asunto y cuerpo: {name} = nombre (saludo personal), {last_name} = apellido, {full_name} = nombre + apellido, {email}, {group}, {campus}, {whatsapp}, {message}, {referred}",
    template_is_default: "Sin personalizar (usando plantilla original)",
    template_is_custom: "Personalizada",
    lead_stats_total: "Total",
    lead_convert_to_student: "Convertir a estudiante",
    lead_convert_coming_soon: "La conversión a estudiante estará disponible en la siguiente fase.",
    lead_notes: "Notas internas",
    lead_notes_placeholder: "Notas visibles solo para el equipo…",
    lead_notes_saved: "Nota interna guardada",
    lead_event_created: "Lead creado",
    lead_event_auto_response_sent: "Auto-respuesta enviada",
    lead_event_status_changed: "Estado cambiado",
    lead_event_notes_updated: "Notas actualizadas",
    lead_event_assigned: "Asignado",
    lead_event_note: "Nota",
    lead_event_call: "Llamada",
    lead_event_email_sent: "Email enviado",
    lead_event_whatsapp_sent: "WhatsApp enviado",
    lead_pipeline_moved: "Lead movido a {status}",
    template_editor_bold: "Negrita",
    template_editor_italic: "Cursiva",
    template_editor_underline: "Subrayado",
    template_editor_h1: "Título 1",
    template_editor_h2: "Título 2",
    template_editor_h3: "Título 3",
    template_editor_bullet: "Lista con viñetas",
    template_editor_ordered: "Lista numerada",
    template_editor_link: "Insertar enlace",
    template_editor_image: "Insertar imagen",
    template_editor_left: "Alinear a la izquierda",
    template_editor_center: "Centrar",
    template_editor_right: "Alinear a la derecha",
    template_editor_justify: "Justificar",
    template_editor_link_prompt: "URL del enlace:",
    template_editor_image_prompt: "URL de la imagen:",
    template_body_placeholder: "Redacta aquí el cuerpo del email con la información del programa…",
    template_new: "Nueva plantilla",
    template_add_program: "Agregar plantilla por programa",
    template_program_label: "Programa (opcional)",
    template_program_placeholder: "Ej: Private Classes in person - 8hrs package",
    template_program_hint: "Selecciona un programa de la lista (▼) para evitar typos. Si lo dejas vacío, será la plantilla de respaldo para toda la sede. Para agregar nuevos programas, usa \"Configurar programas\" en la sede.",
    template_campus_fallback: "Plantilla de respaldo de la sede",
    template_campus_fallback_hint: "Se usa cuando no hay plantilla específica para el programa solicitado.",
    template_program_specific: "Plantilla específica de programa",
    template_drag_hint: "Arrastra para reordenar por importancia",
    template_program_count: "programas configurados",
    template_no_program_templates: "Aún no hay plantillas específicas por programa en {campus}. Se usará la de respaldo.",
    template_delete: "Eliminar plantilla",
    template_delete_confirm: "¿Eliminar esta plantilla? Los leads futuros usarán la plantilla de respaldo de la sede.",
    template_resolution_note: "Se envía la plantilla específica del programa si existe. Si no, se usa la plantilla de respaldo de la sede. Si tampoco existe, se usa la plantilla original.",
    group_no_meet_link: "Sin enlace configurado",
    group_no_meet_link_hint: "Este grupo no tiene enlace de Zoom o Google Meet. Edítalo para agregar uno antes de la próxima clase.",
    template_duplicate: "Duplicar",
    template_duplicate_title: "Duplicar plantilla",
    template_duplicate_hint: "Se creará una copia con el mismo contenido. Puedes cambiarlo antes de guardar.",
    template_bulk_seed: "Cargar programas en lote",
    // ----- Programs Manager (source of truth for program names per campus) -----
    programs_manager_button: "Configurar programas",
    programs_manager_button_hint: "Gestiona la lista de programas de esta sede — para evitar typos al crear plantillas",
    programs_manager_title: "Programas de {campus}",
    programs_manager_desc: "Esta es la lista maestra de programas para esta sede. Sus nombres se usan como opciones del dropdown al crear plantillas de email.",
    programs_manager_hint: "IMPORTANTE: Los nombres que agregues aquí deben coincidir EXACTAMENTE con las opciones del <select> en tu formulario de Contact Form 7 en WordPress. Usa el botón \"Copiar lista\" para pegarlos idénticos.",
    program_add_placeholder: "Ej. Classes for Beginners A1, Mon/Wed at 8:15 am",
    program_added: "Programa agregado",
    program_renamed: "Programa renombrado (y plantilla ligada actualizada)",
    program_deleted: "Programa eliminado",
    program_delete_confirm: "¿Eliminar el programa \"{name}\"? La plantilla vinculada NO se borra (queda huérfana).",
    program_copy_list: "Copiar solo los nombres",
    program_copy_cf7: "Copiar shortcode CF7",
    program_list_copied: "Nombres copiados. Pégalos como opciones del <select> en tu Contact Form 7.",
    program_cf7_copied: "Shortcode CF7 copiado. Reemplaza tu [select* menu-XXX ...] actual con este.",
    programs_empty_state: "Aún no hay programas configurados para esta sede.",
    // ----- Duplicate lead detection -----
    lead_duplicates_title: "⚠️ Este contacto te escribió antes ({count})",
    lead_duplicates_desc: "Encontramos otros leads con el mismo email o WhatsApp. Revísalos antes de contactarlo de nuevo.",
    lead_duplicates_more: "más…",
    // ----- Source stats pie chart -----
    source_stats_title: "Leads por canal",
    source_stats_subtitle: "{total} leads en los últimos {days} días",
    source_stats_empty: "Aún no hay leads en este periodo.",
    done: "Listo",
    add: "Agregar",
    template_bulk_seed_title: "Cargar plantillas en blanco por programa",
    template_bulk_seed_desc: "Pega los nombres de los programas (uno por línea). Se creará una plantilla en blanco para cada uno usando el mismo asunto y cuerpo que la plantilla de respaldo de la sede.",
    template_bulk_seed_placeholder: "Classes for Beginners A1, Mon/Wed at 8:15 am\nClasses for Intermediates, Mon/Wed at 10:15 am\nPrivate Classes in person - 8hrs package\nPrivate Classes in person - 12hrs package",
    template_bulk_seed_confirm: "Crear plantillas en blanco",
    template_bulk_seed_done: "Se crearon {n} plantillas nuevas",
    template_bulk_seed_none: "No hay programas nuevos para agregar",
    lead_convert: "Convertir a estudiante",
    lead_edit: "Editar",
    lead_edit_title: "Editar información del lead",
    lead_edit_desc: "Modifica los datos de contacto del prospecto. Si corriges un email rebotado, se reactivará en los envíos automáticos.",
    lead_edit_name: "Nombre",
    lead_edit_last_name: "Apellido",
    lead_edit_email: "Correo",
    lead_edit_whatsapp: "WhatsApp",
    lead_edit_campus: "Sede",
    lead_edit_group: "Programa / Grupo",
    lead_edit_referred: "¿Quién nos recomendó?",
    lead_edit_save: "Guardar cambios",
    lead_edit_saved: "Cambios guardados",
    lead_edit_error: "Error al guardar",
    lead_edit_name_required: "El nombre es requerido",
    lead_edit_email_required: "El correo es requerido",
    lead_convert_title: "Convertir lead a estudiante",
    lead_convert_desc: "Crea el usuario estudiante y su inscripción. El lead se marcará como enrolado automáticamente.",
    lead_convert_desc_v2: "Crea la cuenta del estudiante con los datos del lead. La inscripción a grupo y el pago se configuran después desde Estudiantes.",
    lead_convert_confirm: "Crear cuenta y enviar correo",
    lead_convert_summary: "Se creará la cuenta con:",
    lead_convert_next_steps_title: "Qué pasa después:",
    lead_convert_step1: "Enviamos un correo con enlace mágico. Al entrar, el estudiante completa su perfil (país, foto) y acepta las políticas.",
    lead_convert_step2: "Se le mostrará un enlace al manual del estudiante para consultarlo cuando quiera.",
    lead_convert_step3: "Luego lo inscribes al grupo/programa desde Estudiantes → Editar → Añadir programa de clases.",
    lead_convert_group: "Grupo o clase privada",
    lead_convert_group_placeholder: "Selecciona un grupo",
    lead_convert_start_date: "Fecha de inicio",
    lead_convert_amount: "Monto del ciclo (USD, opcional)",
    lead_convert_classes: "Clases incluidas (opcional)",
    lead_convert_paid_on_start: "Marcar como pagado desde el inicio",
    lead_convert_send_welcome: "Enviar email de bienvenida",
    lead_convert_success: "Estudiante creado y lead marcado como enrolado",
    lead_convert_error: "Error al convertir",
    lead_converted_at: "Convertido el {date}",
    lead_converted_badge: "Convertido",
    lead_convert_missing_group: "Debes elegir un grupo",
    // Manual lead + Sources + Chart
    manual_lead_add: "Nuevo lead",
    manual_lead_title: "Agregar lead manualmente",
    manual_lead_desc: "Registra un prospecto que llegó por WhatsApp, llamada, referido o cualquier otro canal fuera del sitio web.",
    manual_lead_name: "Nombre",
    manual_lead_last_name: "Apellido",
    manual_lead_email: "Email (opcional)",
    manual_lead_whatsapp: "WhatsApp",
    manual_lead_initial_note: "Nota inicial (opcional)",
    manual_lead_initial_note_placeholder: "Ej: Me escribió preguntando por precios del A1, dice que tiene tiempo libre en las mañanas.",
    manual_lead_send_auto: "Enviar correo de bienvenida",
    manual_lead_template: "Correo que se va a enviar",
    manual_lead_template_auto: "Automático (según sede y programa)",
    manual_lead_template_default: "predeterminada",
    manual_lead_template_general: "General",
    manual_lead_template_hint: "Al elegir un correo de la lista se manda ese y se anula el automático.",
    manual_lead_create: "Crear lead",
    manual_lead_created: "Lead creado",
    manual_lead_error: "Error al crear el lead",
    manual_lead_missing_name: "Debes indicar el nombre",
    manual_lead_missing_contact: "Debes indicar al menos WhatsApp o email",
    lead_source_wordpress_cf7: "Sitio Web",
    lead_source_whatsapp: "WhatsApp",
    lead_source_phone: "Llamada",
    lead_source_referral: "Referido",
    lead_source_instagram: "Instagram",
    lead_source_manual: "Manual",
    lead_filter_all_sources: "Todos los canales",
    lead_campus: "Sede",
    conversion_chart_title: "Tasa de conversión mensual",
    conversion_chart_subtitle: "Leads creados vs. matriculados en los últimos 6 meses",
    conversion_chart_created: "Creados",
    conversion_chart_enrolled: "Matriculados",
    conversion_chart_active_now: "activos hoy",
    conversion_chart_current_month_note: "• El mes en curso todavía está incompleto",
    conversion_chart_rate: "Conversión",
    conversion_chart_no_data: "Aún no hay leads suficientes para calcular la tasa de conversión.",
    editor_font_size: "Tamaño de letra",
    editor_font_size_default: "Tamaño",
    editor_text_color: "Color de texto",
    editor_highlight_color: "Color de resaltado",
    editor_indent: "Aumentar sangría",
    editor_outdent: "Disminuir sangría",
    editor_horizontal_rule: "Línea divisora",
    editor_clear_format: "Limpiar formato",
    editor_live_preview: "Vista previa en vivo",
    editor_tab_visual: "Visual",
    editor_tab_html: "HTML",
  },
  en: {
    app_name: "We Speak Spanish",
    tagline: "School management platform",
    login_title: "Welcome",
    login_subtitle: "Sign in to access your dashboard",
    login_google: "Sign in with Google",
    logout: "Sign out",
    dashboard: "Dashboard",
    sedes: "Campuses",
    programs: "Programs",
    mail_center: "Mail center",
    users: "Users",
    teachers: "Teachers",
    students: "Students",
    groups: "Groups",
    payments: "Payments",
    journal: "Journal",
    attendance: "Attendance",
    my_attendance: "My Attendance",
    my_payments: "My Payments",
    overview: "Overview",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    change: "Change",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    name: "Name",
    email: "Email",
    role: "Role",
    address: "Address",
    description: "Description",
    price: "Price",
    duration_months: "Duration (months)",
    classes_included: "Classes included",
    classes_consumed: "Classes taken",
    classes_progress: "Class progress",
    invoice_sent: "Invoice sent",
    invoices_sent: "Invoices sent",
    run_billing: "Run billing",
    run_billing_desc: "Process invoices for completed cycles and send pending reminders.",
    billing_done: "Billing processed",
    weekly_summary: "Send weekly summary",
    weekly_summary_done: "Summary sent to",
    weekly_summary_desc: "Automatic every Monday; you can trigger it manually anytime.",
    cycle: "Cycle",
    sede: "Campus",
    program: "Program",
    teacher: "Teacher",
    student: "Student",
    academic_director: "Academic Director",
    is_private: "Private",
    schedule: "Schedule",
    schedule_days: "Days",
    schedule_time: "Time",
    start_time: "Start",
    end_time: "End",
    start_date: "Start date",
    start_date_hint: "Marks the start of the cycle. Leave blank if you don't know when it starts yet — the welcome email will say the schedule is pending. If the program has a price, a pending payment is auto-created with this due date.",
    edit_start_date: "Edit start date",
    no_start_date: "No start date",
    invite_user: "Invite user",
    invite_teacher: "Invite teacher",
    invite_student: "Invite student",
    or: "or",
    magic_link_send: "Send me a sign-in link",
    magic_link_hint: "Use the email you were registered with on the platform.",
    login_receive_code_btn: "Send me a sign-in code",
    login_or_other_method: "or choose another method",
    login_magic_link_btn: "Send me a magic link instead",
    login_code_sent_intro: "We sent a 6-digit code to",
    login_code_sent_hint: "Enter it below to sign in:",
    login_submit_code_btn: "Sign in with code",
    login_code_not_received: "Didn't get it?",
    login_retry: "Try again",
    login_check_your_email: "Check your email",
    login_link_sent_intro: "We sent a sign-in link to",
    login_link_sent_hint: "Open it on the same device to sign in. If it doesn't arrive in 2 minutes, check your spam folder.",
    login_back: "← Back",
    login_invalid_code: "Invalid or expired code",
    login_code_must_be_6: "The code must be 6 digits",
    login_code_check_email: "Check your email for the code",
    magic_link_resend: "Resend link",
    magic_link_sent: "If your email is registered, you'll receive a link shortly.",
    magic_link_check_email: "Check your inbox and click the sign-in link.",
    invite_user_hint: "The user will receive an email with a one-time magic link to activate their account.",
    invite_sent_to: "Invitation sent to",
    invite_enroll_section: "Enroll in a group (optional)",
    invite_enroll_hint: "If you pick a group, the student will be enrolled when they activate their account. A pending payment is created when the program has a price and a start date is set.",
    invite_select_group: "Select a group (optional)",
    invite_add_program: "Add program",
    default_price: "Default price",
    program_type: "Program type",
    any_program: "Any program",
    bank_account: "Bank account",
    bank_account_select_placeholder: "Pick an account…",
    bank_account_none: "No bank deposit",
    bank_account_select_hint: "Will appear in the student's welcome email next to the amount to deposit.",
    edit_user: "Edit user",
    edit_add_program_section: "Enroll in more programs",
    edit_add_program_hint: "New enrollments are created on save. Each one generates a pending payment when it has a start date and amount > 0.",
    resend_magic_link: "Resend invitation",
    whatsapp: "WhatsApp",
    payment_link: "Payment link",
    priv_payment_link_hint: "Optional — shown in the welcome email as a \"Pay now\" button.",
    payment_link_hint: "URL the student uses to pay (Stripe, PayPal, bank, etc.). Included in reminder emails and the dashboard banner.",
    pay_now: "Pay now",
    renew_banner_75: "You have {n} sessions left before renewing your program. We'll send your new invoice once it ends.",
    renew_banner_done: "You've completed your cycle. Your new program invoice is on its way.",
    renew_banner_75_pending: "You have {n} sessions left in your program and an unpaid invoice.",
    renew_banner_done_pending: "You've completed your cycle and have an unpaid invoice to continue.",
    my_progress: "My cycle progress",
    remaining: "Remaining",
    date_in_schedule: "Scheduled day for this group",
    date_off_schedule: "Day outside the group's regular schedule",
    daily_reminders: "Daily reminder",
    daily_reminders_done: "Reminders sent",
    daily_reminders_desc: "Notifies teachers with classes scheduled today. Idempotent — one email per teacher/day.",
    schedule_coverage: "Attendance coverage",
    schedule_coverage_desc: "Scheduled classes vs. reported attendance this month (through today).",
    classes_scheduled: "Scheduled",
    classes_reported: "Reported",
    classes_missing: "Missing",
    missing_dates: "Missing dates",
    no_schedule_coverage: "No group has a structured schedule yet.",
    add_schedule: "Add schedule",
    no_schedule_set: "No schedule set",
    day_mon: "Mon",
    day_tue: "Tue",
    day_wed: "Wed",
    day_thu: "Thu",
    day_fri: "Fri",
    day_sat: "Sat",
    day_sun: "Sun",
    max_students: "Max students",
    max_students_hint: "Empty = unlimited · Private individual: 1 · Private pair: 2",
    capacity: "Capacity",
    new_private_group: "New private student",
    program_price: "Program price",
    program_price_none: "No price set",
    custom_price: "Special price (optional)",
    custom_price_hint: "Leave blank to use the program's price. If you set a value here, it will be used for the invoice and the charge.",
    custom_price_edit_hint: "If you change this value, the student's pending invoice will be updated. Leave blank to use the program's price.",
    program_cycle: "Sessions per cycle",
    custom_cycle: "Cycle sessions (optional)",
    custom_cycle_hint: "Leave blank to use the program's cycle. If you set a value (e.g. 9 with a free bonus class), that will be this student's cycle.",
    custom_cycle_edit_warn: "Heads up: if the student already took classes, changing this shifts the counter. Use “Change plan”.",
    change_plan: "Change plan",
    current_plan: "Current plan",
    cycle_in_progress: "Cycle #{n} in progress: {x}/{y} sessions taken",
    new_sessions: "Sessions per cycle",
    new_price: "Price per cycle",
    change_plan_hint: "The current cycle finishes with its current sessions and price. The new plan applies from cycle #{n}. The student's history is untouched.",
    notify_student_plan: "Notify the student by email",
    plan_history: "Change history",
    from_cycle: "from cycle #{n}",
    notified: "notified",
    apply_change: "Apply change",
    plan_changed_ok: "Plan updated: applies from the next cycle",
    add_to_calendar: "Add to my calendar",
    my_achievements: "My achievements",
    celebration_title: "New badge!",
    celebration_total: "{n} pts in total",
    celebration_next: "Next",
    celebration_close: "Awesome!",
    my_points: "My points",
    points_short: "pts",
    badges_earned: "Badges earned",
    your_rank: "Your rank",
    earned_on: "Earned on",
    badge_manual_hint: "Awarded by the teaching team on special occasions.",
    badge_cat_attendance: "Attendance",
    badge_cat_homework: "Homework",
    badge_cat_payments: "Payments",
    badge_cat_community: "Community & resources",
    badge_cat_special: "Special",
    leaderboard_title: "Badge ranking",
    leaderboard_empty_month: "Nobody has earned badges this month yet. Be the first!",
    leaderboard_show_more: "Show the {n} remaining",
    leaderboard_show_less: "Show less",
    badges_how_title: "How are badges earned?",
    badges_how_btn: "How to earn badges",
    badges_how_intro: "Every badge gives points. They are awarded automatically when you reach the goal; nothing to request.",
    badges_how_1: "Attendance: attend class consistently (Streak), finish a cycle with no unjustified absences (Perfect cycle) and two months in a row without absences (Consistency).",
    badges_how_2: "Homework & payments: deliver all of the month's homework on time (Up to date), accumulate homework (Marathon) and pay 3 charges in a row before the due date (Punctual).",
    badges_how_3: "Community: attend WSS Live (Active voice), practice with Amigos con IA (Loyal friend), complete lessons and save resources (Explorer), react and comment on the wall and photos (Cheerleader, Talker).",
    badges_how_4: "Special: the teaching team can give you “WSS Live pioneer” or a “Recognition”.",
    badges_how_note: "The monthly ranking adds up the points of badges earned that month. In “My achievements” you see your progress toward the next one.",
    leaderboard_empty: "Nobody has earned badges yet. Be the first!",
    live_award_badge: "Award the “WSS Live pioneer” badge to attendees",
    live_award_confirm: "Award the “WSS Live pioneer” badge (+30 pts) to the {attended} attendees of “{title}”?",
    live_award_done: "Badge awarded to {n} student(s) ({skipped} already had it)",
    starts_on_date: "Starts on {date}",
    not_started_hint: "This student hadn't started classes yet on this date. If they attended, adjust the start date on their enrollment.",
    cycle_stats_title: "This cycle",
    show_all_history: "Show full history",
    all_time_present: "All-time attended",
    cal_ics_file: "other (.ics)",
    copied: "Copied",
    cal_sync_title: "Sync your classes with your calendar",
    cal_sync_sub: "One-time setup: your WSS Live reservations, regular and private classes show up and stay updated on their own.",
    cal_sync_sub_teacher: "One-time setup: your groups, WSS Live sessions and booked private classes show up and stay updated on their own.",
    cal_sync_note: "Reminder 15 minutes before each class. Google can take 12-24 h to refresh; Apple and Outlook are usually faster. The link is private: don't share it.",
    cal_copy_link: "Copy link",
    cal_how_it_works: "How does it work?",
    cal_regenerate: "Generate new link",
    cal_regenerate_confirm: "The old link will stop working and you'll need to subscribe again. Continue?",
    cal_regenerated: "New link generated",
    cal_help_1: "Tap your calendar's button (Google, Apple or Outlook) and confirm “Add” or “Subscribe”.",
    cal_help_2: "A new calendar named “WSS · Mis clases” appears with all your upcoming classes and reservations.",
    cal_help_3: "If a button doesn't open (e.g. Google on mobile), copy the link and paste it in Google Calendar → Other calendars → + → From URL.",
    starts_on_day: "Starts cycle at day (optional)",
    starts_on_day_hint: "Leave blank to start at session 1. If you set a number (e.g. 4 in an 8-session cycle), the next session will be #5 and the student has 4 left before renewing.",
    paid_on_start: "Cycle starts already paid",
    paid_on_start_hint: "Turn on if the student already paid this cycle (no charge will be created). Leave off if they still owe — they'll get the payment details in their welcome email.",
    historical_payment: "Historical payment (do not include in month's revenue)",
    historical_payment_hint: "Turn on if the student paid months ago (before you started using the app). This payment won't affect the month's revenue and NO invoice will be generated for it.",
    edit_enrollment: "Edit class program",
    per_day_times: "Use different times per day",
    per_day_times_hint: "Turn on when the student takes classes at different hours depending on the day. Values are pre-filled from the times above.",
    // ===== Welcome email preview / resend =====
    preview_welcome_email: "Preview welcome email",
    resend_welcome_email: "Resend welcome email",
    welcome_email_resent: "Welcome email resent",
    welcome_email_resend_error: "Could not resend the email",
    // ===== My profile =====
    my_profile: "My profile",
    meeting_room_superadmin: "Meet with Admin",
    booking: "Bookings",
    self_booking: "Books their own classes",
    self_booking_badge: "Self-books",
    amigos: "Speaking practice",
    program_self_booking: "Private students of this program book their own classes",
    program_self_booking_hint: "Every new private-class enrollment of this program starts with \"Books their own classes\" turned on. You can turn it off per student in Edit enrollment. Group classes are not affected.",
    self_booking_hint: "The student picks slots on the public page; each class is scheduled and consumes a session when attendance is marked.",
    meeting_room_academic_director: "Academic meeting",
    meeting_room_section: "My 1-on-1 meeting room",
    meeting_room_hint: "This link is what the top-bar button opens for every user. Meet is used if filled in, otherwise Zoom.",
    profile_saved: "Profile updated",
    profile_readonly_note: "Your email and role can only be changed by an administrator.",
    upload_avatar: "Upload photo",
    change_avatar: "Change photo",
    remove_avatar: "Remove photo",
    avatar_updated: "Photo updated",
    avatar_removed: "Photo removed",
    avatar_upload_error: "Could not upload the photo",
    avatar_too_large: "File is too large (max 5 MB)",
    avatar_invalid_type: "Unsupported format. Only JPG, PNG or WEBP",
    // ===== Homework wall =====
    attachments_and_responses: "Attachments & responses",
    material_from_teacher: "Material from teacher",
    material_hint: "Files shared with the whole group (PDF, images, audio, Office).",
    upload_material: "Upload material",
    no_material: "No material uploaded yet.",
    my_response: "My response",
    my_response_placeholder: "Write your response to this homework…",
    submit_response: "Submit response",
    update_response: "Update response",
    add_attachment: "Attach file",
    submission_saved: "Response saved",
    uploaded: "File uploaded",
    wall_responses: "Response wall",
    no_responses_yet: "No responses yet. Be the first!",
    you: "you",
    reaction: "reaction",
    reactions: "reactions",
    add_feedback: "Add feedback",
    write_feedback_placeholder: "Write your feedback for the student…",
    send_feedback: "Send feedback",
    comment_posted: "Comment posted",
    // ===== Notifications =====
    notifications: "Notifications",
    no_notifications: "You have no new notifications.",
    mark_all_read: "Mark all as read",
    view_all_notifications: "View all notifications",
    just_now: "now",
    admin_broadcast_btn: "Send message",
    target_audience: "Recipients",
    all_students: "All students",
    all_teachers: "All teachers",
    all_academic_directors: "Academic directors",
    title_required: "Title is required",
    delivered_to: "Delivered to",
    message: "Message",
    link_optional: "Link (optional)",
    send: "Send",
    title: "Title",
    send_also_email: "Also send by email",
    also_send_by_email: "Also send by email",
    also_send_by_email_hint: "In addition to the in-app notification, we'll email every recipient.",
    emails_sent: "emails sent",
    broadcast_email_sent: "Emails sent to",
    profile_tab_personal: "Personal info",
    profile_tab_enrollments: "My programs",
    profile_section_basic: "Basic information",
    profile_section_learner: "Student information",
    profile_section_teacher: "Professional information",
    save_changes: "Save changes",
    next_pending_payment: "Next pending payment",
    no_enrollments_yet: "You don't have any programs assigned yet.",
    cycle_progress: "Cycle progress",
    profession: "Profession",
    emergency_contact_name: "Emergency contact",
    emergency_contact_phone: "Emergency phone",
    learning_goal: "My learning goal",
    occupation: "Occupation",
    native_language: "Native language",
    city: "City",
    country_of_residence: "Country of residence",
    date_of_birth: "Date of birth",
    sessions_unit: "sessions",
    suspend: "Suspend billing",
    resume: "Resume billing",
    suspended: "Suspended",
    suspended_hint: "Program paused: the next cycle and its invoice are not generated.",
    program_status: "Program status",
    edit_private_students_hint: "To add or remove students use the buttons on the group's card.",
    next_payment: "Next payment",
    payment_pending: "Pending payment",
    pay_now: "Pay now",
    bank_deposit: "Bank deposit",
    view_payment_details: "View payment details",
    no_due_date: "No due date",
    due_today: "Due today",
    due_tomorrow: "Due tomorrow",
    due_in_days: "Due in {n} days",
    overdue_by: "Overdue by {n} days",
    all_caught_up: "You're all caught up!",
    no_pending_payments: "You have no pending payments right now.",
    my_current_cycle: "My current cycle",
    my_previous_cycle: "Previous cycle",
    my_next_cycle: "Next cycle",
    cycle: "Cycle",
    cycle_current: "Current",
    no_dates_in_cycle: "No classes in this cycle.",
    cycle_past: "Previous cycle",
    cycle_current_lbl: "Current cycle",
    cycle_future: "Next cycle",
    archived: "Archived",
    alert_archive: "Archive",
    alert_restore: "Restore",
    alert_archived: "Alert archived",
    alert_restored: "Alert restored",
    alerts_show_all: "View archived",
    alerts_show_active: "View active",
    alerts_purge_note: "Alerts are automatically deleted after 90 days.",
    student_search_placeholder: "Search student by name or email…",
    student_picker_no_match: "No matches.",
    student_picker_full: "You've already selected the maximum of students (2). Remove one to add another.",
    remove: "Remove",
    resend_enrollment_email: "Resend enrollment email",
    enrollment_email_sent: "Enrollment email sent",
    private_pair: "Pair",
    private_individual: "Individual",
    filter_all: "All",
    filter_groups: "Group classes",
    filter_private: "Private",
    capacity_reached: "Full",
    add_students: "Add students",
    select_up_to_2: "Select 1 or 2 students",
    date: "Date",
    status: "Status",
    amount: "Amount",
    due_date: "Due date",
    issued_date: "Issue date",
    paid_date: "Paid date",
    notes: "Notes",
    topic: "Topic",
    content: "Content",
    actions: "Actions",
    new_sede: "New campus",
    new_program: "New program",
    duplicate: "Duplicate",
    duplicate_program: "Duplicate program",
    copy_suffix: "(Copy)",
    clone_groups_too: "Also duplicate associated groups",
    groups_cloned: "groups duplicated",
    new_group: "New group",
    new_payment: "New payment",
    new_journal_entry: "New entry",
    homework: "Homework",
    my_homework: "My homework",
    my_journal: "Journal",
    my_notebook: "My Notebook",
    wall_board: "Wall",
    gallery: "Gallery",
    notebooks: "Notebooks",
    calendar: "Calendar",
    my_calendar: "My calendar",
    today: "Today",
    close: "Close",
    all_groups: "All groups",
    scheduled_class: "Scheduled class",
    attendance_reported: "Attendance reported",
    homework_due: "Homework due",
    homework_assigned: "Homework assigned",
    no_events_for_day: "No events for this day.",
    my_status: "My status",
    scheduled_classes_month: "Scheduled classes this month",
    reported: "Reported",
    pending_past: "Missing",
    upcoming: "Upcoming",
    att_day_taken: "Attendance taken",
    att_day_partial: "Incomplete",
    att_day_missing: "Not recorded",
    att_day_paused: "On hold",
    att_day_marked_count: "marked",
    att_paused_badge: "On hold",
    att_blocked_badge: "Not a class day",
    att_blocked_title: "This is not a class day for this group.",
    att_blocked_body: "The list is locked so nobody reports attendance on a date that is not part of the program. If a class did happen (makeup, reschedule or bonus), create the extra session first and then take attendance.",
    att_paused_hint: "This student is on hold on this date: the class is frozen and doesn't consume the cycle.",
    att_paused_admin_warning: "This student is on hold on this date. If you mark them, the class WILL consume the cycle.",
    missing_report: "Missing report",
    cancel_class: "Cancel class",
    my_attendance_month: "My attendance this month",
    cancel_class_body: "This will mark all {count} enrolled students as «Cancelled (teacher)» for {date}. Confirm?",
    cancel_class_confirm: "Yes, cancel the class",
    class_cancelled_saved: "Class marked as cancelled",
    unsaved_changes_title: "You have unsaved changes",
    unsaved_changes_body: "If you leave now, the attendance you haven't saved will be lost. What would you like to do?",
    stay_here: "Stay here",
    save_and_continue: "Save and continue",
    discard_changes: "Discard changes",
    my_journal_subtitle: "What the teacher wrote about each class.",
    new_homework: "New homework",
    edit_homework: "Edit homework",
    title: "Title",
    link: "Link",
    homework_link_hint: "Optional. Paste a Drive, YouTube, PDF link, etc.",
    homework_progress: "Homework progress",
    show_completed: "Show completed",
    completed: "Completed",
    open_link: "Open link",
    all: "All",
    unassigned: "Unassigned",
    clear: "Clear",
    clear_filters: "Clear filters",
    orphan_payment_one: "payment without active enrollment",
    orphan_payments_many: "payments without active enrollment",
    orphan_payments_hint: "Their enrollment was deleted. You can remove them with the red trash icon.",
    orphan_badge: "No enrollment",
    kept_badge: "Income kept",
    kept_badge_tooltip: "The program was deleted, but this income was real and the invoice is kept",
    keep_invoice: "Keep invoice",
    unkeep_invoice: "Flag it as pending again",
    keep_invoice_title: "Keep this invoice?",
    keep_invoice_body: "The program no longer exists, but the income was real: the invoice keeps its number, still counts as revenue and the student still sees it in their profile. It just stops showing up in the orphan-payments alert.",
    keep_invoice_reason: "Reason (optional)",
    keep_invoice_reason_ph: "e.g. the student did not continue, but paid the full cycle",
    keep_invoice_cta: "Yes, keep it",
    kept_ok: "Invoice kept",
    unkept_ok: "Back in the orphan-payments list",
    progress_no_program: "Without a program there are no attendances to compute progress from",
    orphan_badge_tooltip: "The enrollment record linked to this payment no longer exists.",
    show_orphans_only: "Show orphans only",
    show_all_payments: "Show all",
    groups_search_placeholder: "Search group, program, teacher or student…",
    students_search_placeholder: "Search by name or email…",
    no_results_for_filter: "No results match the current filters.",
    filter_by_teacher: "Filter by teacher",
    select_group: "Select group",
    select_sede: "Select campus",
    select_program: "Select program",
    select_teacher: "Select teacher",
    select_student: "Select student",
    enroll_student: "Enroll student",
    members: "Members",
    present: "Present",
    absent: "Absent",
    justified: "Justified absence",
    unjustified: "Unjustified absence",
    teacher_cancelled: "Cancelled",
    not_counted: "Not counted",
    removed: "Removed from plan",
    removed_hint: "Super admin only: takes this date out of the student's plan. It doesn't consume the cycle nor count as an absence — it stays neutral.",
    removed_dialog_title: "Remove session from plan",
    removed_dialog_body: "This date will no longer be part of the student's plan. It doesn't consume the cycle nor count as an absence. You can revert it any time.",
    removed_reason_label: "Reason (optional)",
    removed_reason_placeholder: "E.g. teacher got sick, school courtesy...",
    removed_confirm: "Remove from plan",
    removed_revert: "Restore in plan",
    removed_done: "Session removed from plan",
    removed_reverted: "Session restored in the plan",
    att_edit_chip_hint: "Tap to change the status of this date",
    att_edit_now_in: "currently",
    att_edit_unmarked: "not reported yet",
    att_edit_no_consume: "doesn't consume the cycle",
    att_edit_clear: "Clear the mark (back to not reported)",
    att_edit_note_label: "Note (optional)",
    att_edit_note_placeholder: "Why it was changed, so it leaves a trail",
    att_edit_done: "Attendance updated",

    flexible_schedule: "Special schedule (partial attendance)",
    flexible_schedule_badge: "Special schedule",
    flexible_schedule_hint: "Turn this on when the student attends fewer sessions than the rest of the group. The attendance sheet will show a \"Not counted\" button to mark the group dates that are not part of their paid schedule (they don't consume the cycle). Remember to also set the \"custom cycle\" (e.g. 4 instead of 8) so their invoice matches what they pay.",
    justified_full: "Justified absence",
    unjustified_full: "Unjustified absence",
    clear_attendance: "Unreport",
    clear_attendance_tooltip: "Delete this report and set the session back to 'Upcoming'. If it consumed a class from the cycle, it will be released.",
    clear_attendance_confirm_title: "Clear this attendance report?",
    clear_attendance_confirm_body: "The session on {date} will return to 'Upcoming' state and the cycle counter will be released if applicable.",
    quota_review_toast: "Saved. Heads up: {names} already used the justified-absence allowance for this cycle ({used}/{quota}), so that absence is waiting for approval and counts as a taken class for now.",
    unlimited_justified_student_hint: "You can cancel as many times as you need, at any time: the school granted you that privilege.",
    awaiting_approval: "Waiting for approval",
    unlimited_justified: "Unlimited justified absences",
    unlimited_justified_hint: "Can justify as many times as needed, with no approval and without using the allowance. Only the super admin can grant it.",
    unlimited_justified_badge: "No limit",
    unlimited_justified_note_label: "Why it was granted (kept on record)",
    unlimited_justified_on: "Privilege enabled",
    unlimited_justified_off: "Privilege removed",

    clear_attendance_cta: "Yes, clear report",
    attendance_cleared: "Attendance report cleared",
    paid: "Paid",
    pending: "Pending",
    superadmin: "Super admin",
    no_data: "No data",
    no_assignments: "You are not enrolled in any group yet. Please contact the administrator.",
    welcome_back: "Welcome back",
    total: "Total",
    take_attendance: "Take attendance",
    save_attendance: "Save attendance",
    mark_paid: "Mark as paid",
    private: "Private",
    group: "Group",
    private_student: "Private student",
    pay_now: "Pay now",
    payment_info: "Payment is recorded manually. Please contact the administration for accepted methods.",
    confirm_delete: "Confirm delete?",
    deleted: "Deleted",
    saved: "Saved",
    save_all: "Save all",
    save_and_resend_email: "Save and resend email",
    saved_and_email_resent: "Saved · email resent to student",
    download_invoice: "Download invoice",
    invoice: "Invoice",
    invoice_settings: "Invoice settings",
    invoice_settings_short: "Settings: Invoices",
    invoice_settings_subtitle: "Multiple issuers, shared data, student assignments and monthly report",
    issuer_block: "Issuer details",
    issuer_block_hint: "Shown on the top-right of every invoice and in the footer.",
    issuer_name: "Issuer name",
    issuer_tax_id: "Tax ID",
    issuer_location: "Location",
    policy_url: "Policies & conditions URL",
    policy_url_hint: "Link displayed under 'PAYMENT CONDITIONS' in the invoice.",
    numbering: "Numbering",
    numbering_hint: "The system assigns the next number automatically each time an invoice is issued.",
    next_invoice_number: "Next number to issue",
    next_number_warning: "Changing the next number can create duplicates if you issue with a value already used. Double-check before saving.",
    preview_sample: "Preview sample invoice",
    // Multi-issuer
    tab_issuers: "Issuers",
    tab_shared: "Shared data",
    tab_assignments: "Assignments",
    tab_report: "Monthly report",
    issuers_subtitle: "Configure the legal entities (WF, SRL95, SRL96…) that can issue invoices. One will be the default for new students.",
    shared_subtitle: "Location and policy URL shared by all issuers.",
    assignments_subtitle: "Assign each student to an issuer. If left unassigned, the default issuer will be used.",
    report_subtitle: "Invoices issued in the selected month, broken down by issuer.",
    add_issuer: "Add issuer",
    new_issuer: "New issuer",
    edit_issuer: "Edit issuer",
    prefix: "Prefix",
    prefix_hint: "Appears before the number (e.g. WF-1575, SRL95-200).",
    default_issuer: "Default",
    set_default: "Make default",
    cannot_delete_default: "You can't delete the default issuer.",
    issuer_in_use: "Can't delete: there are invoices issued or students assigned to it.",
    confirm_delete_issuer: "Delete this issuer? Students assigned to it will fall back to the default.",
    monthly_invoice_report: "Monthly invoice report",
    total_invoices: "Total invoices",
    total_amount: "Total amount",
    no_invoices_month: "No invoices were issued this month.",
    by_issuer: "By issuer",
    issued_at: "Issued on",
    invoice_number: "Invoice #",
    student: "Student",
    amount: "Amount",
    assigned_issuer: "Assigned issuer",
    use_default: "Use default",
    bulk_assign: "Assign selected to:",
    apply_bulk_assign: "Apply",
    students_selected: "students selected",
    filter_students: "Filter by name or email…",
    month: "Month",
    // Financial dashboard
    financial_overview: "Financial overview",
    financial_overview_hint: "Projection vs realized revenue, student flow and breakdown by program.",
    financial_report: "Financial report",
    export_pdf: "Export PDF",
    projection: "Projection",
    realized_paid: "Revenue collected",
    variance: "Variance",
    arps: "Avg revenue / student",
    arps_hint: "Monthly average (paid / active)",
    override_active: "Manual",
    auto: "Auto",
    active_enrollments: "Active programs",
    student_flow: "Student flow this month",
    start_of_month: "Start of month",
    new_students: "New",
    reactivated: "Reactivated",
    paused: "Paused",
    cancelled: "Cancelled",
    end_of_month: "End of month",
    net_change: "Net change",
    revenue_by_program: "Revenue by program",
    trend_important: "What matters",
    trend_rest: "The rest",
    trend_active_students: "Active students",
    trend_group_students: "In group classes",
    trend_private_students: "In private classes",
    trend_hours_month: "Hours taught",
    trend_hours_all_time: "Hours to date",
    trend_vs_prev: "vs. last month",
    trend_with_enrollment: "with an active enrollment",
    trend_same_as_prev: "same as last month",
    trend_no_data: "no data yet",
    income_title: "Income and projection month by month",
    income_subtitle: "In US dollars · recent months are computed from collected payments; any month can be corrected by hand",
    income_compare_all: "Compare all",
    income_projection: "Projection",
    income_year: "Year",
    income_total: "Total",
    income_help: "Click any cell to correct the amount (the projection row too, to set each month's target). Clear it and save empty to let the system compute that month again.",
    income_saved: "Value updated",
    income_cleared: "Month back to automatic",
    income_save_error: "Could not save",
    programs_count: "programs",
    test_accounts_excluded: "test accounts excluded from these numbers",
    program: "Program",
    revenue: "Revenue",
    override_projection: "Override projection",
    override_projection_hint: "Manually adjust this month's revenue projection (e.g. if you expect revenue not yet in active enrollments).",
    leave_empty_to_use_auto: "Leave empty to use the automatic value",
    amount: "Amount",
    loading: "Loading…",
    advance_balance: "in credit",
    advance_balance_hint: "we apply it to your next cycle invoice automatically, you do not have to do anything",
    unreported_title: "Today's classes with no attendance taken",
    unreported_none: "Every class today already has its attendance taken.",
    unreported_hint: "Until it is reported, those classes do not consume the cycle and billing falls behind. You also get an email reminder at 8:30 p.m.",
    exchange_rate: "Exchange rate",
    manual: "Manual",
    fallback: "Default",
    refresh_from_bccr: "Refresh from BCCR",
    edit_rate: "Edit exchange rate",
    edit_exchange_rate: "USD → CRC exchange rate",
    edit_exchange_rate_hint: "Manually override the exchange rate. Leave empty to use the automatic BCCR value (refreshed daily).",
    rate: "Rate",
    leave_empty_for_bccr_auto: "Leave empty to use the automatic BCCR value",
    exchange_rate_refreshed: "Exchange rate refreshed from BCCR",
    bccr_unavailable: "BCCR is not available. Check BCCR_EMAIL and BCCR_TOKEN in backend env.",
    error_generic: "Something went wrong. Please try again.",
    // Extra / rescheduled sessions
    add_extra_session: "Add extra session",
    new_extra_session: "New extra session",
    new_extra_session_subtitle: "Create a make-up class, a reschedule, or a bonus session outside the regular timetable.",
    session_type: "Session type",
    session_type_extra: "Extra (bonus)",
    session_type_reschedule: "Reschedule",
    session_type_makeup: "Make-up",
    original_class_date: "Original class date to replace",
    original_class_date_hint: "The original date will be hidden from the calendar and replaced by the new one.",
    applies_to: "Applies to",
    entire_group: "Entire group",
    start_time: "Start time",
    time_select_use_quick: "Use quick times",
    time_select_quick: "Quick",
    time_select_use_custom: "Custom time",
    session_time_hint: "Leave empty to use the group's regular time.",
    duration_minutes: "Duration (min)",
    counts_toward_cycle: "Counts toward the student's cycle",
    generates_charge: "Generates an additional charge",
    charge_amount: "Charge amount",
    currency: "Currency",
    expenses: "Expense Control",
    nav_academic: "Academic",
    resources: "Resources",
    conjugation: "Conjugation",
    cj_title: "Verb conjugation",
    cj_subtitle: "Practice with a score and look up any verb, grouped by the way it changes.",
    cj_tab_practice: "Practice",
    cj_tab_dictionary: "Dictionary",
    cj_build: "Set up your practice",
    cj_tenses: "Tenses",
    cj_difficulty: "Level",
    cj_difficulty_all: "All levels",
    cj_difficulty_any: "All levels",
    cj_count: "Questions",
    cj_include_vos: "Include vos",
    cj_include_vosotros: "Include vosotros",
    cj_start: "Start",
    cj_pick_tense: "Pick at least one tense",
    cj_cannot_build: "We couldn't build this practice",
    cj_practices: "practices",
    cj_best_score: "Best score",
    cj_hits_of: "correct out of",
    cj_question_of: "Question {n} of {total}",
    cj_pts: "pts",
    cj_type_answer: "Type the correct form…",
    cj_check: "Check",
    cj_next: "Next",
    cj_see_score: "See my score",
    cj_exit: "Exit",
    cj_correct: "Correct!",
    cj_almost_accent: "Almost: you missed the accent. It's",
    cj_right_form: "The correct form is",
    cj_points_of: "{score} out of {max} points",
    cj_correct_of: "{correct} correct out of {total} · {acc}% accuracy",
    cj_accent_wrong: "with the wrong accent",
    cj_to_review: "To review",
    cj_accent_only: "accent only",
    cj_practice_again: "Practice again",
    cj_change_filters: "Change filters",
    cj_search_verb: "Search a verb in Spanish or English…",
    cj_verbs_count: "verbs",
    cj_gerund: "Gerund",
    cj_participle: "Past participle",
    cj_tense_col: "Tense",
    cj_imperative_col: "Commands",
    cj_t_presente: "Present",
    cj_t_preterito: "Preterite (simple past)",
    cj_t_imperfecto: "Imperfect",
    cj_t_futuro: "Future",
    cj_t_condicional: "Conditional",
    cj_t_subjuntivo_presente: "Present subjunctive",
    cj_t_subjuntivo_imperfecto: "Imperfect subjunctive",
    cj_t_imperativo_afirmativo: "Affirmative command",
    cj_t_imperativo_negativo: "Negative command",
    cj_affirmative: "affirmative",
    cj_negative: "negative",
    cj_diff_basico: "Beginner",
    cj_diff_intermedio: "Intermediate",
    cj_diff_avanzado: "Advanced",
    cj_rank_title: "Weekly ranking",
    cj_rank_hint: "Resets every Monday · Costa Rica time",
    cj_rank_empty: "Nobody has practiced this week. Be the first!",
    cj_rank_you: "you",
    cj_rank_my_place: "You're #{n} of {total}",
    cj_rank_accuracy: "accuracy",
    cj_rank_all_time: "All time",
    cj_rank_week: "This week",
    cj_rank_gap: "{n} points to pass {name}",
    cj_streak_days: "days",
    cj_streak_day_one: "day",
    cj_streak_row: "in a row",
    cj_streak_row_one: "in a row",
    cj_streak_best: "best",
    cj_vod_title: "Verb of the day",
    cj_vod_note: "{n} questions · about 30 seconds",
    cj_vod_go: "Quick round",
    cj_weak_title: "Verbs you keep missing",
    cj_weak_misses: "{n} misses",
    cj_weak_misses_one: "{n} miss",
    cj_opts_all_levels: "All levels",
    cj_weak_practice: "Practice only these",
    cj_challenge_title: "Weekly challenge",
    cj_challenge_text: "This week everyone practices the",
    cj_challenge_progress: "{done} of {total} rounds done",
    cj_challenge_go: "Practice the challenge",
    cj_opts_show: "Change",
    cj_opts_hide: "Done",
    cj_opts_questions: "{n} questions",
    cj_which_verbs: "Which verbs?",
    cj_fam_all: "All",
    cj_fam_regular: "Regular",
    cj_fam_ortho: "Regular with spelling change",
    cj_fam_core: "18 irregular verbs",
    cj_fam_stem: "Irregular with spelling change",
    cj_fam_reflexive: "Reflexive",
    cj_fam_few: "Few verbs match: they will repeat",
    cjg_button: "How it works",
    cjg_title: "How to use the conjugation activities",
    cjg_intro: "There are three activities. Pick one, choose the tenses you want to practice, choose which verbs (all, regular, irregular, reflexive…), how many questions you want and press «Start». Type your answer and press Enter: you get instant feedback and the correct form. At the end you see your score, and your points count towards the weekly leaderboard.",
    cjg_m1_title: "1 · Conjugate the verb",
    cjg_m1_steps: "You get a verb and a person (for example «vivir» + «nosotros») in the tense you chose. | Type only the conjugated form: «vivimos». | Accents count: if you only miss an accent we tell you, and the answer is worth half. | This is the activity for drilling endings and irregular verbs.",
    cjg_m1_tip: "Tip: start with the present tense and regular verbs, then add the 18 irregular ones.",
    cjg_m2_title: "2 · Complete the sentence",
    cjg_m2_steps: "You get a full sentence with one blank, built from the four pieces: time + person + verb + information (e.g. «Todos los días yo ____ café con leche en la mañana»). | Below you see the infinitive as a hint. | Type the form that goes in the blank. | With the imperative and the subjunctive you sometimes have to type the pronoun too (we tell you when).",
    cjg_m2_tip: "Hover (or tap on your phone) any part of the sentence to see it in English, word by word. Careful: using that help makes the question worth half the points.",
    cjg_m3_title: "3 · Join two sentences",
    cjg_m3_steps: "Two sentences joined by a connector («y», «pero», «porque», «por eso»…): two blanks, one in each sentence. | Level 1: simple connectors and the same tense in both. | Level 2: the two tenses can be different (e.g. past and future). | Level 3: you also have to pick the connector that makes sense. | Type both verbs and press Enter.",
    cjg_m3_tip: "This is the closest one to real speaking: first think about how the two ideas relate.",
    cjg_extras_title: "Other things you can do",
    cjg_extras: "«Hard mode»: the hint is the English translation instead of the Spanish verb. | «Vos» and «vosotros»: turn them on or off depending on what you are studying; your choice is saved. | «Print worksheet»: creates a paper worksheet, with or without the answers. | Dictionary: the full verb tables, grouped by regular, irregular and reflexive. | Weekly board: every practice earns points and puts you on the week's leaderboard.",

    cj_help_hint: "Hover (or tap) any word of the sentence to see it in English · using the help is worth half the points",
    cj_help_used: "You used the translation: this question is worth half the points",
    cj_help_cost: "worth half the points",


    cj_mode_sentences: "Complete the sentence",
    cj_mode_sentences_desc: "Time + pronoun + verb + information",
    cj_mode_forms: "Conjugate the verb",
    cj_mode_forms_desc: "I give you the tense and the person",
    cj_mode_linked: "Link two sentences",
    cj_mode_linked_desc: "Two four-finger joined by a connector",
    cj_level: "Level",
    cj_level_1: "Level 1",
    cj_level_1_desc: "Same tense on both sides",
    cj_level_2: "Level 2",
    cj_level_2_desc: "Different tenses (Antes… pero ayer…)",
    cj_level_3: "Level 3",
    cj_level_3_desc: "You pick the connector",
    cj_pick_connector: "connector…",
    cj_two_tenses: "two tenses",
    cj_right_forms: "The correct forms are:",
    cj_worksheet: "Practice worksheet",
    cj_worksheet_open: "Print worksheet",
    cj_worksheet_print: "Print",
    cj_worksheet_answers: "Include answers",
    cj_worksheet_key: "Answer key",
    cj_worksheet_name: "Name",
    cj_worksheet_date: "Date",
    cj_worksheet_items: "exercises",
    cj_tense_mixed: "All mixed",
    cj_hard_mode: "Hard mode",
    cj_hard_mode_desc: "I give you the verb in English",
    cj_pronoun_blank: "pron.",
    cj_verb_blank: "verb",
    cj_pronoun_wrong: "Check the reflexive pronoun.",
    cjt_tab: "My sentences",
    cjt_title: "My sentences",
    cjt_subtitle: "Write your own time markers and complements. They are added to the built-in ones and show up in your students' practices.",
    cjt_kind_marker: "Time markers",
    cjt_kind_marker_hint: "First finger: Ayer, Todos los días, Ojalá que…",
    cjt_kind_complement: "Verb information",
    cjt_kind_complement_hint: "Fourth finger: what comes after the verb",
    cjt_verb: "Verb",
    cjt_new_marker: "New marker",
    cjt_new_complement: "New information",
    cjt_ph_marker: "e.g. El jueves pasado",
    cjt_ph_complement: "e.g. un casado en Soda Tapia",
    cjt_add: "Add",
    cjt_added: "Done, it's live in the practices",
    cjt_error: "Couldn't save it",
    cjt_only_school: "Use only my sentences",
    cjt_only_school_hint: "when on, the built-in ones are skipped wherever you have your own",
    cjt_preview: "See an example",
    cjt_mine: "Mine",
    cjt_mine_empty: "You haven't added any yet. The built-in ones keep working.",
    cjt_system: "Built-in",
    cjt_marker_warning: "The marker must force the tense you picked. If you put \"El jueves pasado\" under Present, students will answer in the preterite and the system will mark it wrong. Check the example before saving.",
    cjt_kind_connector: "Connectors",
    cjt_kind_connector_hint: "To join two sentences: y, pero, después…",
    cjt_new_connector: "New connector",
    cjt_ph_connector: "e.g. de una vez",
    cjt_causal: "Use cause connectors",
    cjt_causal_hint: "porque, por eso, por lo tanto, así que, entonces, por esa razón — off by default because they need a real logical link between the two sentences",
    announcements: "Announcements",
    resources_sub: "Study material to practice anytime",
    resource_new: "New resource",
    resource_edit: "Edit resource",
    resource_category: "Category",
    resource_search: "Search resource...",
    resource_favorites: "Favorites",
    resource_empty: "No resources published yet",
    resource_new_badge: "New",
    resource_draft: "Draft",
    resource_open: "Open",
    resource_watch: "Watch",
    resource_clicks: "Opens",
    resource_kind: "Resource type",
    resource_kind_link: "External link",
    resource_kind_video: "Video (YouTube, Vimeo...)",
    resource_kind_pdf: "Downloadable PDF",
    resource_kind_file: "Downloadable file (PDF, Word, Excel, image, audio)",
    resource_file_hint: "PDF, Word, Excel, PowerPoint, text, CSV, ZIP, images or audio · max 25 MB",
    resource_kind_embed: "Embedded content",
    resource_embed_code: "Embed code",
    resource_embed_preview: "Preview",
    resource_aspect: "Content ratio",
    resource_aspect_fine: "Fine tune",
    resource_aspect_hint: "Pick the ratio of the original design. If it doesn't match, Canva or YouTube pad it with black bars.",
    resource_aspect_wide: "widescreen (video, slides)",
    resource_aspect_classic: "classic (Canva presentations)",
    resource_aspect_square: "square",
    resource_aspect_portrait: "portrait (page)",
    resource_aspect_story: "tall portrait (phone)",
    resource_embed_no_iframe: "I can't find an <iframe> with a src in the pasted code",
    resource_embed_bad_host: "Domain not allowed for embedding:",
    resource_reorder_hint: "Drag the cards to change the order students see",
    resource_duplicate: "Duplicate",
    resource_duplicated: "Resource duplicated: change the title and the link",
    resource_ranking: "Usage ranking",
    resource_ranking_total: "Total opens",
    resource_category_new: "New category",
    resource_category_edit: "Edit category",
    resource_category_name: "Category name",
    resource_category_hidden: "Hidden (no resources)",
    resource_category_delete_confirm: "Delete this category? Its resources move to 'Otros'.",
    resource_all_categories: "All categories",
    resource_visibility: "Visibility",
    resource_vis_all: "Everyone (students and teachers)",
    resource_vis_staff: "Teachers only",
    resource_vis_public_badge: "Public",
    resource_vis_hint: "\"Teachers only\" is hidden from the student gallery, but a student can open it if a teacher attaches it to a homework (while it stays attached).",
    resource_pending_review: "Pending approval",
    resource_teacher_note: "Your resource stays as a draft until admin or the academic director approves it.",
    resource_share: "Copy share link",
    resource_attach: "Attach to a homework",
    resource_attach_new_hw: "Create a new homework",
    resource_attach_need_title: "Write the homework title",
    resource_attached: "Material attached to the homework",
    select: "Select...",
    resource_link_copied: "Link copied: paste it in the homework, email or WhatsApp",
    resource_count_one: "resource",
    resource_count_many: "resources",
    resource_reorder_cats_hint: "Drag the categories to change the order students see",
    resource_reorder_blocked: "Clear the filters and search to reorder the cards",
    resource_embed_hint: "Paste the code given by Canva, YouTube, Quizlet, Genially, Wordwall, Padlet or Google. We only take the iframe and render it inside the platform.",
    resource_url: "Link",
    resource_pdf: "PDF file (max 20 MB)",
    resource_cover: "Cover",
    resource_image_url_hint: "Paste an image URL (or upload one below)",
    resource_published: "Published",
    resource_published_hint: "If off, only you can see it (draft)",
    all_levels: "All levels",
    level: "Level",
    download: "Download",
    nav_people: "People",
    nav_finance: "Finance",
    nav_marketing: "Marketing & Sales",
    nav_comms: "Communication",
    nav_settings: "Settings",
    expenses_sub: "Record and control the expenses of each office",
    expense_categories: "Categories",
    expense_category: "Category",
    expense_new: "New expense",
    expense_records: "expenses",
    expense_total: "Period total (USD)",
    expense_by_office: "Spend by office (USD)",
    expense_vendor: "Vendor (optional)",
    expense_new_category: "New category",
    expense_category_archived: "Category archived (it has expenses linked)",
    notes_placeholder_extra: "Reason or additional details",
    extra_session_created: "Session created and notified",
    extra_sessions_label: "Extra sessions",
    extra_session_extra: "EXTRA",
    extra_session_reschedule: "RESCH",
    extra_session_makeup: "MAKEUP",
    reschedule_needs_original: "Pick the original date being rescheduled",
    reschedule_session: "Reschedule session",
    reschedule_edit: "Edit reschedule",
    reschedule_session_title: "Reschedule session",
    reschedule_session_subtitle: "Move the {date} session to another date. The original will be hidden from the cycle and replaced by the new one.",
    rescheduled_from: "Rescheduled from {date}",
    new_date: "New date",
    date_is_reschedule: "This date is a reschedule of {orig}",
    date_is_makeup: "This date is a group makeup session",
    date_is_extra: "This date is an extra group session",
    extra_session_updated: "Session updated and notified",
    undo_session_tooltip: "Undo this session",
    edit_session_tooltip: "Change this session's date or time",
    change_date_short: "Date",
    move_booked_class_title: "Move the booked class",
    booked_class_moved: "Class moved · the booking and the calendar moved too, with nobody notified",
    edit_session_title: "Change this session",
    edit_session_subtitle: "Session on {date}. Change the date or time and save.",
    extra_sessions_hint: "Tap the session to take attendance, \"Date\" to move it to another day or time, or the X to undo it.",
    move_booked_class_tooltip: "Change the date of this booked class",
    move_booked_class_note: "The student booked this class from the calendar. Changing the date or time also moves the booking and the event in the teacher's Google Calendar, with no emails sent.",
    move_booked_class_conflict_cta: "Move it anyway",
    move_booked_class_conflict_other: "Pick another time",
    undo_session_title: "Undo this session?",
    undo_reschedule_body: "The {date} session will be removed and the original date ({orig}) returns to the student's cycle. You can reschedule it again anytime.",
    undo_extra_body: "The {date} session will be removed from the group calendar and from its students.",
    undo_session_cta: "Yes, undo it",
    undo_session_done: "Session undone",
    // Absence requests
    absence_requests: "Absence requests",
    absence_requests_title: "Absence requests",
    absence_requests_subtitle: "Review and decide on absence requests submitted by students.",
    my_absences: "My absences",
    my_absences_title: "My absence requests",
    my_absences_subtitle: "Request to cancel a class at least 12 hours in advance (or your custom notice period).",
    new_absence_request: "New request",
    new_absence_dialog_subtitle: "Pick one or more dates you won't be able to attend.",
    enrollment: "Enrollment",
    dates_to_cancel: "Dates to cancel",
    add_date: "Add date",
    at_least_one_date: "At least one date is required",
    choose_class_date: "Pick a class date…",
    no_available_dates_to_cancel: "No upcoming classes available to cancel in this cycle.",
    submit_request: "Submit request",
    absence_reason_placeholder: "Reason for the absence (optional, recommended)",
    cycle_quota_label: "Cancellation quota (current cycle)",
    quota_left_short: "{left} of {total} left",
    absence_history_current_cycle: "Current cycle",
    absence_history_past_cycles: "Previous cycles",
    no_cycle_active: "No active cycle",
    no_active_enrollments: "You have no active class programs",
    remaining_cancellations_cycle: "{left} of {total} left this cycle",
    policy_hours_label: "Policy: {hours} hours minimum advance notice",
    quota_exhausted_warning: "You've used all allowed cancellations. New requests will go to admin review.",
    absence_request_received: "Request received",
    absence_request_received_subtitle: "Here's what was processed:",
    auto_justified_msg: "✓ Within policy and quota — the absence is automatically justified.",
    over_quota_msg: "⚠️ Exceeds your cycle quota. For now this class is deducted from your plan; if admin approves the justification, it'll be released.",
    late_notice_msg: "⚠️ Less than {hours}h notice. For now this class is deducted from your plan; if admin approves the justification, it'll be released.",
    my_absence_history: "My request history",
    no_absence_requests: "You haven't submitted any requests yet.",
    no_pending_requests: "No pending requests to review.",
    review_request_title: "Review request",
    dates_in_request: "Dates in this request",
    hours_notice_label: "Notice",
    out_of_policy: "Out of policy",
    exceeds_quota_short: "Over quota",
    admin_note: "Admin note",
    admin_note_optional: "Note (optional)",
    admin_note_placeholder: "Comment on the decision",
    request_approved: "Request approved",
    request_rejected: "Request rejected",
    submitted: "Submitted",
    review: "Review",
    approve: "Approve",
    reject: "Reject",
    pending: "Pending",
    all: "All",
    dates: "Dates",
    group: "Group",
    cancellation_policy_hours_label: "Custom cancellation notice (hours)",
    cancellation_policy_hours_hint: "Leave blank to use the default 24h policy.",
    no_usable_enrollment: "To request an absence, you first need to be up to date with your current cycle payment. Once your payment is confirmed, this option will unlock automatically. If you believe you've already paid, please contact the academic team.",
    payment_required_title: "Cycle payment pending",
    group_deleted: "(group deleted)",
    unjustified_consumed: "Absence (counted)",
    unjustified_consumed_hint: "This class was deducted from your cycle because the request was late or exceeded your quota. Admin can revert it by approving the request.",
    view_month: "Month",
    view_week: "Week",
    today: "Today",
    from: "From",
    to: "To",
    reschedule_class_title: "Reschedule class",
    reschedule_class_subtitle: "Confirm the new date and time for this class.",
    reschedule_class_hint: "The original date will be hidden from the calendar and replaced by the new one.",
    reschedule_class_done: "Class rescheduled and notified",
    confirm_reschedule: "Confirm reschedule",
    mon_short: "Mon",
    tue_short: "Tue",
    wed_short: "Wed",
    thu_short: "Thu",
    fri_short: "Fri",
    sat_short: "Sat",
    sun_short: "Sun",

    // Help center
    help: "Help",
    help_title: "User manual",
    help_subtitle: "Step-by-step guide to everything you can do on the platform based on your role.",
    download_manual_pdf: "Download PDF",
    // CSV bulk import
    bulk_import_students: "Import CSV",
    bulk_import_title: "Bulk student import",
    bulk_import_subtitle: "Upload a CSV with columns name, email, whatsapp, country.",
    download_template: "Download CSV template",
    drop_csv_here: "Drop your CSV here or click to select it",
    select_csv: "Select file",
    file_selected: "File selected",
    analyze_csv: "Analyze file",
    preview_results: "Analysis results",
    rows_valid: "Valid rows",
    rows_duplicate: "Duplicates (will be skipped)",
    rows_invalid: "With errors (will be skipped)",
    rows_total: "Total rows",
    send_welcome_emails: "Send welcome email (magic link) to created students",
    confirm_import: "Confirm & import",
    import_summary: "Import summary",
    created_count: "students created",
    skipped_count: "skipped (duplicates)",
    emails_sent_count: "emails sent",
    errors_count: "errors",
    import_again: "Import another file",
    csv_no_valid_rows: "No valid rows to import.",
    reason: "Reason",
    language: "Language",
    role_pending: "Your account is pending role assignment. Please contact the administrator.",
    settings: "Settings",
    enrollments: "Class programs",
    my_groups: "My programs",
    my_students: "My students",
    messages: "Messages",
    messages_subtitle: "Private chat with your teachers/students.",
    messages_subtitle_pass: "Write directly to the school's administration.",
    dm_sec_staff: "Administration",
    gc_section: "My groups",
    gc_subtitle: "Group chat: your classmates and your teacher can see it.",
    gc_empty: "This is the start of the group chat. Say hi to your classmates and your teacher.",
    gc_placeholder: "Write in {g}",
    gc_teacher: "Teacher",
    gc_send_error: "It could not be sent",
    dm_sec_teachers: "Teachers",
    dm_sec_students: "Students",
    dm_sec_affiliates: "Affiliates",
    ann_button: "Message several", 
    ann_title: "One message for several people",
    ann_help: "Everyone gets it as a private chat, so when they reply, they reply only to you.",
    ann_audience: "Who receives it?",
    ann_aud_all: "Everybody",
    ann_aud_teachers: "Teachers",
    ann_aud_students: "Students",
    ann_aud_affiliates: "Affiliates",
    ann_aud_group: "One group",
    ann_aud_sede: "One campus",
    ann_aud_my_students: "My students",
    ann_pick_group: "Pick the group",
    ann_pick_sede: "Pick the campus",
    ann_message: "Message",
    ann_placeholder: "Write the message…",
    ann_email_toggle: "Send it by email too",
    ann_email_hint: "If you turn it off it only shows up in the platform, with its notification.",
    ann_attach: "Attach a file (optional)",
    ann_send: "Send the message",
    ann_sent: "Message sent to {n} people",
    ann_error: "The message could not be sent",
    ann_need_text: "Write the message",
    ann_need_group: "Pick the group",
    ann_need_sede: "Pick the campus",
    ann_history: "Sent before",
    ann_people: "people",
    ann_with_email: "with email",

    no_messages_available: "You don't have any conversations yet.",
    no_messages_yet: "No messages",
    pick_conversation: "Pick a conversation",
    no_results: "No results",
    open_dm: "Open chat",
    summary: "Overview",
    alerts: "Alerts",
    alerts_desc: "Automatically detected events that need your attention.",
    no_alerts: "No alerts recorded. All good!",
    run_alerts: "Run analysis",
    alerts_done: "Analysis ran",
    alert_absence: "Absences",
    alert_overdue: "Overdue payment",
    alert_absence_msg: "Accumulated {missed} absences in {program}, exceeding the 25% limit ({allowed} allowed).",
    alert_overdue_msg: "Payment of {amount} for {program} is {days} days overdue.",
    notified: "Notified",
    just_now: "just now",
    reports: "Reports",
    reports_desc: "Revenue, payments and students consolidated by campus.",
    by_sede: "By campus",
    paid_total: "Total paid",
    pending_total: "Total pending",
    paid_last_30d: "Paid last 30d",
    payments_paid_count: "# payments",
    revenue_chart: "Revenue by campus",
    unattributed_title: "Payments without campus",
    unattributed_desc: "Some payments don't match any enrollment for that program. Enroll the student to attribute revenue correctly:",
    you: "you",
    users_invite_hint: "Share the app link with your team; they will appear here after first sign-in.",
    teachers_invite_hint: "Active teachers on the platform. Promote new teachers by changing their role.",
    students_invite_hint: "Registered students. Enroll them into groups from the Groups tab.",
    delete_user_title: "Delete user?",
    delete_user_desc: "{name} will be removed along with their enrollments, attendance and payments. This action cannot be undone.",
    applications: "Applications",
    applications_desc: "Review and approve users who applied for access.",
    no_applications: "No pending applications.",
    view_details: "View details",
    view_user: "View user",
    view_no_enrollments: "This student has no class programs yet.",
    no_whatsapp: "No WhatsApp",
    no_payment_link: "No payment link",
    no_bank_account: "No bank account",
    no_amount: "No amount",
    country: "Country",
    no_country: "No country",
    select_country: "Select a country…",
    whatsapp_dial_label: "Code",
    whatsapp_number_placeholder: "Number (without the +)",
    copied_to_clipboard: "Copied to clipboard",
    copy_email: "Copy email",
    magic_link_expired_title: "Link expired or invalid",
    magic_link_expired_hint: "No worries — enter your email below and we'll send you a fresh 24-hour link.",
    magic_link_sent_title: "Link sent!",
    approve: "Approve",
    reject: "Reject",
    approve_as: "Approve as",
    approved: "Approved",
    rejected: "Rejected",
    confirm_reject: "Reject this application? The user will lose access.",
    // ----- Onboarding -----
    onboarding_title_student: "Tell us a bit more about you",
    onboarding_title_teacher: "Complete your teacher profile",
    onboarding_subtitle: "We need this information to activate your account. It only takes a minute.",
    onboarding_required_hint: "Fields marked with * are required.",
    onboarding_submit: "Activate my account",
    onboarding_saving: "Activating…",
    onboarding_success: "All set! Your account is now active.",
    // ----- Policies & Conditions acceptance -----
    policies_accept_prefix: "I have read and I accept the",
    policies_link_text: "Policies and Conditions",
    policies_accept_suffix: "of We Speak Spanish CR",
    policies_page_title: "Policies & Conditions",
    policies_page_subtitle: "Hi {name}, before continuing we need you to confirm that you accept our current policies and conditions.",
    policies_page_subtitle_reaccept: "Hi {name}, we have updated our policies and conditions. Please review and accept the new version to continue.",
    policies_page_body: "To keep using the platform, please read our updated Policies & Conditions and check the acceptance box below.",
    policies_page_body_reaccept: "We've made changes to our Policies & Conditions. Please read them and confirm your acceptance of the new version.",
    policies_updated_title: "📄 We've updated our Policies & Conditions",
    policies_updated_body: "We've made important changes we want you to know about. Please review the updated document and confirm your acceptance to keep using the platform.",
    policies_whats_new: "What changed",
    policies_menu_item: "Policies & Conditions",
    // ----- Auto-response global kill switch -----
    autoresponse_toggle_on_title: "Custom auto-responses ON",
    autoresponse_toggle_on_body: "Prospects receive the email tailored to their program/campus. If no custom template exists, the system's default template is used.",
    autoresponse_toggle_off_title: "Using system default template",
    autoresponse_toggle_off_body: "All prospects still receive a welcome email, but your custom templates are ignored and the safe pre-programmed system template is sent instead. Useful while editing specific templates without leaving prospects unanswered.",
    autoresponse_status_active: "Custom",
    autoresponse_status_paused: "Default only",
    autoresponse_paused: "System default template is now used for all leads (custom templates ignored).",
    autoresponse_resumed: "Custom auto-responses re-enabled.",
    autoresponse_reason_label: "Reason",
    autoresponse_reason_input_label: "Reason (optional, for your internal record)",
    autoresponse_reason_placeholder: "e.g. Updating email templates…",
    policies_read_here: "Read the Policies & Conditions",
    policies_accept_button: "Accept and continue",
    policies_must_accept: "You must accept the Policies & Conditions to continue.",
    policies_accepted_success: "Thanks! Your acceptance has been recorded.",
    saving: "Saving…",
    view_profile_section: "Profile",
    view_no_profile_data: "No data yet. The user will fill in their profile on first login.",
    edit_profile_section_title: "User profile",
    field_date_of_birth: "Date of birth",
    field_country_of_residence: "Country of residence",
    field_city: "City of residence",
    field_occupation: "Occupation",
    field_native_language: "Native language",
    field_how_did_you_hear: "How did you hear about us?",
    field_learning_goal: "What is your goal learning Spanish?",
    field_has_learning_difficulty: "Do you have any condition that makes language learning harder?",
    field_learning_difficulty_detail: "Tell us briefly",
    field_address: "Address",
    field_profession: "Profession",
    field_languages_spoken: "Languages you speak",
    field_languages_spoken_hint: "Pick one or many. To add another, type it and press Enter.",
    field_emergency_contact_name: "Emergency contact name",
    field_emergency_contact_phone: "Emergency contact phone",
    field_meet_link: "Google Meet link",
    field_zoom_link: "Zoom link",
    field_meet_link_hint: "Paste your recurring Meet link. You can choose which to use per group.",
    field_zoom_link_hint: "Paste your recurring Zoom link. You can choose which to use per group.",
    field_meet_platform: "Virtual platform",
    platform_default: "Default",
    platform_meet: "Google Meet",
    platform_zoom: "Zoom",
    join_class: "Join class",
    join_class_meet: "Join via Meet",
    join_class_zoom: "Join via Zoom",
    start_class: "Start class",
    start_class_meet: "Start Meet class",
    start_class_zoom: "Start Zoom class",
    student_status: "Student status",
    status_active: "Active",
    status_inactive: "Inactive",
    status_cancelled: "Cancelled",
    filter_all: "All",
    yes: "Yes",
    no: "No",
    pick_option: "Select an option",
    how_online_search: "Searching Spanish Schools online",
    how_facebook_group: "Facebook Group",
    how_newspaper_ads: "Newspaper Ads",
    how_google_ads: "Google Ads",
    how_facebook_ads: "Facebook Ads",
    how_recommendation: "By Recommendation",
    how_street_signal: "Signal in the Street",
    how_banner: "Banner",
    how_flyers: "Flyers",
    how_walk_in: "Walking in front of our School",
    how_another_school: "Another School",
    how_webpage_ads: "Ads on another Webpage",
    lang_spanish: "Spanish",
    lang_english: "English",
    lang_french: "French",
    lang_portuguese: "Portuguese",
    lang_german: "German",
    lang_italian: "Italian",
    lang_other: "Other",
    // ===== Churn feedback (cancelled students) =====
    churn_feedbacks: "Churn feedback",
    churn_feedback_title: "Your feedback matters to us",
    churn_feedback_intro: "Thank you for choosing us. Before you go, could you tell us why? Your answer will help us improve the school.",
    churn_feedback_reasons_label: "Why did you decide to leave? (pick all that apply)",
    churn_feedback_comment_label: "Anything else you want to share? (optional)",
    churn_feedback_comment_placeholder: "Tell us how you felt during your time with us…",
    churn_feedback_submit: "Send feedback",
    churn_feedback_submitted_title: "Thank you for your feedback!",
    churn_feedback_submitted_msg: "Your answer has been recorded. If you ever decide to come back, we'll be here.",
    churn_feedback_invalid_link: "This link is invalid or has expired.",
    churn_feedback_select_at_least_one: "Select at least one reason",
    churn_feedback_already_submitted: "This survey has already been answered.",
    // Reasons (multi-select)
    churn_reason_price: "Too expensive / Financial reasons",
    churn_reason_no_time: "Lack of time",
    churn_reason_expectations_not_met: "Didn't meet my expectations",
    churn_reason_changed_school: "Switched to another school",
    churn_reason_achieved_goal: "I achieved my goal",
    churn_reason_teacher_or_group_issue: "Issue with the teacher / group",
    churn_reason_other: "Other (please write below)",
    // Admin dashboard
    churn_send_farewell_btn: "Send farewell email",
    churn_farewell_sent_toast: "Farewell email sent",
    churn_farewell_error_toast: "Could not send the email",
    churn_total_sent: "Emails sent",
    churn_total_submitted: "Responses received",
    churn_response_rate: "Response rate",
    churn_top_reasons: "Top reasons",
    churn_all_responses: "All responses",
    churn_filter_submitted: "Only answered",
    churn_filter_pending: "Only pending",
    churn_col_student: "Student",
    churn_col_reasons: "Reasons",
    churn_col_comment: "Comment",
    churn_col_sent: "Sent",
    churn_col_status: "Status",
    churn_status_pending: "Pending",
    churn_status_responded: "Answered",
    churn_status_email_skipped: "Email not sent",
    churn_empty: "No feedback registered yet.",
    churn_no_responses_yet: "No responses yet.",
    // ===== CRM Lead Management =====
    admissions_lead_coordinator: "Admissions Lead Coordinator",
    leads: "Leads",
    leads_analytics: "Analytics",
    leads_analytics_title: "Leads Analytics",
    leads_analytics_subtitle: "Conversion rate and channel breakdown to make better decisions.",
    leads_view_analytics: "View analytics",
    leads_title: "Lead Management",
    leads_subtitle: "Prospects captured from the website and other channels.",
    lead_templates: "Email Templates",
    lead_automation: "Automation",
    distribution: "Distribution",
    affiliates: "Affiliates",
    affiliate: "Affiliate",
    store_orders: "Store orders",
    courses_od: "On-Demand Courses",
    my_courses_od: "On-Demand Courses",
    my_portal: "My portal",
    // ----- WSS Live Sessions -----
    live_sessions: "WSS Live Sessions",
    live_pass: "WSS GO Passes",
    attendance_report: "Monthly attendance",
    lp_pay: "Pay {price}",
    lp_trial_days: "Free trial · {n} days left. After that it's {price} a month.",
    lp_trial_one_day: "Free trial · 1 day left. After that it's {price} a month.",
    lp_trial_last_day: "Free trial · today is the last day. After that it's {price} a month.",
    lp_pending_title: "Your trial has ended.",
    lp_pending_text: "Your {price} invoice is already in \u00abMy Payments\u00bb. You keep your access for a few more days while you pay it.",
    lp_blocked_title: "Your access is on hold.",
    lp_blocked_text: "We haven't received this month's payment yet. As soon as we register it, everything comes back: live classes, conjugation and resources.",
    lp_home_title: "Your WSS Live access is ready",
    lp_home_text: "Open WSS Live in the menu and book any live class you want. You also have the conjugation trainer and the resource library.",
    email_change_cta: "Change the sign-in email",
    email_change_new: "New email",
    email_change_apply: "Change the email",
    email_change_hint: "The change is immediate. The old address gets a notice that it no longer signs them in, and the new one that it is their access from now on.",
    email_change_confirm_q: "Check the spelling: this person will sign in with",
    email_change_confirm_yes: "Yes, change it",
    email_change_done: "They now sign in with {email}",

    sa_game_sub: "Play online with Kahoot and Wordwall",
    sa_game_count: "{n} games",
    sa_game_plays: "{n} games played",

    game_zone_import: "Bring the ones from Resources",
    game_zone_import_none: "No Kahoot or Wordwall games found in Resources (or they are all here already)",
    game_zone_import_confirm: "Found {n} game(s) in Resources. Bring them into the Game Zone?",
    game_zone_import_done: "{n} game(s) brought into the Game Zone",

    game_zone: "WSS Game Zone",
    game_zone_sub: "Play and practise without leaving the platform. Pick a category and go.",
    game_zone_new_category: "New category",
    game_zone_edit_category: "Edit category",
    game_zone_new_game: "Add game",
    game_zone_edit_game: "Edit game",
    game_zone_games: "games",
    game_zone_featured: "Featured this week",
    game_zone_play_now: "Play now",
    game_zone_awards: "Your awards",
    game_zone_plays: "plays",
    game_zone_empty: "No games yet. The school will be adding them.",
    game_zone_category_empty: "No games in this category yet.",
    game_zone_link: "Game link",
    game_zone_link_hint: "Paste the link or the embed code: the platform detects whether it is Kahoot or Wordwall. Kahoot games must be public or unlisted.",
    game_zone_feature_it: "Feature it this week",
    game_zone_any_level: "Any level",
    game_zone_open_tab: "Open in a new tab",
    game_zone_open_outside: "This game will not load in here. Open it in a new tab with the button below.",
    category: "Category",
    your_level: "Your level",

    like: "Like",
    resource_view_cards: "Card view",
    resource_view_list: "List view",

    photo_week_label: "Week of {from} – {to}",
    see_full_gallery: "See the full gallery ({n})",

    gallery_sub: "Every community photo, including previous weeks",
    gallery_caption_ph: "Caption (optional)",
    gallery_upload: "Upload photos",
    gallery_pending_note: "Your photos wait for approval",
    gallery_all_photos: "All photos",
    gallery_sent_for_review: "Sent for approval",
    gallery_published: "Photos published",
    gallery_upload_failed: "Could not upload",
    photo_caption_prompt: "Caption",
    photo_caption_saved: "Caption updated",
    photo_delete_confirm: "Delete this photo?",
    write_comment_ph: "Write a comment",

    wall_news_title: "News & announcements",
    wall_see_all: "See all",
    wall_empty_text: "No announcements published yet",
    wall_comments_n: "{n} comments",

    sa_live_sub: "Live classes every day",
    sa_conj_sub: "Train your verbs at your own pace",
    sa_conj_title: "Conjugation Verbs",
    sa_res_sub: "Guides, audio and class material",
    sa_live_none: "See the schedule",
    sa_live_today: "Today {time}",
    sa_live_tomorrow: "Tomorrow {time}",
    sa_conj_none: "Start today",
    sa_conj_verbs: "{n} verbs practiced",
    sa_res_count: "{n} materials",
    sa_photos_title: "Photos of the week",
    sa_photos_sub: "What happened at school",
    sa_photos_all: "See the gallery",

    lp_home_cta: "See the available classes",
    ls_title: "WSS GO landing visits",
    ls_sub: "Our own counter, in Costa Rica time. No cookies.",
    ls_days: "{n} days",
    ls_visitors: "People",
    ls_views: "Opens",
    ls_signups: "Signups",
    ls_conversion: "Conversion",
    ls_empty: "Nobody has opened the landing in this period yet. The counter starts once it is published.",
    ls_chart_note: "Each bar is one day. The green line on top marks days with signups.",
    ls_sources: "Where they came from",
    ls_direct: "Direct (typed the link or opened it from a message)",

    lp_admin_sub: "Who signed up from the public page, who is on their free week and who still owes the month.",
    lp_st_trial: "Free week",
    lp_st_invoiced: "Invoiced",
    lp_st_active: "Paid up",
    lp_st_blocked: "On hold",
    lp_terms: "Offer terms",
    lp_price: "Monthly price",
    lp_trial_days_label: "Free days",
    lp_pay_link: "Payment link",
    lp_terms_hint: "The invoice goes out when the free period ends; the reminder and the hold follow 48 and 96 hours later.",
    lp_people: "People",
    lp_search: "Search by name or email",
    lp_empty: "Nobody has signed up through the public WSS Live page yet.",
    lp_col_person: "Person",
    lp_col_status: "Status",
    lp_col_trial_until: "Free until",
    lp_col_paid_until: "Paid until",
    lp_col_action: "Action",
    lp_register_payment: "Register payment",
    lp_payment_hint: "You are about to mark {name}'s pass invoice as paid and switch their access back on for a month.",
    lp_confirm_convert: "Turn {name} into a regular student? The pass ends today and WSS Live comes included with their program.",
    lp_converted: "Done: they are a regular student now",
    lp_delete_title: "Delete {name}",
    lp_delete_hint: "They are removed from the platform: they lose access and their enrollment and attendance are deleted.",
    lp_keep_history: "Keep their purchase history and invoices in the system",
    lp_deleted: "Person deleted",
    payment_method: "Payment method",
    cash: "Cash",
    deposit: "Deposit",
    card: "Card",
    unspecified: "Unspecified",
    lp_sales_line: "WSS Live passes",
    lp_embed: "Put the form on your website",
    lp_embed_hint: "Copy this snippet and paste it on the page of your site where you want people to sign up. The form stays inside your website and the 6-digit code is validated right there.",
    lp_copy_embed: "Copy the snippet",
    lp_open_public: "Open the public page",
    lp_confirm_payment: "Register {name}'s payment and switch their access back on for a month?",
    lp_saved: "Terms saved",
    lp_active_until: "Access active until {date}",
    live_sessions_sub: "Extra live virtual classes for every active student",
    live_classes: "WSS Live",
    live_classes_sub: "Reserve live virtual sessions included in your program",
    live_new_session: "New session",
    live_topic: "Session topic",
    live_activity_type: "Activity type",
    live_capacity: "Capacity",
    live_levels: "Levels",
    live_levels_hint: "Leave empty to make the session visible to all levels.",
    live_all_levels: "All levels",
    live_meet_link: "Meeting link",
    live_meet_link_hint: "Leave empty to use your default profile link (Meet first, then Zoom).",
    live_meet_link_hint_admin: "Leave empty to use the assigned teacher's default link (Meet first, then Zoom).",
    live_default_link: "This link will be used",
    live_no_default_link: "⚠ This teacher has no Meet or Zoom link in their profile — type one here.",
    live_missing_link: "⚠ No link: this teacher has no Meet or Zoom saved in their profile. Edit the session and paste a link, or add it to the teacher's profile (Users → edit).",
    live_link_from_profile: "Using the teacher's profile link",
    live_title_required: "Topic is required",
    live_sent_for_approval: "Session sent for approval",
    live_status_all: "All",
    live_status_past: "Past",
    live_status_completed: "Completed",
    live_past_summary: "{booked} booked · {attended} attended",
    live_clone: "Clone",
    live_clone_hint: "Everything is copied (topic, type, levels, capacity, teacher and materials). Just pick the new date and time.",
    live_cloned: "Session cloned. Find it on the new date.",
    live_past_no_access: "This session already ended. The join link is closed, but you can still see its materials.",
    live_status_proposed: "Pending approval",
    live_status_published: "Published",
    live_status_rejected: "Rejected",
    live_status_cancelled: "Cancelled",
    live_approve: "Approve",
    live_approved: "Session approved and published",
    live_reject: "Reject",
    live_reject_reason_ph: "Reason (optional)",
    live_rejected_reason: "Reason",
    live_cancel_session: "Cancel session",
    live_cancel_confirm: "Cancel this session? Attendees will be notified.",
    live_cancelled_ok: "Session cancelled",
    live_roster: "Attendees",
    live_no_bookings: "No reservations yet",
    live_confirmed: "Confirmed",
    live_waitlist: "Waitlist",
    live_seats: "Reserved",
    live_seats_left: "Seats left",
    live_email_prefs_title: "WSS Live emails",
    live_month_left_hint: "Upcoming published WSS Live classes",
    live_only_mine: "Only mine",
    billing_profile: "Billing details",
    billing_profile_hint: "Fill this only when the invoice must be issued to a company. If empty, the invoice is issued to the student.",
    billing_name: "Bill to / Company name",
    billing_tax_id: "Tax ID",
    billing_activity_code: "Economic activity code",
    billing_location: "Billing address / place",
    billing_email: "Invoice email",
    billing_email_hint: "Gets a copy of the invoice in addition to the student.",
    guardian_title: "Parent / guardian",
    guardian_hint: "For minors. This email can sign in to THIS account with its own code and gets a copy of invoices and payment reminders. Leave empty if not applicable.",
    guardian_email: "Parent/guardian email",
    live_view_all: "All",
    live_all_weeks: "All weeks",
    live_from_resources: "From Resources",
    live_pick_resources: "Bring material from Resources",
    live_from_resources_hint: "Pick PDFs, videos, audio or links you already have in the Resources bank.",
    live_material_type_resource: "Resource",
    live_month_summary: "{upcoming} upcoming classes · {remaining} this month",
    live_email_prefs_hint: "Choose which live-class notices you want to receive. Reminders for classes you booked and cancellation notices are always sent.",
    live_email_weekly: "Weekly schedule (Sundays)",
    live_email_weekly_hint: "Every class of the coming week, with the button to book.",
    live_email_daily: "Today's schedule (8 a.m.)",
    live_email_daily_hint: "Only on days with live classes scheduled.",
    live_save_attendance: "Save attendance",
    live_explore: "Explore",
    live_my_reservations: "My reservations",
    live_all_activities: "All activities",
    live_showing_for_level: "Showing sessions for your level",
    live_open_to_all: "Every session is open — join any of them, even outside your level",
    live_assigned_teacher: "Assigned teacher",
    live_materials: "Materials",
    live_upload_material: "Upload image or video",
    live_material_hint: "Documents (PDF, Word, PowerPoint, Excel, TXT) up to 25 MB · images up to 10 MB · videos up to 50 MB. You can select several at once.",
    live_materials_added: "{n} materials added",
    live_materials_locked: "Materials for this session are available only to students who attended.",
    live_add_link: "Or paste a link (YouTube, Drive, etc.)",
    live_no_materials: "This session has no materials yet",
    live_material_added: "Material added",
    live_material_type_image: "Image",
    live_material_type_video: "Video",
    live_material_type_link: "Link",
    live_open: "Open",
    live_session_materials: "Session material",
    live_download: "Download",
    menu: "Menu",
    payment_cancelled: "Annulled (invoice keeps its number)",
    invoice_number_short: "Invoice #",
    cycle_mismatch_warning: "The system counts",
    cycle_mismatch_dates: "Records outside the cycle calendar",
    cycle_mismatch_extra: "extra/rescheduled session",
    cycle_mismatch_offschedule: "day outside the group schedule",
    cycle_mismatch_delete_confirm: "Delete the attendance record of",
    live_tagline: "Your Spanish travels with you",
    live_view_week: "Week",
    live_view_month: "Month",
    live_timezone: "Costa Rica time",
    live_see_next_week: "See next week",
    live_see_next_month: "See next month",
    live_pick_teacher: "Select a teacher",
    live_no_level_set: "You don't have a level assigned yet — showing all available sessions.",
    live_no_sessions: "No sessions available right now",
    live_no_reservations: "You have no reservations yet",
    live_reserve: "Reserve",
    live_join_waitlist: "Join waitlist",
    live_cancel_reservation: "Cancel reservation",
    live_booked_ok: "Reservation confirmed!",
    live_waitlisted_ok: "You are on the waitlist",
    live_unbooked_ok: "Reservation cancelled",
    live_you_are_waitlisted: "You are on the waitlist. We'll let you know if a seat opens up.",
    live_join: "Join class",
    live_stats: "Analytics",
    live_stat_sessions: "Sessions",
    live_stat_bookings: "Reservations",
    live_stat_attended: "Attended",
    live_stat_rate: "Attendance %",
    live_top_sessions: "Most reserved sessions",
    live_demand_by_level: "Demand by level",
    live_demand_by_hour: "Demand by hour",
    live_top_students: "Most active students",
    live_attended_short: "attended",
    live_type_conversation: "Conversation",
    live_type_grammar: "Grammar",
    live_type_pronunciation: "Pronunciation",
    live_type_five_finger: "Five-Finger System",
    live_type_costa_rican_spanish: "Costa Rican Spanish",
    live_type_everyday_spanish: "Everyday Spanish",
    live_type_listening: "Listening practice",
    live_type_qa: "Q&A with a teacher",
    live_type_other: "Other",
    spanish_level: "Spanish level",
    // ----- Automation (Scheduled Newsletters + Follow-up Rules) -----
    automation_page_title: "Lead automation",
    automation_page_subtitle: "Schedule campaigns and create follow-up rules that work for you.",
    automation_tab_scheduled: "Scheduled sends",
    automation_tab_rules: "Follow-up rules",
    automation_tab_settings: "Settings",
    // Tracking settings
    tracking_settings_title: "Email tracking (Resend webhooks)",
    tracking_settings_desc: "Automatically log when each email is opened, clicked or bounces.",
    tracking_settings_active: "Active",
    tracking_settings_not_configured: "Not configured",
    tracking_settings_steps_title: "How to activate:",
    tracking_settings_step1: "Go to",
    tracking_settings_step2: "Create a webhook with this URL:",
    tracking_settings_step3: "Enable the 6 events: sent, delivered, opened, clicked, bounced, complained.",
    tracking_settings_step4: "Copy the Signing Secret (whsec_...) and paste it below.",
    tracking_settings_secret_label: "Resend Signing Secret",
    tracking_settings_save: "Save",
    tracking_settings_saved: "Secret saved. Tracking is now active.",
    tracking_settings_save_error: "Save failed",
    tracking_settings_invalid_secret: "Secret must start with \"whsec_\"",
    tracking_settings_url_copied: "URL copied",
    tracking_settings_currently: "Currently configured from {source}. Ends in:",
    tracking_settings_source_env: "environment variable",
    tracking_settings_source_db: "database",
    maintenance_title: "Maintenance",
    orphans_title: "Clean orphan invoices",
    orphans_desc: "Delete pending invoices whose program was already removed (useful to clean test data).",
    orphans_run: "Clean now",
    orphans_removed: "{n} orphan invoice(s) removed",
    orphans_none: "No orphan invoices — all clean",
    orphans_error: "Cleanup failed",
    orphans_last: "Last cleanup",
    automation_scheduled_title: "Scheduled newsletters",
    automation_scheduled_desc: "Queue an email to a specific segment of leads. It will fire automatically at the chosen date/time.",
    automation_scheduled_empty: "No scheduled sends yet. Create one to get started.",
    automation_new_scheduled: "Schedule send",
    automation_new_scheduled_desc: "Write your email and choose who receives it. The system dispatches it automatically at the scheduled time.",
    automation_label: "Internal label (optional)",
    automation_label_placeholder: "e.g. Intro Class reminder — July",
    automation_subject: "Subject",
    automation_body: "Email body (HTML)",
    automation_vars_hint: "Available variables: {name} · {first_name} · {last_name} · {full_name} · {email} · {group} · {campus}",
    automation_when: "Send date & time",
    automation_campus: "Campus",
    automation_status_filter: "Filter by classification (optional)",
    automation_status_filter_hint: "Leave empty to email ALL leads with an address. Pick one or more to segment.",
    automation_exclude_converted: "Exclude leads already converted to students",
    automation_preview_recipients: "Preview recipients",
    automation_preview_total: "Recipients: {n}",
    automation_preview_error: "Preview failed",
    automation_preview_ok: "{n} lead(s) match this rule right now",
    automation_required_fields: "Fill subject, body and date",
    automation_must_be_future: "The date must be in the future",
    automation_scheduled_ok: "Scheduled successfully",
    automation_scheduled_error: "Failed to schedule",
    automation_schedule_button: "Schedule",
    automation_cancel_title: "Cancel scheduled send?",
    automation_cancel_desc: "It will not fire. You can create another one later.",
    automation_cancel_confirm: "Cancel send",
    automation_cancelled_ok: "Cancelled",
    automation_cancel_error: "Could not cancel",
    automation_delete_record: "Remove from list",
    automation_delete_record_title: "Remove this send from history?",
    automation_delete_record_desc: "The email was already sent (or cancelled). This only removes the record from the list to keep it clean. Already-sent emails are not affected.",
    automation_sn_status_pending: "Scheduled",
    automation_sn_status_sending: "Sending…",
    automation_sn_status_sent: "Sent",
    automation_sn_status_cancelled: "Cancelled",
    automation_sn_status_failed: "Failed",
    // Rules
    automation_rules_title: "Automatic follow-up rules",
    automation_rules_desc: "When a lead sits in a classification for X days without moving, send a follow-up email.",
    automation_rules_empty: "No rules yet.",
    automation_rules_example: "e.g. \"Introductory Class +3 days no reply → soft reminder\"",
    automation_new_rule: "New rule",
    automation_edit_rule: "Edit rule",
    automation_rule_dialog_desc: "Define when the follow-up fires and what to send.",
    automation_rule_name: "Name",
    automation_rule_name_placeholder: "e.g. Follow-up 2 days — Contacted",
    automation_rule_source_status: "Source classification",
    automation_rule_days_after: "Days without activity",
    automation_rule_summary: "After {days} day(s) in \"{status}\" with no activity → send email",
    automation_rule_stats: "Sent: {sent} · Last run: {last}",
    automation_active: "Active",
    automation_paused: "Paused",
    automation_edit: "Edit",
    automation_save_rule: "Save rule",
    automation_rule_saved: "Rule saved",
    automation_rule_save_error: "Error saving rule",
    automation_rule_deleted: "Rule deleted",
    automation_rule_delete_error: "Delete failed",
    automation_delete_rule: "Delete this rule?",
    automation_delete_rule_desc: "No new emails will be sent by this rule. Already-sent ones stay.",
    automation_delete: "Delete",
    automation_load_error: "Load error",
    // ----- Distribution Kit -----
    distribution_title: "Content Distribution",
    distribution_subtitle: "Turn your latest blog post into channel-ready copy — powered by AI.",
    distribution_new_kit: "New AI kit",
    distribution_empty_title: "No kits yet",
    distribution_empty_body: "Enter your blog post title and a brief summary — AI generates all copy for Facebook, Instagram, LinkedIn, Twitter, email and Reels, ready to copy and paste.",
    distribution_new_kit_title: "New distribution kit",
    distribution_new_kit_desc: "Tell the AI what your blog post is about. It'll handle the rest.",
    distribution_form_title: "Blog post title",
    distribution_form_url: "Blog post URL (optional)",
    distribution_form_summary: "Content summary",
    distribution_form_summary_placeholder: "In 2-3 sentences, explain what the post is about and what the reader will learn. Be specific — the AI uses this to generate all copy.",
    distribution_form_campus: "Campus",
    distribution_form_tone: "Tone",
    distribution_form_language: "Language",
    distribution_tone_warm: "Warm",
    distribution_tone_pro: "Professional",
    distribution_tone_fun: "Fun",
    distribution_generation_notice: "Generation takes ~1 min. You can close this window and come back — the kit updates itself.",
    distribution_generate: "Generate with AI",
    distribution_form_required: "Title and summary are required",
    distribution_kit_queued: "Kit queued. AI is working in the background…",
    distribution_load_error: "Error loading kits",
    distribution_delete_confirm: "Delete this kit?",
    distribution_pending_title: "Generating with AI…",
    distribution_pending_body: "This takes about a minute. The window auto-refreshes when ready.",
    distribution_failed_title: "Generation failed",
    distribution_failed_body: "Try again or refine the summary.",
    distribution_status_pending: "Generating",
    distribution_status_ready: "Ready",
    distribution_status_failed: "Failed",
    distribution_channels_published: "published",
    distribution_fb_variants: "Facebook — 5 variants",
    distribution_instagram: "Instagram",
    distribution_linkedin: "LinkedIn",
    distribution_twitter: "Twitter / X — Thread",
    distribution_email: "Newsletter (Email)",
    distribution_reels: "Reels / Shorts — 3 ideas",
    distribution_reels_hook: "Idea",
    distribution_email_subject: "Subject",
    distribution_email_body: "Body (HTML)",
    distribution_copy_full_thread: "Copy full thread",
    distribution_copy_subject: "Copy subject",
    distribution_copy_body: "Copy body",
    distribution_mark_published: "Mark as published",
    distribution_marked_published: "Published",
    distribution_copied: "Copied to clipboard",
    // ----- Newsletter dispatch -----
    newsletter_send_button: "Send newsletter",
    newsletter_sending: "Sending…",
    newsletter_dialog_title: "Send newsletter",
    newsletter_dialog_desc: "Send this email to a segment of leads and/or students. {name} is auto-personalized for each recipient.",
    newsletter_audience: "Send to whom?",
    newsletter_audience_leads: "Leads only (prospects)",
    newsletter_audience_students: "Active students only",
    newsletter_audience_both: "Leads + students",
    newsletter_lead_statuses: "Filter leads by status",
    newsletter_campus_filter: "Campus filter",
    newsletter_preview_btn: "Preview recipients",
    newsletter_preview_total: "{count} eligible recipients",
    newsletter_test_email_label: "Send test to one email first (recommended)",
    newsletter_send_test: "Send test",
    newsletter_test_hint: "Send only to this address to check how it looks before the mass send.",
    newsletter_test_email_required: "Enter an email for the test",
    newsletter_test_queued: "Test email sent.",
    newsletter_queued: "Newsletter queued. Emails are being sent in the background.",
    newsletter_confirm_send: "Send the newsletter to {count} recipients? This CANNOT be undone.",
    newsletter_send_to_count: "Send to {count}",
    newsletter_last_sent: "Last sent: {sent} emails · {when}",
    newsletter_failed: "failed",
    more: "more",
    lead_templates_title: "Email Templates by Campus",
    lead_templates_subtitle: "Customize the automatic email sent when a lead completes the form.",
    lead_status_new: "New",
    lead_status_introductory_class: "Introductory Class",
    lead_status_introductory_attended: "Attended",
    lead_status_introductory_no_show: "No-show",
    lead_status_contacted: "Contacted",
    lead_column_new: "New",
    lead_column_introductory_class: "New",
    lead_column_introductory_attended: "Attended",
    lead_column_introductory_no_show: "No-show",
    lead_column_contacted: "Contacted",
    lead_column_interview_meeting: "Interview",
    lead_column_send_info: "Send Info",
    lead_column_info_ready: "Info Ready",
    lead_column_enrolled: "Registered",
    lead_column_later: "Later",
    lead_column_not_interested: "Not interested",
    lead_column_archived: "Archived",
    lead_tab_pipeline: "Pipeline",
    lead_tab_introductory: "Introductory",
    lead_tab_archived: "Archived",
    lead_archived_active: "Active",
    lead_archived_inactive: "Inactive",
    lead_archived_later: "Later",
    lead_archived_not_interested: "Not interested",
    lead_status_interview_meeting: "Interview",
    lead_status_send_info: "Send Info",
    lead_status_info_ready: "Info Ready",
    lead_status_enrolled: "Registered",
    lead_status_later: "Later",
    lead_status_not_interested: "Not interested",
    lead_campus_general: "General",
    lead_campus_santa_ana: "Santa Ana",
    lead_campus_atenas: "Atenas",
    lead_campus_grecia: "Grecia",
    lead_campus_online: "Online",
    lead_filter_all_campuses: "All campuses",
    lead_no_leads_column: "No leads",
    lead_add_note: "Add note",
    lead_note_placeholder: "Write a note, e.g.: called them on WhatsApp…",
    lead_save_note: "Save note",
    lead_timeline: "Timeline",
    lead_status: "Status",
    lead_source_url: "Source (URL)",
    lead_program: "Program of interest",
    lead_referred: "How did they hear about us?",
    lead_message: "Message",
    lead_form_answers: "Form answers",
    lead_email_history: "Email history",
    lead_email_bounced_title: "This email bounced",
    lead_email_complained_title: "This recipient marked our emails as spam",
    lead_email_invalid_desc: "No more auto-responses, newsletters or follow-ups will be sent until you update the email.",
    // Email status pills
    email_status_sent: "Sent",
    email_status_delivered: "Delivered",
    email_status_opened: "Opened",
    email_status_clicked: "Clicked",
    email_status_bounced: "Bounced",
    email_status_complained: "Spam",
    email_status_failed: "Failed",
    email_bounce_generic: "Invalid email",
    email_campaign_auto_response: "Auto response",
    email_campaign_scheduled_newsletter: "Scheduled newsletter",
    email_campaign_followup_rule: "Auto follow-up",
    email_campaign_distribution_newsletter: "Newsletter (Distribution Kit)",
    email_campaign_manual_lead_email: "Manual email",
    email_campaign_unknown: "—",
    // Stats modal
    email_stats_title: "Delivery details",
    email_stats_desc: "Real-time status of each email from Resend.",
    email_stats_view_button: "View details",
    email_stats_total: "Total",
    email_stats_delivered: "Delivered",
    email_stats_opened: "Opened",
    email_stats_bounced: "Bounced",
    email_stats_recipient: "Recipient",
    email_stats_status: "Status",
    email_stats_sent_at: "Sent",
    email_stats_details: "Detail",
    email_stats_empty: "No data yet. Events show up as soon as Resend notifies us.",
    lead_created: "Created",
    lead_updated: "Updated",
    lead_delete: "Delete lead",
    lead_delete_confirm: "Are you sure you want to delete this lead? This action is permanent.",
    lead_open_email: "Send email",
    lead_open_whatsapp: "Open WhatsApp",
    lead_no_program: "No program selected",
    lead_days_ago: "{n}d ago",
    lead_hours_ago: "{n}h ago",
    lead_just_now: "just now",
    lead_open_detail: "View detail",
    lead_search_placeholder: "Search by name, email or program…",
    template_edit: "Edit template",
    template_reset: "Reset to original",
    template_reset_confirm: "Reset {campus} template to the original version? You'll lose your changes.",
    template_subject: "Subject",
    template_body: "Email body (HTML)",
    template_preview: "Preview",
    template_save: "Save template",
    template_cancel: "Cancel",
    template_saved: "Template saved",
    template_reset_done: "Template reset",
    template_variables_help: "Available variables",
    template_variables_note: "You can use these variables in subject and body: {name} = first name (personal greeting), {last_name}, {full_name} = first + last name, {email}, {group}, {campus}, {whatsapp}, {message}, {referred}",
    template_is_default: "Not customized (using original template)",
    template_is_custom: "Customized",
    lead_stats_total: "Total",
    lead_convert_to_student: "Convert to student",
    lead_convert_coming_soon: "Convert-to-student will be available in the next phase.",
    lead_notes: "Internal notes",
    lead_notes_placeholder: "Notes visible only to the team…",
    lead_notes_saved: "Internal note saved",
    lead_event_created: "Lead created",
    lead_event_auto_response_sent: "Auto-response sent",
    lead_event_status_changed: "Status changed",
    lead_event_notes_updated: "Notes updated",
    lead_event_assigned: "Assigned",
    lead_event_note: "Note",
    lead_event_call: "Call",
    lead_event_email_sent: "Email sent",
    lead_event_whatsapp_sent: "WhatsApp sent",
    lead_pipeline_moved: "Lead moved to {status}",
    template_editor_bold: "Bold",
    template_editor_italic: "Italic",
    template_editor_underline: "Underline",
    template_editor_h1: "Heading 1",
    template_editor_h2: "Heading 2",
    template_editor_h3: "Heading 3",
    template_editor_bullet: "Bullet list",
    template_editor_ordered: "Ordered list",
    template_editor_link: "Insert link",
    template_editor_image: "Insert image",
    template_editor_left: "Align left",
    template_editor_center: "Align center",
    template_editor_right: "Align right",
    template_editor_justify: "Justify",
    template_editor_link_prompt: "Link URL:",
    template_editor_image_prompt: "Image URL:",
    template_body_placeholder: "Write the email body here with the program details…",
    template_new: "New template",
    template_add_program: "Add program template",
    template_program_label: "Program (optional)",
    template_program_placeholder: "e.g. Private Classes in person - 8hrs package",
    template_program_hint: "Pick a program from the dropdown (▼) to avoid typos. Leave empty to make this the campus-wide fallback template. To add new programs, use \"Manage programs\" on the campus.",
    template_campus_fallback: "Campus fallback template",
    template_campus_fallback_hint: "Used when no specific program template exists.",
    template_program_specific: "Program-specific template",
    template_drag_hint: "Drag to reorder by importance",
    template_program_count: "programs configured",
    template_no_program_templates: "No program-specific templates in {campus} yet. The campus fallback will be used.",
    template_delete: "Delete template",
    template_delete_confirm: "Delete this template? Future leads will use the campus fallback template.",
    template_resolution_note: "The program-specific template is used if it exists. Otherwise the campus fallback is used. Otherwise the original template is used.",
    group_no_meet_link: "No link configured",
    group_no_meet_link_hint: "This group has no Zoom or Google Meet link. Edit it to add one before the next class.",
    template_duplicate: "Duplicate",
    template_duplicate_title: "Duplicate template",
    template_duplicate_hint: "A copy will be created with the same content. You can change it before saving.",
    template_bulk_seed: "Bulk seed programs",
    // ----- Programs Manager -----
    programs_manager_button: "Manage programs",
    programs_manager_button_hint: "Manage this campus's program list — prevents typos when creating templates",
    programs_manager_title: "Programs for {campus}",
    programs_manager_desc: "This is the master list of programs for this campus. Its names are used as dropdown options when creating email templates.",
    programs_manager_hint: "IMPORTANT: The names you add here must EXACTLY match the <select> options in your Contact Form 7 form on WordPress. Use the \"Copy list\" button to paste them identically.",
    program_add_placeholder: "e.g. Classes for Beginners A1, Mon/Wed at 8:15 am",
    program_added: "Program added",
    program_renamed: "Program renamed (linked template updated)",
    program_deleted: "Pro",
    program_deleted: "Program deleted",
    program_delete_confirm: "Delete the program \"{name}\"? The linked template is NOT removed (it becomes orphan).",
    program_copy_list: "Copy names only",
    program_copy_cf7: "Copy CF7 shortcode",
    program_list_copied: "Names copied. Paste them as <select> options in your Contact Form 7.",
    program_cf7_copied: "CF7 shortcode copied. Replace your current [select* menu-XXX ...] with this.",
    programs_empty_state: "No programs configured for this campus yet.",
    // ----- Duplicate lead detection -----
    lead_duplicates_title: "⚠️ This contact reached out before ({count})",
    lead_duplicates_desc: "We found other leads with the same email or WhatsApp. Review them before reaching out again.",
    lead_duplicates_more: "more…",
    // ----- Source stats pie chart -----
    source_stats_title: "Leads by channel",
    source_stats_subtitle: "{total} leads in the last {days} days",
    source_stats_empty: "No leads yet in this period.",
    done: "Done",
    add: "Add",
    template_bulk_seed_title: "Bulk-create empty program templates",
    template_bulk_seed_desc: "Paste program names (one per line). An empty template will be created for each one using the same subject and body as the campus fallback.",
    template_bulk_seed_placeholder: "Classes for Beginners A1, Mon/Wed at 8:15 am\nClasses for Intermediates, Mon/Wed at 10:15 am\nPrivate Classes in person - 8hrs package\nPrivate Classes in person - 12hrs package",
    template_bulk_seed_confirm: "Create empty templates",
    template_bulk_seed_done: "Created {n} new templates",
    template_bulk_seed_none: "No new programs to add",
    lead_convert: "Convert to student",
    lead_edit: "Edit",
    lead_edit_title: "Edit lead information",
    lead_edit_desc: "Modify the lead's contact info. Correcting a bounced email will reactivate them in automated sends.",
    lead_edit_name: "First name",
    lead_edit_last_name: "Last name",
    lead_edit_email: "Email",
    lead_edit_whatsapp: "WhatsApp",
    lead_edit_campus: "Campus",
    lead_edit_group: "Program / Group",
    lead_edit_referred: "Who referred us?",
    lead_edit_save: "Save changes",
    lead_edit_saved: "Changes saved",
    lead_edit_error: "Error saving",
    lead_edit_name_required: "Name is required",
    lead_edit_email_required: "Email is required",
    lead_convert_title: "Convert lead to student",
    lead_convert_desc: "Creates the student user and enrollment. The lead will be marked as enrolled automatically.",
    lead_convert_desc_v2: "Creates the student account with the lead's data. Group enrollment and payment are configured later from Students.",
    lead_convert_confirm: "Create account and send email",
    lead_convert_summary: "Account will be created with:",
    lead_convert_next_steps_title: "What happens next:",
    lead_convert_step1: "We send a magic-link email. On login, the student completes their profile (country, photo) and accepts the policies.",
    lead_convert_step2: "They'll see a link to the student manual to consult any time.",
    lead_convert_step3: "You enroll them in a group/program later from Students → Edit → Add enrollment.",
    lead_convert_group: "Group or private class",
    lead_convert_group_placeholder: "Select a group",
    lead_convert_start_date: "Start date",
    lead_convert_amount: "Cycle amount (USD, optional)",
    lead_convert_classes: "Classes included (optional)",
    lead_convert_paid_on_start: "Mark as paid from the start",
    lead_convert_send_welcome: "Send welcome email",
    lead_convert_success: "Student created and lead marked as enrolled",
    lead_convert_error: "Error converting",
    lead_converted_at: "Converted on {date}",
    lead_converted_badge: "Converted",
    lead_convert_missing_group: "You must pick a group",
    // Manual lead + Sources + Chart
    manual_lead_add: "New lead",
    manual_lead_title: "Add lead manually",
    manual_lead_desc: "Log a prospect that reached you via WhatsApp, phone, referral, or any channel outside your website.",
    manual_lead_name: "First name",
    manual_lead_last_name: "Last name",
    manual_lead_email: "Email (optional)",
    manual_lead_whatsapp: "WhatsApp",
    manual_lead_initial_note: "Initial note (optional)",
    manual_lead_initial_note_placeholder: "e.g. Messaged asking about A1 prices — has time in the mornings.",
    manual_lead_send_auto: "Send welcome email",
    manual_lead_template: "Email that will be sent",
    manual_lead_template_auto: "Automatic (by campus and program)",
    manual_lead_template_default: "default",
    manual_lead_template_general: "General",
    manual_lead_template_hint: "Picking an email from the list sends that one and overrides the automatic choice.",
    manual_lead_create: "Create lead",
    manual_lead_created: "Lead created",
    manual_lead_error: "Error creating the lead",
    manual_lead_missing_name: "Name is required",
    manual_lead_missing_contact: "At least WhatsApp or email is required",
    lead_source_wordpress_cf7: "Website",
    lead_source_whatsapp: "WhatsApp",
    lead_source_phone: "Phone",
    lead_source_referral: "Referral",
    lead_source_instagram: "Instagram",
    lead_source_manual: "Manual",
    lead_filter_all_sources: "All channels",
    lead_campus: "Campus",
    conversion_chart_title: "Monthly conversion rate",
    conversion_chart_subtitle: "Created leads vs. enrolled students over the last 6 months",
    conversion_chart_created: "Created",
    conversion_chart_enrolled: "Enrolled",
    conversion_chart_active_now: "active today",
    conversion_chart_current_month_note: "• The current month is still in progress",
    conversion_chart_rate: "Conversion",
    conversion_chart_no_data: "Not enough leads yet to compute the conversion rate.",
    editor_font_size: "Font size",
    editor_font_size_default: "Size",
    editor_text_color: "Text color",
    editor_highlight_color: "Highlight color",
    editor_indent: "Increase indent",
    editor_outdent: "Decrease indent",
    editor_horizontal_rule: "Horizontal rule",
    editor_clear_format: "Clear formatting",
    editor_live_preview: "Live preview",
    editor_tab_visual: "Visual",
    editor_tab_html: "HTML",
  },
};

const I18nContext = createContext({ t: (k) => k, lang: "es", setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    // Default to English for everyone. If the user explicitly picked a
    // language before (stored in localStorage via the toggle), honor that.
    const stored = localStorage.getItem("lang");
    if (stored === "es" || stored === "en") return stored;
    return "en";
  });
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key, vars) => {
    const raw = dict[lang]?.[key] ?? dict.es[key] ?? key;
    if (!vars) return raw;
    return Object.keys(vars).reduce(
      (acc, k) => acc.replaceAll(`{${k}}`, String(vars[k])),
      raw,
    );
  };
  const setLang = (l) => setLangState(l);
  return <I18nContext.Provider value={{ t, lang, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
